/* eslint-disable react/no-this-in-sfc */
/* eslint-disable max-classes-per-file */
/* eslint-disable jsx-a11y/media-has-caption */

import React, {
  useState,
  useRef,
  useMemo,
  useCallback,
  useEffect,
  SetStateAction,
} from "react";
// import "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component

import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
// import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
// import "ag-grid-community/styles/ag-theme-alpine-dark.css"; // Optional theme CSS
import {
  // CellClickedEvent,
  ValueFormatterParams,
  GetRowIdParams,
  ValueGetterParams,
  IDetailCellRendererParams,
  ICellRendererParams,
  RowNode,
  FilterChangedEvent,
} from "ag-grid-community";
import { LicenseManager } from "ag-grid-enterprise";

import "./styles/QueueLeaderboard.scss";
import {
  createTheme,
  makeStyles,
  Typography,
  Button,
  TextField,
  Popover,
  Grid,
  Checkbox,
  Toolbar,
  IconButton,
  Collapse,
  Menu,
  MenuItem,
  ThemeProvider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Modal,
  Box,
  Fade,
  Tooltip,
  // FormControlLabel,
} from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  RadioButtonUnchecked,
  CheckCircle,
  AccessTime,
  Event,
  ExpandLess,
  ExpandMore,
  UnfoldMore,
  UnfoldLess,
  GetApp,
  TextFormat,
  Refresh,
  Chat,
  Close,
  Phone,
  CheckCircleRounded,
  KeyboardArrowDown,
  GetAppSharp,
  SentimentVerySatisfied,
  SentimentSatisfiedAlt,
  SentimentSatisfied,
  SentimentDissatisfied,
  SentimentVeryDissatisfied,
} from "@material-ui/icons";
import hash from "object-hash";
import { Map as ImmutableMap } from "immutable";
import { MuiPickersOverrides } from "@material-ui/pickers/typings/overrides";
import { ColDef, RowDataUpdatedEvent } from "@ag-grid-community/core";
import { TranscriptIcon, TranscriptNone } from "./icons/transcriptIcons";
import transcriptDark from "./icons/transcript/Transcript_D.png";
import transcriptLight from "./icons/transcript/Transcript_L.png";
import noTranscriptDark from "./icons/transcript/NoTranscript_D.png";
import noTranscriptLight from "./icons/transcript/NoTranscript_L.png";
import { VMOnly } from "./Portal";

LicenseManager.setLicenseKey(
  "CompanyName=Resource Software International Ltd,LicensedApplication=Shadow,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-032296,SupportServicesEnd=20_October_2023_[v2]_MTY5Nzc1NjQwMDAwMA==0c008d8dba7b9997038f1e1fee335d4a"
);

function dateFormatter(params: ValueFormatterParams) {
  return params.value?.toLocaleString();
}

const callbackCalls = new Map<string, CallbackState>();

const useStyles: any = makeStyles((theme) => ({
  // style for light
  menuPaper: {},
  menuItem: {},
  checkboxDate: {
    "&:hover": {
      backgroundColor: "transparent !important",
    },
  },
  popover: {},
  dateRange: {
    "& .MuiInputBase-input": {
      cursor: "pointer !important",
    },
  },
  select: {
    color: "#90C8E2",
    fontSize: "0.75rem",
  },
  underline: {
    borderBottomColor: "#A52A2A",
  },
  dateInput: {},
  calendarPopover: {},
  timePopover: {},
  tab: {
    textTransform: "capitalize",
    color: "white",
    "&:hover": {
      backgroundColor: "inherit",
      color: "#04587E",
    },
  },
  dialog: {},
  typography: {
    color: "black",
  },
}));

const useDarkStyles = makeStyles((theme) => ({
  menuPaper: { backgroundColor: "#282828" },
  menuItem: {
    color: "white",
  },
  checkboxDate: {
    "&:hover": {
      backgroundColor: "transparent !important",
    },
  },
  popover: {
    backgroundColor: "rgb(40, 40, 40) !important",
    color: "white",
  },
  dateRange: {
    "& .MuiInputBase-input": {
      cursor: "pointer !important",
    },
  },
  select: {
    color: "#D3D3D3",
    fontSize: "0.75rem",
  },
  underline: {
    borderBottomColor: "#A52A2A",
  },
  dateInput: {
    // '& .MuiPopover-root': {
    //   backgroundColor: 'green !important',
    // },
    // '& .MuiInputBase-input': {
    //   color: '#fff', // Text color
    // },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#fff8", // Semi-transparent underline
    },
    "& .MuiInput-underline:hover:before": {
      borderBottomColor: "#fff", // Solid underline on hover
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#fff", // Solid underline on focus
    },
  },
  timePopover: {
    "& .MuiPaper-root": {
      "& .MuiPickersToolbar-toolbar": {
        backgroundColor: "gray",
      },
      backgroundColor: "#282828",
      "& .MuiPickersClock-clock": {
        "& .MuiTypography-root": {
          color: "white",
        },
      },
      "& .MuiPickersClock-pin": {
        backgroundColor: "gray",
      },
      "& .MuiPickersClockPointer-pointer": {
        backgroundColor: "gray",
      },
    },
  },
  calendarPopover: {
    "& .MuiPaper-root": {
      "& .MuiPickersToolbar-toolbar": {
        backgroundColor: "gray",
      },
      backgroundColor: "#282828",
      "& .MuiPickersBasePicker-pickerView": {
        "& .MuiIconButton-root:hover": {
          backgroundColor: "gray",
        },
      },
      "& .MuiPickersCalendarHeader-switchHeader": {
        "& .MuiTypography-root": {
          color: "white",
        },
        "& .MuiIconButton-root": {
          backgroundColor: "#282828",
        },
        "& .MuiSvgIcon-root": {
          color: "white",
        },
      },
      "& .MuiPickersCalendarHeader-daysHeader": {
        "& .MuiTypography-root": {
          color: "gray",
        },
      },
      "& .MuiPickersCalendar-transitionContainer": {
        "& .MuiTypography-root": {
          color: "white",
        },
      },
    },
  },
  tab: {
    textTransform: "capitalize",
    color: "white",
    "&:hover": {
      backgroundColor: "inherit",
      color: "#808080",
    },
  },
  dialog: {
    backgroundColor: "rgb(40, 40, 40) !important",
    color: "white",
  },
  typography: {
    color: "white",
  },
}));

// https://github.com/mui/material-ui-pickers/issues/1414
type OverridesNameToClassKey = {
  [P in keyof Required<MuiPickersOverrides>]: keyof MuiPickersOverrides[P];
};

declare module "@material-ui/core/styles/overrides" {
  export interface ComponentNameToClassKey extends OverridesNameToClassKey {}
}

const myTheme = createTheme({
  palette: {
    primary: {
      main: "#0684BD",
    },
    secondary: {
      main: "#ff8c00",
    },
  },
});

const darkTheme = createTheme({
  palette: {
    primary: {
      main: "#D3D3D3",
    },
    secondary: {
      main: "#ff8c00",
    },
  },
  overrides: {
    MuiPickersDay: {
      daySelected: {
        backgroundColor: "gray",
      },
    },
    MuiPickersYear: {
      root: { color: "gray" },
      yearSelected: {
        color: "white",
      },
    },
    MuiPickersClockPointer: {
      thumb: {
        backgroundColor: "white",
        border: "14px solid gray",
      },
      noPoint: {
        backgroundColor: "gray",
      },
    },
  },
});

const notifStyle = {
  backgroundColor: "red",
  width: 15,
  height: 15,
  borderRadius: "50%",
  position: "absolute",
  top: "-5px",
  right: "-5px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "white",
};

let start: Date | null = new Date();
start.setHours(0, 0, 0, 0);
let end: Date | null;

interface CallUser {
  ringDuration: number;
  index: string;
  talkDuration: number;
  callId: string;
  userId: string;
  direction: string;
  duration: number;
  state: string;
  recordingId: string;
  siteId: string;
  toPhoneNumber: string;
  fromPhoneNumber: string;
  holdTimeInbound: number;
  faxSendTime: number;
  vmGreetingTime: number;
  vmDurationTime: number;
  rcVideoTime: number;
  hangupTime: number;
  fromName: string;
  partyId: string;
  version: number;
  insights?: {
    disposition?: {
      time: string;
      accountId: string;
      code: string;
      codeCallId: string;
      codeDescription: string;
      codeNumber: string;
      extensionId: string;
      id: string;
      message: string;
      prefix: string;
      telephonySessionId: string;
      custom?: {
        notes?: string;
        accountCode: string;
        dispositionCode: string;
      };
    };
  };
}

interface CallEvent {
  body: {
    eventTime: string;
    telephonySessionId: string;
    origin: {
      type: string;
    };
    parties: [
      {
        id: string;
        extensionId: string;
        direction: string;
        status: {
          code: string;
          reason?: string;
          message?: string;
          custom?: {
            notes?: string;
            accountCode: string;
            dispositionCode: string;
          };
        };
        from?: {
          phoneNumber: string;
          name?: string;
          extensionNumber: string;
          extensionId?: string;
        };
        to?: {
          phoneNumber: string;
          name?: string;
          extensionNumber: string;
          extensionId?: string;
        };
        queueCall?: boolean;
        queue?: string;
        user?: string;
      }
    ];
  };
}

interface CallbackState {
  userId: string;
  index: string;
  callId: string;
  fromPhoneNumber: string;
  fromName?: string;
  toPhoneNumber: string;
  sequence: number;
  duration: number;
  vmAbandonedTime?: number;
  vmDurationTime?: number;
  vmGreetingTime?: number;
  transcript?: string;
  statusCode?: number;
  callback?: Array<string>;
}

interface UserState {
  userId: string;
  state: "IDLE" | "ON CALL" | "ON QUEUE CALL" | "RINGING";
  time: string;
  queueId?: string;
  from?: {
    phoneNumber?: string;
    extensionId?: string;
    deviceId?: string;
    name?: string;
  };
  to?: {
    phoneNumber?: string;
    extensionId?: string;
    deviceId?: string;
    name?: string;
  };
  direction?: string;
  sequence: number;
}

interface QueueCallState {
  userId?: string;
  state:
    | "TALKING"
    | "HOLDING"
    | "TRANSFERRED"
    | "COMPLETE"
    | "RINGING"
    | "MISSED";
  time: string;
  callId: string;
  queueId: string;
  from:
    | {
        phoneNumber: string;
        name: string;
      }
    | Array<{
        phoneNumber: string;
        name: string;
      }>;
  to: {
    phoneNumber: string;
  };
  sequence: number;
  partyId: string;
}
interface Historical {
  queue: Array<{
    users: Array<{
      id: string;
      acceptCurrentQueueCalls: boolean;
    }>;
    extensionNumber: string;
    name: string;
    id: string;
    ivrId?: string;
  }>;
  user: Array<{
    id: string;
    display: string;
    lastName: string;
    firstName: string;
    extensionNumber: string;
    lastDndStatus: string;
    messageTimestamp: string;
    signedUrl?: string;
  }>;
  currentTime: number;
  organization: Array<{}>;
  table: Array<{}>;
  code: Array<{}>;
  rule: Array<{}>;
  ivr: Array<{
    extensionNumber: string;
    id: string;
    name: string;
    ttl: number;
  }>;
  vmOnly: Array<VMOnly>;
}

interface UserPresenceEvent {
  id: string;
  display: string;
  lastDndStatus: string;
  messageTimestamp: string;
  connected?: boolean;
  glip?: boolean;
}

interface QueuePresenceEvent {
  userId: string;
  id: string;
  acceptCurrentQueueCalls: boolean;
}

interface Delta {
  [key: string]: any;
  userId: string;
  time?: string;
  queueId?: string; // user record associated with a queue

  count?: number;
  duration?: number;
  maxDuration?: number;

  ringCountInbound?: number;
  ringTimeInbound?: number;
  maxRingTimeInbound?: number;
  ringCountOutbound?: number;
  ringTimeOutbound?: number;
  maxRingTimeOutbound?: number;

  talkCountInbound?: number;
  talkTimeInbound?: number;
  maxTalkTimeInbound?: number;
  talkCountOutbound?: number;
  talkTimeOutbound?: number;
  maxTalkTimeOutbound?: number;

  faxCount?: number;
  faxSendTime?: number;

  holdCountInbound?: number;
  holdTimeInbound?: number;
  maxHoldTimeInbound?: number;
  holdCountOutbound?: number;
  holdTimeOutbound?: number;
  maxHoldTimeOutbound?: number;

  vmAbandonedCount?: number;
  vmLeftCount?: number;
  vmDurationTime?: number;
  vmGreetingTime?: number;
  vmCount?: number;

  rcVideoCount?: number;

  hangupCount?: number;

  firstCall?: string;
  lastCall?: string;

  // queue stuff
  missedCount?: number;
  abandonedCount?: number;
  answeredCount?: number;
  missedTime?: number;
  abandonedTime?: number;
  answeredTime?: number;
  voicemailCount?: number;
  voicemailTime?: number;

  // internal counts
  ringCountInternal?: number;
  talkCountInternal?: number; //
  talkTimeInternal?: number;
  maxRingTimeInternal?: number;
  maxTalkTimeInternal?: number;
}

interface Summary {
  now: string;
  userStates: Array<UserState>;
  users: Array<Delta>;
  agents: Array<Delta>;
  fakeEvents: Array<CallEvent>;
  myEvents: Array<CallEvent>;
  queueCallState: Array<QueueCallState>;
  callback?: Array<CallbackState>;
  myCalls?: Array<CallUser>;
  markedAsCalled: Array<any>;
  deletedVoiceMails: Array<string>;
  // myEvents: Array<{
  //   direction: string;
  //   softEnd: string;
  //   hardEnd: string;
  //   eventsTimes: Array<{
  //     code: string;
  //     time: string;
  //     reason: string;
  //   }>;
  //   id: string;
  //   index: string;
  //   offeredUpdated?: boolean;
  //   attemptedUpdated?: boolean;
  //   userId: string;
  //   endUpdated?: boolean;
  //   disposition?: {
  //     code: string;
  //     message: string;
  //     time: string;
  //   };
  //   account?: {
  //     code: string;
  //     message: string;
  //     time: string;
  //   };
  //   forced?: {
  //     code: string;
  //     message: string;
  //     time: string;
  //   };
  //   to?: {
  //     extensionId: string;
  //     name: string;
  //     phoneNumber: string;
  //   };
  //   from?: {
  //     extensionId: string;
  //     name: string;
  //     phoneNumber: string;
  //   };
  //   answeredTime?: string;
  // }>;
}

// const getQueryParams = (url: string) => {
//   const paramsArray = url.slice(url.indexOf("?") + 1).split("&");
//   const params: UrlParams = {};
//   paramsArray.forEach((param) => {
//     const [key, value] = param.split("=");
//     params[key as keyof UrlParams] = value;
//   });

//   return params;
// };

const QueueLeaderboard = (() => {
  interface User {
    queues: Map<string, boolean>;
    display?: string;
    lastDndStatus?: string;
    id: string;
    messageTimestamp?: string;
  }

  interface Call {
    reason?: "answered" | "abandoned" | "voicemail" | "missed";
    duration?: number;
    ringTime?: string;
  }

  interface Queue {
    users?: Array<{
      id: string;
      acceptCurrentQueueCalls: boolean;
    }>;
    extensionNumber?: string;
    name?: string;
    answeredSum?: number;
    answeredCount?: number;
    abandonedSum?: number;
    abandonedCount?: number;
    missedSum?: number;
    missedCount?: number;
    voicemailCount?: number;
    voicemailSum?: number;
    callCount?: number;
    earliestWaiting?: string;
    calls?: Map<string, Call>;
    id: string;
  }

  const users = new Map<string, User>();

  // two variables to handle the filtered queue situation
  const queues = new Map<string, Queue>();
  const queueIds = new Set<string>();
  let inProgressDelta: string | undefined;
  let missedDeltas: Array<Delta> | undefined = [];

  function agentCountGetter(params: ValueGetterParams) {
    if (params.data.agentCount) return params.data.agentCount.length;
    return "";
  }

  function availableAgentCountGetter(params: ValueGetterParams) {
    if (params.data.availableAgentCount)
      return params.data.availableAgentCount.length;
    return "";
  }

  function busyAgentCountGetter(params: ValueGetterParams) {
    if (params.data.busyAgentCount) return params.data.busyAgentCount.length;
    return "";
  }

  function unavailableAgentCountGetter(params: ValueGetterParams) {
    if (params.data.unavailableAgentCount)
      return params.data.unavailableAgentCount.length;
    return "";
  }

  // function waitingCountGetter(params: ValueGetterParams) {
  //   return params.data.waitingCount.length;
  // }

  function longestWaitingGetter(params: ValueGetterParams) {
    if (params.data.longestWaiting === undefined) return "--:--";
    return `${Math.floor(params.data.longestWaiting / 60)
      .toString()
      .padStart(2, "0")}:${(params.data.longestWaiting % 60)
      .toString()
      .padStart(2, "0")}`;
  }

  function answeredAverageGetter(params: ValueGetterParams) {
    if (params.data.answeredAverage === undefined) return "--:--";
    return `${Math.floor(params.data.answeredAverage / 60)
      .toString()
      .padStart(2, "0")}:${(params.data.answeredAverage % 60)
      .toString()
      .padStart(2, "0")}`;
  }

  function abandonedAverageGetter(params: ValueGetterParams) {
    if (params.data.abandonedAverage === undefined) return "--:--";
    return `${Math.floor(params.data.abandonedAverage / 60)
      .toString()
      .padStart(2, "0")}:${(params.data.abandonedAverage % 60)
      .toString()
      .padStart(2, "0")}`;
  }

  function voicemailAverageGetter(params: ValueGetterParams) {
    if (params.data.voicemailAverage === undefined) return "--:--";
    return `${Math.floor(params.data.voicemailAverage / 60)
      .toString()
      .padStart(2, "0")}:${(params.data.voicemailAverage % 60)
      .toString()
      .padStart(2, "0")}`;
  }

  function missedAverageGetter(params: ValueGetterParams) {
    if (params.data.missedAverage === undefined) return "--:--";
    return `${Math.floor(params.data.missedAverage / 60)
      .toString()
      .padStart(2, "0")}:${(params.data.missedAverage % 60)
      .toString()
      .padStart(2, "0")}`;
  }

  // function lengthFormatter(params: ValueFormatterParams) {
  //   return params.value.length;
  // }

  // function durationFormatter(params: ValueFormatterParams) {
  //   if (params.value === undefined) return "--:--";
  //   return `${Math.floor(params.value / 60)
  //     .toString()
  //     .padStart(2, "0")}:${(params.value % 60).toString().padStart(2, "0")}`;
  // }

  function availableFilter(userId: string, queueId: string) {
    return (
      users.get(userId)?.queues.get(queueId) &&
      users.get(userId)?.display?.startsWith("AVL:") &&
      users.get(userId)?.lastDndStatus === "TakeAllCalls"
    );
  }

  function busyFilter(userId: string, queueId: string) {
    return (
      users.get(userId)?.queues.get(queueId) &&
      !users.get(userId)?.display?.startsWith("AVL:") &&
      users.get(userId)?.lastDndStatus === "TakeAllCalls"
    );
  }

  function dndFilter(userId: string, queueId: string) {
    return (
      !users.get(userId)?.queues.get(queueId) ||
      users.get(userId)?.lastDndStatus !== "TakeAllCalls"
    );
  }
  interface RowData {
    agentCount: Array<string>;
    availableAgentCount: Array<string>;
    busyAgentCount: Array<string>;
    unavailableAgentCount: Array<string>;
    answeredCount: number;
    answeredSum: number;
    abandonedCount: number;
    abandonedSum: number;
    voicemailCount: number;
    voicemailSum: number;
    missedCount: number;
    missedSum: number;
    waitingCount: number;
    longestWaiting?: number;
    callCount: number;
    name: string;
    extensionNumber: string;
    id: string;
  }

  return ({
    orgId,
    historicals,
    // callEvents,
    queueCallStates,
    leaderboardDeltas,
    presenceEvents,
    queuePresenceEvents,
    summaries,
    mode,
    verticalPercent,
    expandLeaderboard,
    setExpandLeaderboard,
    smaller,
    larger,
    dateRange,
    hudTab,
    openDateRange,
    // openDatePicker,
    fontSize,
    increaseFont,
    decreaseFont,
    excludedQueues,
    local,
    updateLocal,
    offset,
    tab,
    navPage,
    setActiveFilterRef,
    queueSelectedTab,
  }: {
    orgId: string | undefined;
    historicals: Array<Historical>;
    // callEvents: Array<CallEvent>;
    queueCallStates: Array<QueueCallState>;
    leaderboardDeltas: Array<Delta>;
    presenceEvents: Array<UserPresenceEvent>;
    queuePresenceEvents: Array<QueuePresenceEvent>;
    summaries: Array<Summary>;
    mode: string;
    verticalPercent: number;
    expandLeaderboard: boolean;
    setExpandLeaderboard: any;
    smaller: any;
    larger: any;
    dateRange: string;
    hudTab: string;
    openDateRange: any;
    // openDatePicker: any;
    fontSize: string;
    increaseFont: any;
    decreaseFont: any;
    excludedQueues: Set<string> | undefined;
    local: any;
    updateLocal: any;
    offset: number;
    tab: string;
    navPage: string;
    queueSelectedTab:
      | "summary"
      | "waiting"
      | "inProgress"
      | "callback"
      | "abandoned"
      | "voicemail"
      | "agent";
    setActiveFilterRef: React.Dispatch<
      SetStateAction<{ [colId: string]: any }>
    >;
  }) => {
    // eslint-disable-next-line
    const classes = mode === "light" ? useStyles() : useDarkStyles();
    const gridRef = useRef<AgGridReact>(null); // Optional - for accessing Grid's API
    // Each Column Definition results in one Column.
    const columnDefs = useMemo(
      () => [
        {
          field: "extensionNumber",
          cellClass: "notranslate",
          filter: true,
          pinned: true,
        },
        { field: "name", cellClass: "notranslate", filter: true },
        {
          field: "agentCount",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: agentCountGetter,
          // valueFormatter: lengthFormatter,
          // comparator: (valueA: Array<string>, valueB: Array<string>) =>
          //   valueA.length - valueB.length,
        },
        {
          field: "availableAgentCount",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: availableAgentCountGetter,
          // valueFormatter: lengthFormatter,
          // comparator: (valueA: Array<string>, valueB: Array<string>) =>
          //   valueA.length - valueB.length,
        },
        {
          field: "busyAgentCount",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: busyAgentCountGetter,
          // valueFormatter: lengthFormatter,
          // comparator: (valueA: Array<string>, valueB: Array<string>) =>
          //   valueA.length - valueB.length,
        },
        {
          field: "unavailableAgentCount",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: unavailableAgentCountGetter,
          // valueFormatter: lengthFormatter,
          // comparator: (valueA: Array<string>, valueB: Array<string>) =>
          //   valueA.length - valueB.length,
        },
        {
          field: "waitingCount",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          // valueFormatter: lengthFormatter,
          // comparator: (valueA: Array<string>, valueB: Array<string>) =>
          //   valueA.length - valueB.length,
        },
        // {
        //   field: "longestWaiting",
        //   valueGetter: longestWaitingGetter,
        //   // valueFormatter: durationFormatter
        // },
        {
          field: "answeredCount",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          // valueFormatter: lengthFormatter,
          // comparator: (valueA: Array<string>, valueB: Array<string>) =>
          //   valueA.length - valueB.length,
        },
        {
          field: "answeredAverage",
          headerName: "Answered Waiting Avg",
          cellClass: "notranslate",
          valueGetter: answeredAverageGetter,
          // valueFormatter: durationFormatter,
          filter: "agNumberColumnFilter",
        },
        {
          field: "abandonedCount",
          filter: "agNumberColumnFilter",
          cellClass: "notranslate",
          // valueFormatter: lengthFormatter,
          // comparator: (valueA: Array<string>, valueB: Array<string>) =>
          //   valueA.length - valueB.length,
        },
        {
          field: "abandonedAverage",
          headerName: "Abandoned Waiting Avg",
          cellClass: "notranslate",
          valueGetter: abandonedAverageGetter,
          filter: "agNumberColumnFilter",
          // valueFormatter: durationFormatter,
        },
        {
          field: "voicemailCount",
          filter: "agNumberColumnFilter",
          cellClass: "notranslate",
          // valueFormatter: lengthFormatter,
          // comparator: (valueA: Array<string>, valueB: Array<string>) =>
          //   valueA.length - valueB.length,
        },
        {
          field: "voicemailAverage",
          headerName: "Voicemail Waiting Avg",
          cellClass: "notranslate",
          valueGetter: voicemailAverageGetter,
          filter: "agNumberColumnFilter",
          // valueFormatter: durationFormatter,
        },
        {
          field: "missedCount",
          headerName: "Other Count",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          // valueFormatter: lengthFormatter,
          // comparator: (valueA: Array<string>, valueB: Array<string>) =>
          //   valueA.length - valueB.length,
        },
        {
          field: "missedAverage",
          headerName: "Other Waiting Avg",
          cellClass: "notranslate",
          valueGetter: missedAverageGetter,
          filter: "agNumberColumnFilter",
          // valueFormatter: durationFormatter,
        },
        {
          field: "callCount",
          filter: "agNumberColumnFilter",
          cellClass: "notranslate",
          // valueFormatter: lengthFormatter,
          // comparator: (valueA: Array<string>, valueB: Array<string>) =>
          //   valueA.length - valueB.length,
        },
      ],
      []
    );
    const [anchorExport, setAnchorExport] = useState<null | HTMLElement>(null);
    const openExport = Boolean(anchorExport);
    const [gridReady, setGridReady] = useState(false);
    const defaultColDef = useMemo(
      () => ({
        sortable: true,
        resizable: true,
        animateRows: false,
        detailRowHeight: 200,
        cellClass: " notarnslate ",
        cellClassRules: {
          small: () => fontSize === "small",
          medium: () => fontSize === "medium",
          large: () => fontSize === "large",
        },
      }),
      [fontSize]
    );
    const setTotals = useCallback(() => {
      if (!gridRef) return;
      if (!gridRef.current) return;

      let totalWaitingCount: number = 0;
      let totalLongestWaiting: number = 0;
      let totalAnsweredCount: number = 0;
      let totalAbandonedCount: number = 0;
      let totalVoicemailCount: number = 0;
      let totalMissedCount: number = 0;
      let totalCallCount: number = 0;
      let totalAnsweredSum: number = 0;
      let totalAbandonedSum: number = 0;
      let totalVoicemailSum: number = 0;
      let totalMissedSum: number = 0;
      try {
        gridRef.current?.api?.forEachNodeAfterFilter((rowNode: any, i: any) => {
          totalWaitingCount += rowNode.data.waitingCount;

          if (rowNode.data.longestWaiting > totalLongestWaiting) {
            totalLongestWaiting = rowNode.data.longestWaiting;
          }

          totalAnsweredCount += rowNode.data.answeredCount;
          totalAbandonedCount += rowNode.data.abandonedCount;
          totalVoicemailCount += rowNode.data.voicemailCount;
          totalMissedCount += rowNode.data.missedCount;

          totalAnsweredSum += rowNode.data.answeredSum;
          totalAbandonedSum += rowNode.data.abandonedSum;
          totalVoicemailSum += rowNode.data.voicemailSum;
          totalMissedSum += rowNode.data.missedSum;

          totalCallCount += rowNode.data.callCount;
        });
      } catch (e) {
        console.log("OnFilterChanged forEachNodeAfterFilter", e);
      }

      // setTimeout(() => {
      try {
        gridRef.current?.api?.setPinnedBottomRowData([
          {
            extensionNumber: "Total",

            waitingCount: totalWaitingCount,
            longestWaiting: totalLongestWaiting,
            answeredCount: totalAnsweredCount,
            answeredAverage:
              totalAnsweredCount === 0
                ? undefined
                : Math.round(totalAnsweredSum / totalAnsweredCount / 1000),
            abandonedCount: totalAbandonedCount,
            abandonedAverage:
              totalAbandonedCount === 0
                ? undefined
                : Math.round(totalAbandonedSum / totalAbandonedCount / 1000),
            voicemailCount: totalVoicemailCount,
            voicemailAverage:
              totalVoicemailCount === 0
                ? undefined
                : Math.round(totalVoicemailSum / totalVoicemailCount / 1000),
            missedCount: totalMissedCount,
            missedAverage:
              totalMissedCount === 0
                ? undefined
                : Math.round(totalMissedSum / totalMissedCount / 1000),
            callCount: totalCallCount,
          },
        ]);
      } catch (e) {
        console.log("OnFilterChanged, SetPinned", e);
      }

      if (
        queueSelectedTab === "summary" &&
        gridReady &&
        gridRef.current &&
        hudTab === "queues"
      ) {
        setActiveFilterRef(gridRef.current?.api?.getFilterModel());
      }
      // }, 0);
    }, [gridReady, gridRef, hudTab, queueSelectedTab]);

    useEffect(() => {
      if (
        queueSelectedTab === "summary" &&
        gridReady &&
        gridRef.current &&
        hudTab === "queues"
      ) {
        setActiveFilterRef(gridRef.current?.api?.getFilterModel());
      }
    }, [hudTab, gridReady, gridRef, queueSelectedTab]);

    useEffect(() => {
      setTotals();
    }, [setTotals]);
    useEffect(() => {
      if (queueCallStates.length === 0) {
        return;
      }
      queueCallStates.forEach((record) => {
        const myQueue = queues.get(record.queueId) as Queue | null;
        let calls = myQueue?.calls;

        if (record.state === "RINGING") {
          if (calls === undefined) {
            calls = new Map([[record.callId, { ringTime: record.time }]]);
          } else {
            calls.set(record.callId, { ringTime: record.time });
          }
        } else if (record.state === "COMPLETE") {
          calls?.delete(record.callId);
        } else if (calls === undefined) {
          calls = new Map([[record.callId, {}]]);
        } else {
          calls.set(record.callId, {});
        }

        let earliestWaiting: string | undefined;

        Array.from(calls?.keys() || []).forEach((id) => {
          const myRingTime = calls?.get(id)?.ringTime;

          if (myRingTime !== undefined) {
            if (earliestWaiting === undefined || earliestWaiting > myRingTime) {
              earliestWaiting = myRingTime;
            }
          }
        });

        queues.set(record.queueId, {
          ...myQueue,
          id: record.queueId,
          calls,
          earliestWaiting,
        });

        const update = gridRef.current!.api?.getRowNode(record.queueId);

        if (update) {
          try {
            // setTimeout(() => {
            gridRef?.current?.api?.applyTransaction({
              update: [
                {
                  ...update.data,
                  waitingCount: Array.from(calls?.values() || []).filter(
                    (call) => call.ringTime !== undefined
                  ).length,
                  longestWaiting: earliestWaiting
                    ? Math.round(
                        (new Date().getTime() +
                          offset -
                          new Date(earliestWaiting).getTime()) /
                          1000
                      )
                    : undefined,
                },
              ],
            });
            // }, 0);
          } catch (e) {
            console.log("transaction on queueCallStates", e);
          }
        }

        setTotals();
      });
      // setRowData((existingRows) =>
      //   existingRows?.map((row) => {
      //     if (row.id === record.queueId) {
      //       return {
      //         ...row,
      //         waitingCount: Array.from(calls?.values() || []).filter(
      //           (call) => call.ringTime !== undefined
      //         ).length,
      //         longestWaiting: earliestWaiting
      //           ? Math.round(
      //               (new Date().getTime() +
      //                 offset -
      //                 new Date(earliestWaiting).getTime()) /
      //                 1000
      //             )
      //           : undefined,
      //       };
      //     }

      //     return row;
      //   })
      // );
    }, [queueCallStates, setTotals]);

    const processDelta = useCallback((delta: Delta, row: RowData) => {
      let answeredSum: number = row.answeredSum || 0;
      let answeredCount: number = row.answeredCount || 0;
      let abandonedSum: number = row.abandonedSum || 0;
      let abandonedCount: number = row.abandonedCount || 0;
      let voicemailSum: number = row.voicemailSum || 0;
      let voicemailCount: number = row.voicemailCount || 0;
      let missedSum: number = row.missedSum || 0;
      let missedCount: number = row.missedCount || 0;

      if (delta.answeredCount) {
        answeredSum += delta.answeredTime || 0;
        answeredCount += delta.answeredCount;
      }

      if (delta.abandonedCount) {
        abandonedSum += delta.abandonedTime || 0;
        abandonedCount += delta.abandonedCount;
      }

      if (delta.missedCount) {
        missedSum += delta.missedTime || 0;
        missedCount += delta.missedCount;
      }

      if (delta.voicemailCount) {
        voicemailSum += delta.voicemailTime || 0;
        voicemailCount += delta.voicemailCount;
      }

      if (gridRef.current?.api.getRowNode(delta.userId)?.rowIndex) {
        // row is visible
        const total = gridRef.current?.api?.getPinnedBottomRow(0)?.data as
          | RowData
          | undefined;

        let answeredSumTotal: number = total?.answeredSum || 0;
        let answeredCountTotal: number = total?.answeredCount || 0;
        let abandonedSumTotal: number = total?.abandonedSum || 0;
        let abandonedCountTotal: number = total?.abandonedCount || 0;
        let voicemailSumTotal: number = total?.voicemailSum || 0;
        let voicemailCountTotal: number = total?.voicemailCount || 0;
        let missedSumTotal: number = total?.missedSum || 0;
        let missedCountTotal: number = total?.missedCount || 0;

        if (delta.answeredCount) {
          answeredSumTotal += delta.answeredTime || 0;
          answeredCountTotal += delta.answeredCount;
        }

        if (delta.abandonedCount) {
          abandonedSumTotal += delta.abandonedTime || 0;
          abandonedCountTotal += delta.abandonedCount;
        }

        if (delta.missedCount) {
          missedSumTotal += delta.missedTime || 0;
          missedCountTotal += delta.missedCount;
        }

        if (delta.voicemailCount) {
          voicemailSumTotal += delta.voicemailTime || 0;
          voicemailCountTotal += delta.voicemailCount;
        }
        // setTimeout(() => {
        try {
          gridRef.current?.api?.setPinnedBottomRowData([
            {
              ...(total || {}),
              answeredCount: answeredCountTotal,
              answeredSum: answeredSumTotal,
              answeredAverage: answeredCountTotal
                ? Math.round(answeredSumTotal / answeredCountTotal / 1000)
                : undefined,
              abandonedCount: abandonedCountTotal,
              abandonedSum: abandonedSumTotal,
              abandonedAverage: abandonedCountTotal
                ? Math.round(abandonedSumTotal / abandonedCountTotal / 1000)
                : undefined,
              voicemailCount: voicemailCountTotal,
              voicemailSum: voicemailSumTotal,
              voicemailAverage: voicemailCountTotal
                ? Math.round(voicemailSumTotal / voicemailCountTotal / 1000)
                : undefined,
              missedCount: missedCountTotal,
              missedSum: missedSumTotal,
              missedAverage: missedCountTotal
                ? Math.round(missedSumTotal / missedCountTotal / 1000)
                : undefined,
              callCount:
                answeredCountTotal +
                abandonedCountTotal +
                missedCountTotal +
                voicemailCountTotal,
            },
          ]);
        } catch (e) {
          console.log("processDelta, setpinnedbottomrowdata", e);
        }
        // }, 0);
      }

      return {
        ...row,
        answeredCount,
        answeredSum,
        answeredAverage: answeredCount
          ? Math.round(answeredSum / answeredCount / 1000)
          : undefined,
        abandonedCount,
        abandonedSum,
        abandonedAverage: abandonedCount
          ? Math.round(abandonedSum / abandonedCount / 1000)
          : undefined,
        voicemailCount,
        voicemailSum,
        voicemailAverage: voicemailCount
          ? Math.round(voicemailSum / voicemailCount / 1000)
          : undefined,
        missedCount,
        missedSum,
        missedAverage: missedCount
          ? Math.round(missedSum / missedCount / 1000)
          : undefined,
        callCount:
          answeredCount + abandonedCount + missedCount + voicemailCount,
        // extensionNumber: row?.extensionNumber,
        // name: row?.name,
      } as RowData;
    }, []);

    useEffect(() => {
      if (leaderboardDeltas.length === 0) {
        return;
      }
      leaderboardDeltas.forEach((delta: Delta) => {
        // due to the way deltas are incremented, sometimes there are duplicates
        if (inProgressDelta !== undefined && inProgressDelta === hash(delta)) {
          return;
        }

        inProgressDelta = hash(delta);

        if (gridRef.current!.api) {
          const row = gridRef.current!.api.getRowNode(delta.userId);

          if (row) {
            try {
              gridRef?.current?.api?.applyTransaction({
                update: [processDelta(delta, row.data)],
              });
            } catch (e) {
              console.log("Transaction error on deltas", e);
            }
          }
        } else {
          // log for later
          missedDeltas?.push(delta);
        }

        // setRowData((existingRows) => {
      });

      //   if (existingRows === undefined) {
      //     // log for later
      //     missedDeltas.push(delta);
      //     return undefined;
      //   }
      //   const row = existingRows.find((temp) => temp.id === delta.userId);

      //   if (row) {
      //     return existingRows?.map((temp) => {
      //       if (temp.id === row.id) {
      //         return processDelta(row, delta);
      //       }
      //       return temp;
      //     });
      //   }

      //   return existingRows;
      // });
    }, [leaderboardDeltas]);

    // behaviour that needs to be replaced:
    // update the queue calls list on active calls
    // update the row data
    // const callEventHandler = useCallback(
    //   (record: CallEvent) => {
    //     // const four = 4;
    //     // if (four === 4) {
    //     //   return;
    //     // }
    //     if (end && new Date(record.body.eventTime) > end) return;
    //     if (start && new Date(record.body.eventTime) < start) return;

    //     const queueId = record.body.parties[0].extensionId;
    //     const callId = record.body.telephonySessionId;

    //     const calls = new Map(queues.get(queueId)?.calls);
    //     const call = calls.get(callId);

    //     let ringTime = call?.ringTime;

    //     if (record.body.parties[0].status.code === "Proceeding") {
    //       if (ringTime === undefined || ringTime > record.body.eventTime) {
    //         ringTime = record.body.eventTime;
    //       }
    //     }

    //     let reason = call?.reason;
    //     let duration = call?.duration;

    //     if (record.body.parties[0].status.code === "Voicemail") {
    //       reason = "voicemail";
    //       if (ringTime !== undefined) {
    //         const newDuration: number =
    //           new Date(record.body.eventTime).getTime() -
    //           new Date(ringTime).getTime();
    //         if (duration === undefined || newDuration > duration) {
    //           duration = newDuration;
    //         }
    //       }
    //     }

    //     if (record.body.parties[0].status.code === "Disconnected") {
    //       if (record.body.parties[0].status.reason === "AgentAnswered") {
    //         reason = "answered";
    //       } else if (record.body.parties[0].status.reason === "CallerDropped") {
    //         reason = "abandoned";
    //       } else if (reason === undefined) {
    //         reason = "missed";
    //       }
    //       if (ringTime !== undefined) {
    //         const newDuration: number =
    //           new Date(record.body.eventTime).getTime() -
    //           new Date(ringTime).getTime();
    //         if (duration === undefined || newDuration > duration) {
    //           duration = newDuration;
    //         }
    //       }
    //     }
    //     const myQueue = queues.get(queueId);

    //     if (myQueue === undefined) {
    //       queues.set(queueId, {
    //         calls: new Map([[callId, { ringTime, reason, duration }]]),
    //         earliestWaiting: ringTime,
    //         id: queueId,
    //       });
    //     } else {
    //       calls.set(callId, { ...call, ringTime, reason, duration });

    //       let earliestWaiting: string | undefined;

    //       Array.from(calls.keys()).forEach((id) => {
    //         const myRingTime = calls.get(id)?.ringTime;
    //         const myReason = calls.get(id)?.reason;

    //         if (myRingTime !== undefined && myReason === undefined) {
    //           if (
    //             earliestWaiting === undefined ||
    //             earliestWaiting > myRingTime
    //           ) {
    //             earliestWaiting = myRingTime;
    //           }
    //         }
    //       });

    //       queues.set(queueId, {
    //         ...myQueue,
    //         calls,
    //         earliestWaiting,
    //       });
    //     }

    //     setRowData((existingRows) =>
    //       existingRows?.map((row) => {
    //         if (row.id === queueId) {
    //           const myCalls = new Map(queues.get(queueId)?.calls);
    //           const earliestWaiting = queues.get(queueId)?.earliestWaiting;

    //           let answeredSum: number = queues.get(queueId)?.answeredSum || 0;
    //           let answeredCount: number =
    //             queues.get(queueId)?.answeredCount || 0;
    //           let abandonedSum: number = queues.get(queueId)?.abandonedSum || 0;
    //           let abandonedCount: number =
    //             queues.get(queueId)?.abandonedCount || 0;
    //           let voicemailSum: number = queues.get(queueId)?.voicemailSum || 0;
    //           let voicemailCount: number =
    //             queues.get(queueId)?.voicemailCount || 0;
    //           let missedSum: number = queues.get(queueId)?.missedSum || 0;
    //           let missedCount: number = queues.get(queueId)?.missedCount || 0;
    //           let callCount: number =
    //             answeredCount + abandonedCount + missedCount + voicemailCount;
    //           let waitingCount: number = 0;
    //           Array.from(myCalls.values()).forEach((myCall: Call) => {
    //             callCount += 1;
    //             if (
    //               myCall.reason === undefined &&
    //               myCall.ringTime !== undefined
    //             ) {
    //               waitingCount += 1;
    //             }
    //             if (myCall.duration !== undefined) {
    //               if (myCall.reason === "answered") {
    //                 answeredSum += myCall.duration;
    //                 answeredCount += 1;
    //               } else if (myCall.reason === "abandoned") {
    //                 abandonedSum += myCall.duration;
    //                 abandonedCount += 1;
    //               } else if (myCall.reason === "missed") {
    //                 missedSum += myCall.duration;
    //                 missedCount += 1;
    //               } else if (myCall.reason === "voicemail") {
    //                 voicemailSum += myCall.duration;
    //                 voicemailCount += 1;
    //               }
    //             }
    //           });

    //           return {
    //             ...row,
    //             answeredCount,
    //             answeredSum,
    //             answeredAverage: answeredCount
    //               ? Math.round(answeredSum / answeredCount / 1000)
    //               : undefined,
    //             abandonedCount,
    //             abandonedSum,
    //             abandonedAverage: abandonedCount
    //               ? Math.round(abandonedSum / abandonedCount / 1000)
    //               : undefined,
    //             voicemailCount,
    //             voicemailSum,
    //             voicemailAverage: voicemailCount
    //               ? Math.round(voicemailSum / voicemailCount / 1000)
    //               : undefined,
    //             missedCount,
    //             missedSum,
    //             missedAverage: missedCount
    //               ? Math.round(missedSum / missedCount / 1000)
    //               : undefined,
    //             longestWaiting: earliestWaiting
    //               ? Math.round(
    //                   (new Date().getTime() +
    //                     offset -
    //                     new Date(earliestWaiting).getTime()) /
    //                     1000
    //                 )
    //               : undefined,
    //             waitingCount,
    //             callCount,
    //           };
    //         }
    //         return row;
    //       })
    //     );
    //   },
    //   [offset]
    // );

    const initialize = useCallback(() => {
      // if (missedDeltas === undefined) {
      //   return;
      // }
      if (!gridRef.current!.api) {
        return;
      }

      const add = [] as Array<RowData>;
      const update = [] as Array<RowData>;

      Array.from(queues.values()).forEach((queue) => {
        const row = gridRef.current!.api.getRowNode(queue.id);

        // console.log(`${missedDeltas.length} missed deltas`);

        if (row !== undefined) {
          let updateRow = {
            ...(row.data as RowData),

            waitingCount: Array.from(queue.calls?.values() || []).filter(
              (call) => call.ringTime !== undefined
            ).length,
            longestWaiting: queue.earliestWaiting
              ? Math.round(
                  (new Date().getTime() +
                    offset -
                    new Date(queue.earliestWaiting).getTime()) /
                    1000
                )
              : undefined,
            agentCount: queue.users?.map(({ id }) => id),
            availableAgentCount: queue.users
              ?.filter(({ id: userId }) => availableFilter(userId, queue.id))
              .map(({ id }) => id),
            busyAgentCount: queue.users
              ?.filter(({ id: userId }) => busyFilter(userId, queue.id))
              .map(({ id }) => id),
            unavailableAgentCount: queue.users
              ?.filter(({ id: userId }) => dndFilter(userId, queue.id))
              .map(({ id }) => id),
          } as RowData;

          missedDeltas
            ?.filter((delta: Delta) => delta.userId === updateRow.id)
            .forEach((delta: Delta) => {
              updateRow = processDelta(delta, updateRow);
            });

          update.push(updateRow);
        } else {
          let addRow = {
            answeredCount: 0,
            answeredSum: 0,
            answeredAverage: undefined,
            abandonedCount: 0,
            abandonedSum: 0,
            abandonedAverage: undefined,
            voicemailCount: 0,
            voicemailSum: 0,
            voicemailAverage: undefined,
            missedCount: 0,
            missedSum: 0,
            missedAverage: undefined,
            callCount: 0,

            ...queue,
            waitingCount: Array.from(queue.calls?.values() || []).filter(
              (call) => call.ringTime !== undefined
            ).length,
            longestWaiting: queue.earliestWaiting
              ? Math.round(
                  (new Date().getTime() +
                    offset -
                    new Date(queue.earliestWaiting).getTime()) /
                    1000
                )
              : undefined,
            agentCount: queue.users?.map(({ id }) => id),
            availableAgentCount: queue.users
              ?.filter(({ id: userId }) => availableFilter(userId, queue.id))
              .map(({ id }) => id),
            busyAgentCount: queue.users
              ?.filter(({ id: userId }) => busyFilter(userId, queue.id))
              .map(({ id }) => id),
            unavailableAgentCount: queue.users
              ?.filter(({ id: userId }) => dndFilter(userId, queue.id))
              .map(({ id }) => id),
          } as RowData;

          missedDeltas
            ?.filter((delta: Delta) => delta.userId === addRow.id)
            .forEach((delta: Delta) => {
              addRow = processDelta(delta, addRow);
            });

          add.push(addRow);
        }
      });

      if (add.length || update.length) {
        // setTimeout(() => {
        try {
          gridRef?.current?.api?.applyTransaction({
            add: add.length ? add : undefined,
            update: update.length ? update : undefined,
          });
        } catch (e) {
          console.log("Transaction error on initialize", e);
        }
        // }, 0);
      }

      missedDeltas = undefined;

      setTotals();
    }, [setTotals]);

    // Example load data from server
    useEffect(() => {
      const data = historicals[0];
      if (data === undefined) {
        return;
      }

      queueIds.clear();

      // setRowData(
      data.queue.forEach((queue) => {
        queueIds.add(queue.id);
        queue.users.forEach((user) => {
          const newUser = data.user.find(({ id }) => id === user.id);

          const existingUser = users.get(user.id);

          if (newUser && !existingUser) {
            users.set(user.id, {
              ...newUser,
              queues: new Map([[queue.id, user.acceptCurrentQueueCalls]]),
            });
          } else if (existingUser) {
            const { queues: myQueues } = existingUser;

            if (myQueues.get(queue.id) === undefined) {
              myQueues.set(queue.id, user.acceptCurrentQueueCalls);
            }

            if (
              newUser &&
              existingUser.messageTimestamp &&
              newUser.messageTimestamp > existingUser.messageTimestamp
            ) {
              users.set(user.id, {
                ...existingUser,
                ...newUser,
                queues: myQueues,
              });
            } else {
              users.set(user.id, {
                ...newUser,
                ...existingUser,
                queues: myQueues,
              });
            }
          }
        });

        queues.set(queue.id, queue);
      });
      // );

      initialize();

      // missedDeltas.length = 0;
    }, [historicals, offset, processDelta, initialize]);

    // useEffect(() => {
    //   setRowData((existingRows) => {
    //     if (existingRows === undefined) return undefined;

    //     const newRows = Array.from(queueIds)
    //       .filter((queueId) => {
    //         if (excludedQueues && excludedQueues.has(queueId)) {
    //           return false;
    //         }
    //         return true;
    //       })
    //       .map((queueId) => {
    //         const queue = queues.get(queueId);
    //       // const myCalls = new Map(queues.get(queueId)?.calls);
    //       // const earliestWaiting = queues.get(queueId)?.earliestWaiting;

    //       // let answeredSum: number = queues.get(queueId)?.answeredSum || 0;
    //       // let answeredCount: number = queues.get(queueId)?.answeredCount || 0;
    //       // let abandonedSum: number = queues.get(queueId)?.abandonedSum || 0;
    //       // let abandonedCount: number =
    //       //   queues.get(queueId)?.abandonedCount || 0;
    //       // let voicemailSum: number = queues.get(queueId)?.voicemailSum || 0;
    //       // let voicemailCount: number =
    //       //   queues.get(queueId)?.voicemailCount || 0;
    //       // let missedSum: number = queues.get(queueId)?.missedSum || 0;
    //       // let missedCount: number = queues.get(queueId)?.missedCount || 0;
    //       // let callCount: number = queues.get(queueId)?.callCount || 0;
    //       // let waitingCount: number = 0;

    //       // Array.from(myCalls.values()).forEach((call: Call) => {
    //       //   callCount += 1;
    //       //   if (call.reason === undefined && call.ringTime !== undefined) {
    //       //     waitingCount += 1;
    //       //   }
    //       //   if (call.duration !== undefined) {
    //       //     if (call.reason === "answered") {
    //       //       answeredSum += call.duration;
    //       //       answeredCount += 1;
    //       //     } else if (call.reason === "abandoned") {
    //       //       abandonedSum += call.duration;
    //       //       abandonedCount += 1;
    //       //     } else if (call.reason === "missed") {
    //       //       missedSum += call.duration;
    //       //       missedCount += 1;
    //       //     } else if (call.reason === "voicemail") {
    //       //       voicemailSum += call.duration;
    //       //       voicemailCount += 1;
    //       //     }
    //       //   }
    //       // });

    //       return {
    //         ...queue,
    //         agentCount: (queue?.users || []).map((user) => user.id),
    //         availableAgentCount: (queue?.users || [])
    //           .map((user) => user.id)
    //           .filter((userId) => availableFilter(userId, queueId)),
    //         busyAgentCount: (queue?.users || [])
    //           .map((user) => user.id)
    //           .filter((userId) => busyFilter(userId, queueId)),
    //         unavailableAgentCount: (queue?.users || [])
    //           .map((user) => user.id)
    //           .filter((userId) => dndFilter(userId, queueId)),
    //         // answeredCount,
    //         // answeredSum,
    //         // answeredAverage: answeredCount
    //         //   ? Math.round(answeredSum / answeredCount / 1000)
    //         //   : undefined,
    //         // abandonedCount,
    //         // abandonedSum,
    //         // abandonedAverage: abandonedCount
    //         //   ? Math.round(abandonedSum / abandonedCount / 1000)
    //         //   : undefined,
    //         // voicemailCount,
    //         // voicemailSum,
    //         // voicemailAverage: voicemailCount
    //         //   ? Math.round(voicemailSum / voicemailCount / 1000)
    //         //   : undefined,
    //         // missedCount,
    //         // missedSum,
    //         // missedAverage: missedCount
    //         //   ? Math.round(missedSum / missedCount / 1000)
    //         //   : undefined,
    //         // waitingCount,
    //         // longestWaiting: earliestWaiting
    //         //   ? Math.round(
    //         //       (new Date().getTime() +
    //         //         offset -
    //         //         new Date(earliestWaiting).getTime()) /
    //         //         1000
    //         //     )
    //         //   : undefined,
    //       };
    //     });
    //     return newRows;
    //   });
    // }, [excludedQueues, offset]);

    // useEffect(() => {
    //   const data = summaries[0];
    //   if (data === undefined) {
    //     return;
    //   }

    //   queues.forEach((queue, id) => {
    //     queues.set(id, {
    //       ...queue,
    //       answeredSum: undefined,
    //       answeredCount: undefined,
    //       abandonedSum: undefined,
    //       abandonedCount: undefined,
    //       missedSum: undefined,
    //       missedCount: undefined,
    //       voicemailCount: undefined,
    //       voicemailSum: undefined,
    //       callCount: undefined,
    //       calls: new Map(),
    //       earliestWaiting: undefined,
    //     });
    //   });

    //   // data.fakeEvents.forEach((record) => {
    //   //   callEventHandler(record);
    //   // });

    //   data.users.forEach((extension) => {
    //     const myQueue = queues.get(extension.userId);
    //     let callCount = 0;
    //     if (extension.talkCountInbound) {
    //       callCount += extension.talkCountInbound;
    //     }
    //     if (extension.abandonedCount) {
    //       callCount += extension.abandonedCount;
    //     }
    //     if (extension.missedCount) {
    //       callCount += extension.missedCount;
    //     }
    //     if (extension.voicemailCount) {
    //       callCount += extension.voicemailCount;
    //     }
    //     if (myQueue === undefined) {
    //       queues.set(extension.userId, {
    //         id: extension.userId,
    //         answeredSum: extension.answeredTime,
    //         answeredCount: extension.answeredCount,
    //         abandonedSum: extension.abandonedTime,
    //         abandonedCount: extension.abandonedCount,
    //         missedSum: extension.missedTime,
    //         missedCount: extension.missedCount,
    //         voicemailCount: extension.voicemailCount,
    //         voicemailSum: extension.voicemailTime,
    //         callCount,
    //       });
    //     } else {
    //       queues.set(extension.userId, {
    //         ...myQueue,
    //         answeredSum: extension.answeredTime,
    //         answeredCount: extension.answeredCount,
    //         abandonedSum: extension.abandonedTime,
    //         abandonedCount: extension.abandonedCount,
    //         missedSum: extension.missedTime,
    //         missedCount: extension.missedCount,
    //         voicemailCount: extension.voicemailCount,
    //         voicemailSum: extension.voicemailTime,
    //         callCount,
    //       });
    //     }
    //   });

    //   setRowData((existingRows) => {
    //     const newRows = existingRows?.map((row) => {
    //       // const myCalls = new Map(queues.get(row.id)?.calls);
    //       // const earliestWaiting = queues.get(queueId)?.earliestWaiting;

    //       const answeredSum: number = queues.get(row.id)?.answeredSum || 0;
    //       const answeredCount: number = queues.get(row.id)?.answeredCount || 0;
    //       const abandonedSum: number = queues.get(row.id)?.abandonedSum || 0;
    //       const abandonedCount: number =
    //         queues.get(row.id)?.abandonedCount || 0;
    //       const voicemailSum: number = queues.get(row.id)?.voicemailSum || 0;
    //       const voicemailCount: number =
    //         queues.get(row.id)?.voicemailCount || 0;
    //       const missedSum: number = queues.get(row.id)?.missedSum || 0;
    //       const missedCount: number = queues.get(row.id)?.missedCount || 0;
    //       const callCount: number =
    //         answeredCount + abandonedCount + missedCount + voicemailCount;
    //       // Array.from(myCalls.values()).forEach((myCall: Call) => {
    //       //   callCount += 1;
    //       //   if (myCall.duration !== undefined) {
    //       //     if (myCall.reason === "answered") {
    //       //       answeredSum += myCall.duration;
    //       //       answeredCount += 1;
    //       //     } else if (myCall.reason === "abandoned") {
    //       //       abandonedSum += myCall.duration;
    //       //       abandonedCount += 1;
    //       //     } else if (myCall.reason === "missed") {
    //       //       missedSum += myCall.duration;
    //       //       missedCount += 1;
    //       //     } else if (myCall.reason === "voicemail") {
    //       //       voicemailSum += myCall.duration;
    //       //       voicemailCount += 1;
    //       //     }
    //       //   }
    //       // });

    //       return {
    //         ...row,
    //         answeredCount,
    //         answeredSum,
    //         answeredAverage: answeredCount
    //           ? Math.round(answeredSum / answeredCount / 1000)
    //           : undefined,
    //         abandonedCount,
    //         abandonedSum,
    //         abandonedAverage: abandonedCount
    //           ? Math.round(abandonedSum / abandonedCount / 1000)
    //           : undefined,
    //         voicemailCount,
    //         voicemailSum,
    //         voicemailAverage: voicemailCount
    //           ? Math.round(voicemailSum / voicemailCount / 1000)
    //           : undefined,
    //         missedCount,
    //         missedSum,
    //         missedAverage: missedCount
    //           ? Math.round(missedSum / missedCount / 1000)
    //           : undefined,
    //         callCount,
    //       };
    //     });

    //     return newRows;
    //   });
    // }, [summaries]);

    // Queue event update
    // useEffect(() => {
    //   const record = callEvents[0];
    //   if (record === undefined) {
    //     return;
    //   }

    //   callEventHandler(record);
    // }, [callEvents, callEventHandler]);

    // Example using Grid's API
    useEffect(() => {
      if (!presenceEvents || presenceEvents.length === 0) {
        return;
      }

      presenceEvents.forEach((record) => {
        const existingUser = users.get(record.id);

        // Add new user or update existing user based on messageTimestamp
        if (!existingUser) {
          users.set(record.id, {
            ...record,
            queues: new Map(),
          });
        } else if (
          existingUser.messageTimestamp === undefined ||
          record.messageTimestamp > existingUser.messageTimestamp
        ) {
          users.set(record.id, {
            ...existingUser,
            ...record,
          });
        }

        // Update the corresponding row in the grid
        const row = gridRef.current!.api?.getRowNode(record.id);

        if (row) {
          if (users.get(record.id)?.queues.has(row.data.id)) {
            try {
              gridRef?.current?.api?.applyTransaction({
                update: [
                  {
                    ...row.data,
                    availableAgentCount: row.data.users
                      ?.filter(({ id: userId }: { id: string }) =>
                        availableFilter(userId, row.data.id)
                      )
                      .map(({ id }: { id: string }) => id),
                    busyAgentCount: row.data.users
                      ?.filter(({ id: userId }: { id: string }) =>
                        busyFilter(userId, row.data.id)
                      )
                      .map(({ id }: { id: string }) => id),
                    unavailableAgentCount: row.data.users
                      ?.filter(({ id: userId }: { id: string }) =>
                        dndFilter(userId, row.data.id)
                      )
                      .map(({ id }: { id: string }) => id),
                  },
                ],
              });
            } catch (e) {
              console.log("Transaction error on presenceEvents", e);
            }
          }
        }
      });
    }, [presenceEvents]);

    useEffect(() => {
      const record = queuePresenceEvents[0];
      if (record === undefined) {
        return;
      }
      const existingUser = users.get(record.userId);

      if (!existingUser) {
        users.set(record.userId, {
          id: record.userId,
          queues: new Map([[record.id, record.acceptCurrentQueueCalls]]),
        });
      } else {
        const myQueues = new Map(existingUser.queues);
        myQueues.set(record.id, record.acceptCurrentQueueCalls);

        users.set(record.userId, {
          ...existingUser,
          queues: myQueues,
        });
      }

      const row = gridRef.current!.api?.getRowNode(record.id);

      if (row) {
        if (users.get(record.userId)?.queues.has(row.data.id)) {
          // setTimeout(() => {
          try {
            gridRef?.current?.api?.applyTransaction({
              update: [
                {
                  ...row.data,
                  availableAgentCount: row.data.users
                    ?.filter(({ id: userId }: { id: string }) =>
                      availableFilter(userId, row.data.id)
                    )
                    .map(({ id }: { id: string }) => id),
                  busyAgentCount: row.data.users
                    ?.filter(({ id: userId }: { id: string }) =>
                      busyFilter(userId, row.data.id)
                    )
                    .map(({ id }: { id: string }) => id),
                  unavailableAgentCount: row.data.users
                    ?.filter(({ id: userId }: { id: string }) =>
                      dndFilter(userId, row.data.id)
                    )
                    .map(({ id }: { id: string }) => id),
                },
              ],
            });
          } catch (e) {
            console.log("Transaction error on queuePresenceEvents", e);
          }
          // }, 0);
        }
      }
      // setRowData((existingRows) =>
      //   existingRows?.map((row) => {
      //     if (users.get(record.userId)?.queues.has(row.id)) {
      //       return {
      //         ...row,
      //         availableAgentCount: row.agentCount.filter((userId) =>
      //           availableFilter(userId, row.id)
      //         ),
      //         busyAgentCount: row.agentCount.filter((userId) =>
      //           busyFilter(userId, row.id)
      //         ),
      //         unavailableAgentCount: row.agentCount.filter((userId) =>
      //           dndFilter(userId, row.id)
      //         ),
      //       };
      //     }
      //     return row;
      //   })
      // );
    }, [queuePresenceEvents]);

    const columnChanges = useCallback(
      (event) => {
        if (gridRef.current?.columnApi === undefined) {
          return;
        }
        localStorage.setItem(
          `queue-summary-leaderboard`,
          JSON.stringify(gridRef.current!.columnApi.getColumnState())
        );
      },
      [gridRef]
    );

    useEffect(() => {
      gridRef.current?.api?.onFilterChanged();
    }, [excludedQueues]);

    useEffect(() => {
      if (
        gridReady &&
        local[`queue-summary-leaderboard`] !== undefined &&
        gridRef.current !== undefined &&
        gridRef.current !== null &&
        gridRef.current.columnApi !== null
      ) {
        //  applying column state changes from last session
        const raw = local[`queue-summary-leaderboard`];
        const columnData = raw ? JSON.parse(raw) : [];
        gridRef.current.columnApi.applyColumnState({
          state: columnData,
          applyOrder: true,
        });

        if (orgId) {
          // applying filter state changes from last session
          const rawFilters = localStorage.getItem(`queue-summary-leaderboard-filters-${orgId}`);
          const filterData = rawFilters ? JSON.parse(rawFilters) : [];
          try {
            gridRef.current.api?.setFilterModel(filterData);
          } catch(err) {
            console.error("%c ⚠ Could not set Queue Summary Leaderboard localStorage configurations to leaderboard. ⚠", 'color: orange; font-weight: 900' , err)
          }
        }
      }
    }, [gridReady, local, gridRef, orgId]);

    const getRowId = useMemo(
      () => (params: GetRowIdParams) => params.data.id,
      []
    );

    const clickOnCsvExport = useCallback(() => {
      gridRef.current!.api.exportDataAsCsv();
      setAnchorExport(null);
    }, []);

    const clickOnExcelExport = useCallback(() => {
      gridRef.current!.api.exportDataAsExcel();
      setAnchorExport(null);
    }, []);

    const setFilterConfigToLocalStorage = useCallback((): void => {
      if (!gridRef.current || !gridReady || !orgId) return;
      const filterModel = gridRef.current.api?.getFilterModel()
      try {
        localStorage.setItem(`queue-summary-leaderboard-filters-${orgId}`,JSON.stringify(filterModel));
      } catch (err) {
        console.error("%c ⚠ Could not set Queue Summary Leaderboard filter configurations to localStorage. ⚠", 'color: orange; font-weight: 900' , err)
      }
    }, [gridRef, gridReady, orgId]);

    return (
      <div>
        <Toolbar
          disableGutters
          variant="dense"
          style={{
            minHeight: "50px",
            backgroundColor: mode === "dark" ? "#181818" : "#0684bd",
            borderRadius: "5px 5px 0px 0px",
          }}
        >
          <Grid container justifyContent="space-between">
            <Grid
              item
              xs={4}
              md={4}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Button
                variant="text"
                disableRipple
                style={{
                  backgroundColor: "transparent",
                  color: "#fff",
                  textTransform: "none",
                }}
                onClick={() => setExpandLeaderboard(!expandLeaderboard)}
                startIcon={
                  expandLeaderboard ? (
                    <ExpandLess style={{ color: "white" }} />
                  ) : (
                    <ExpandMore style={{ color: "white" }} />
                  )
                }
              >
                Leaderboard
              </Button>
              {gridRef &&
                gridRef.current &&
                gridRef.current.api &&
                Object?.keys(gridRef.current?.api?.getFilterModel() || {})
                  ?.length > 0 && (
                  <button
                    type="button"
                    style={{
                      cursor: "pointer",
                      background: "none",
                      border: "none",
                    }}
                  >
                    <span
                      style={{
                        fontFamily: "agGridAlpine",
                        color: "white",
                        fontSize: "1.4em",
                      }}
                      className="ag-theme-alpine ag-icon-filter"
                    />
                  </button>
                )}
            </Grid>
            {expandLeaderboard && (
              <Grid
                container
                item
                xs={8}
                alignItems="center"
                direction="row-reverse"
                style={{ paddingTop: "0.3rem" }}
              >
                <Grid container item xs={12} justifyContent="flex-end">
                  <Button
                    id="queue-leaderboard-download"
                    onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
                      setAnchorExport(e.currentTarget)
                    }
                    aria-controls={openExport ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={openExport ? "true" : undefined}
                    size="small"
                    style={{
                      height: "32px",
                      width: "32px",
                      minWidth: "24px",
                    }}
                  >
                    <GetApp style={{ color: "white" }} />
                  </Button>

                  <Button
                    size="small"
                    style={{
                      height: "32px",
                      width: "32px",
                      minWidth: "24px",
                    }}
                    onClick={larger}
                  >
                    <UnfoldMore style={{ color: "white" }} />
                  </Button>
                  <Button
                    size="small"
                    style={{ height: "32px", width: "32px", minWidth: "24px" }}
                    onClick={smaller}
                  >
                    <UnfoldLess style={{ color: "white" }} />
                  </Button>
                  <Button
                    onClick={increaseFont}
                    size="small"
                    style={{
                      height: "32px",
                      width: "32px",
                      minWidth: "24px",
                    }}
                  >
                    <TextFormat
                      style={{ fontSize: "1.8rem", color: "white" }}
                    />
                  </Button>
                  <Button
                    onClick={decreaseFont}
                    size="small"
                    style={{ height: "32px", width: "32px", minWidth: "24px" }}
                  >
                    <TextFormat fontSize="small" style={{ color: "white" }} />
                  </Button>
                </Grid>
                {/* <Grid
                  item
                  xs={12}
                  sm={6}
                  style={{ marginBottom: 5, marginTop: 5 }}
                >
                  <TextField
                    fullWidth
                    style={{
                      height: 30,
                      cursor: "pointer",
                      marginBottom: 5,
                    }}
                    // onClick={(e) => {
                    //   if (hudTab === "queues") {
                    //     openDatePicker(e);
                    //   }
                    // }}
                    value={dateRange}
                    id="datetime-range"
                    label="Date Range"
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                      className: classes.select,
                    }}
                    aria-controls={openDateRange ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={openDateRange ? "true" : undefined}
                    className={classes.dateRange}
                    InputLabelProps={{
                      style: {
                        color: "white",
                        fontSize: "0.85rem",
                        cursor: "pointer",
                      },
                      shrink: true,
                    }}
                  />
                </Grid> */}
              </Grid>
            )}
          </Grid>
        </Toolbar>
        <Menu
          disableEnforceFocus
          disableAutoFocus
          classes={{ paper: classes.menuPaper }}
          anchorEl={anchorExport}
          id="basic-menu"
          open={openExport}
          getContentAnchorEl={null}
          // transformOrigin={{ horizontal: 'left', vertical: 'top' }}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
          onClose={() => setAnchorExport(null)}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          style={{
            display: tab === "queues" && navPage === "hud" ? "inherit" : "none",
          }}
        >
          <MenuItem
            id="queue-leaderboard-download-csv"
            className={classes.menuItem}
            onClick={clickOnCsvExport}
          >
            CSV Export
          </MenuItem>
          <MenuItem
            id="queue-leaderboard-download-excel"
            className={classes.menuItem}
            onClick={clickOnExcelExport}
          >
            Excel Export
          </MenuItem>
        </Menu>
        <Collapse in={expandLeaderboard} timeout="auto">
          <div style={{ width: "100%", height: `${verticalPercent}vh` }}>
            <AgGridReact
              isExternalFilterPresent={() => true}
              doesExternalFilterPass={(row) =>
                excludedQueues === undefined
                  ? true
                  : !excludedQueues.has(row.data.id)
              }
              suppressCopyRowsToClipboard
              detailRowHeight={200}
              onGridReady={() => {
                setGridReady(true);
                initialize();
              }}
              ref={gridRef} // Ref for accessing Grid's API
              // rowData={rowData} // Row Data for Rows
              columnDefs={columnDefs} // Column Defs for Columns
              defaultColDef={defaultColDef} // Default Column Properties
              animateRows // Optional - set to 'true' to have rows animate when sorted
              rowSelection="multiple" // Options - allows click selection of rows
              // onCellClicked={cellClickedListener} // Optional - registering for Grid Event
              getRowId={getRowId}
              paginationAutoPageSize
              pagination
              rowHeight={28}
              onFilterModified={setFilterConfigToLocalStorage}
              onFilterChanged={(e) => {
                // save to local storage.
                setFilterConfigToLocalStorage();
                // set bottom line totals.
                setTotals();
              
              }}
              onColumnVisible={columnChanges}
              onSortChanged={columnChanges}
              onColumnMoved={columnChanges}
              onColumnPinned={columnChanges}
              onColumnResized={columnChanges}
              getRowStyle={(params) => {
                if (params.node.rowPinned) {
                  return { fontWeight: "bold" };
                }
                return { fontWeight: "normal" };
              }}
              sideBar={{
                toolPanels: [
                  "filters",
                  {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel",
                    toolPanelParams: {
                      suppressRowGroups: true,
                      suppressValues: true,
                      suppressPivots: true,
                      suppressPivotMode: true,
                      suppressColumnFilter: true,
                      suppressColumnSelectAll: true,
                      suppressColumnExpandAll: true,
                    },
                  },
                ],
              }}
            />
          </div>
        </Collapse>
      </div>
    );
  };
})();

class BtnCellRenderer extends React.Component {
  private params: any;

  constructor(props: any) {
    super(props);
    this.params = props;
    this.btnClickedHandler = this.btnClickedHandler.bind(this);
  }

  btnClickedHandler() {
    this.params.clicked(this.params);
  }

  render() {
    return (
      <>
        {this.params.node.data.partyId !== undefined && (
          <div style={{ display: "flex", margin: 0 }}>
            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={this.btnClickedHandler}
              style={{
                height: "23px",
                backgroundColor: "#30ae74 !important",
              }}
            >
              <Phone fontSize="small" style={{ color: "white" }} />
              Pick up
            </Button>
          </div>
        )}
      </>
    );
  }
}

class DisabledBtnCellRenderer extends React.Component {
  private params: any;

  constructor(props: any) {
    super(props);
    this.params = props;
    this.btnClickedHandler = this.btnClickedHandler.bind(this);
  }

  btnClickedHandler() {
    this.params.clicked(this.params);
  }

  render() {
    return (
      <>
        <Button color="primary" variant="contained" size="small" disabled>
          Pick up
        </Button>
      </>
    );
  }
}

const QueueWaiting = (() => {
  interface Queue {
    extensionNumber?: string;
    name?: string;
    id: string;
    calls?: Map<string, Call>;
  }

  interface Call {
    id: string;
    vip?: number;
    vipName?: string;
    partyId?: string;
    disconnected?: boolean;
    ringTime?: Date;
    queueId: string;
    callerNumber?: string;
    callerName?: string;
    calleeNumber?: string;
    duration?: number;
  }

  function durationFormatter(params: ValueFormatterParams) {
    if (params.value === undefined) return "--:--";
    return `${Math.floor(params.value / 60)
      .toString()
      .padStart(2, "0")}:${(params.value % 60).toString().padStart(2, "0")}`;
  }
  function vipCheck(params: ValueFormatterParams) {
    if (params.value) {
      return "Yes";
    }
    return "No";
  }

  function regexCheck(str: string, number: string): boolean {
    const escapeRegex = (s: string): string =>
      s.replace(/([.+^=!:${}()|\\])/g, "\\$1");

    const temp = "^".concat(number.split("*").map(escapeRegex).join(".*"), "$");
    const r = new RegExp(temp.split("?").join("."));

    return r.test(str);
  }

  function checkVip(
    vipList: Array<any>,
    number: string,
    showVip: boolean
  ): { val: number; vipName: string } {
    let val = 0;
    let vipName: string = "";
    if (vipList.length) {
      vipList.forEach((vip: any) => {
        const temp = regexCheck(number, vip.number);
        if (temp && showVip) {
          val = 1;
          vipName = vip.name;
        }
      });
    }
    return { val, vipName };
  }

  interface RowData {
    callId: string;
    partyId?: string;
    queueId: string;
    name: string;
    extensionNumber: string;
    callerNumber?: string;
    callerName?: string;
    duration?: number;
    vip?: number;
    vipName?: string;
    calleeNumber?: string;
    ringTime?: Date;
  }

  const queues = new Map<string, Queue>();
  const calls = new Map<string, string>();

  let unprocessStates = [] as Array<QueueCallState> | undefined;
  // const unprocessed = new Map<string, Queue>();

  return ({
    historicals,
    // callEvents,
    queueCallStates,
    expandLeaderboard,
    setExpandLeaderboard,
    smaller,
    larger,
    mode,
    verticalPercent,
    fontSize,
    increaseFont,
    decreaseFont,
    excludedQueues,
    local,
    updateLocal,
    offset,
    deviceId,
    rcAccessToken,
    queueCallPickUp,
    summaries,
    showCherryPick,
    spoiledCherryPickCalls,
    setSpoiledCherryPickCalls,
    vipList,
    showVip,
    user,
    queueWaitingCount,
    setQueueWaitingCount,
    organizationId,
    setActiveFilterRef,
    queueSelectedTab,
    page,
    hudTab,
    navTab,
    navPage,
  }: {
    historicals: Array<Historical>;
    // callEvents: Array<CallEvent>;
    queueCallStates: Array<QueueCallState>;
    expandLeaderboard: boolean;
    setExpandLeaderboard: any;
    smaller: any;
    larger: any;
    mode: string;
    verticalPercent: number;
    fontSize: string;
    increaseFont: any;
    decreaseFont: any;
    excludedQueues: Set<string> | undefined;
    local: any;
    updateLocal: any;
    offset: number;
    deviceId: string | undefined;
    rcAccessToken: string | undefined;
    queueCallPickUp: boolean | undefined;
    summaries: Array<Summary>;
    showCherryPick: boolean | undefined;
    spoiledCherryPickCalls: Set<string>;
    setSpoiledCherryPickCalls: any;
    vipList: any;
    showVip: boolean;
    user: any;
    queueWaitingCount: number;
    setQueueWaitingCount: any;
    organizationId: string;
    setActiveFilterRef: React.Dispatch<SetStateAction<any>>;
    queueSelectedTab: string;
    page: string;
    hudTab: string;
    navTab: string;
    navPage: string;
  }) => {
    // eslint-disable-next-line
    const classes = mode === "light" ? useStyles() : useDarkStyles();

    const gridRef = useRef<AgGridReact>(null);

    const pickUp = useCallback(
      async (value: any) => {
        if (!deviceId) {
          setErrorWaitingTab("No device id");
          return;
        }

        if (user.display.startsWith("DND")) {
          setErrorWaitingTab(
            "Cannot pick up this call: user should not have DND status to be able to pick up a call."
          );
          return;
        }

        // send request to rc pick up api
        const { callId, partyId } = value.node.data;
        try {
          const res = await fetch(
            `https://platform.ringcentral.com/restapi/v1.0/account/~/telephony/sessions/${callId}/parties/${partyId}/pickup`,
            {
              method: "post",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${rcAccessToken}`,
              },
              body: JSON.stringify({
                deviceId,
              }),
            }
          );
          if (!res.ok) {
            const err = await res.json();
            setErrorWaitingTab(
              `Cannot pick up this call: ${err.errors?.[0]?.message}`
            );
            setSpoiledCherryPickCalls(
              (oldSpoiledCherryPickCalls: Set<string>) => {
                const mySet = new Set(oldSpoiledCherryPickCalls);
                mySet.add(callId);
                return mySet;
              }
            );
          }
        } catch (err) {
          setErrorWaitingTab(`Cannot pick up this call: ${err}`);
          setSpoiledCherryPickCalls(
            (oldSpoiledCherryPickCalls: Set<string>) => {
              const mySet = new Set(oldSpoiledCherryPickCalls);
              mySet.add(callId);
              return mySet;
            }
          );
        }
      },
      [deviceId, rcAccessToken]
    );

    // const CherryPickHidden = useMemo(
    //   () => [
    //     { field: "extensionNumber", filter: true, pinned: true },
    //     { field: "name", filter: true },
    //     { field: "callerNumber", filter: true },
    //     { field: "callerName", filter: true },
    //     {
    //       field: "duration",
    //       headerName: "Wait Time",
    //       valueFormatter: durationFormatter,
    //     },
    //   ],
    //   []
    // );

    // const cherryPickButtonEnabled = useMemo(
    //   () => [
    //     { field: "extensionNumber", filter: true, pinned: true },
    //     { field: "name", filter: true },
    //     { field: "callerNumber", filter: true },
    //     { field: "callerName", filter: true },
    //     {
    //       field: "duration",
    //       headerName: "Wait Time",
    //       valueFormatter: durationFormatter,
    //     },
    //     {
    //       field: "partyId",
    //       headerName: "",
    //       cellRenderer: BtnCellRenderer,
    //       cellRendererParams: {
    //         clicked: pickUp,
    //       },
    //     },
    //   ],
    //   [pickUp, rowData]
    // );

    // const cherryPickButtonDisabled = useMemo(
    //   () => [
    //     { field: "extensionNumber", filter: true, pinned: true },
    //     { field: "name", filter: true },
    //     { field: "callerNumber", filter: true },
    //     { field: "callerName", filter: true },
    //     {
    //       field: "duration",
    //       headerName: "Wait Time",
    //       valueFormatter: durationFormatter,
    //     },
    //     {
    //       field: "partyId",
    //       headerName: "",
    //       cellRenderer: DisabledBtnCellRenderer,
    //       cellRendererParams: {
    //         clicked: pickUp,
    //       },
    //     },
    //   ],
    //   [pickUp, rowData]
    // );
    // Each Column Definition results in one Column.
    const [columnDefs, setColumnDefs] = useState([
      {
        field: "vipName",
        headerName: "VIP Name",
        cellClass: "notranslate",
        hide: !showVip,
      },
      {
        field: "vip",
        headerName: "VIP",
        cellClass: "notranslate",
        valueFormatter: vipCheck,
        hide: !showVip,
      },
      { field: "extensionNumber", filter: true, pinned: true },
      { field: "name", filter: true, cellClass: "notranslate" },
      { field: "callerNumber", filter: true },
      { field: "callerName", filter: true, cellClass: "notranslate" },
      {
        field: "calleeNumber",
        headerName: "Callee Number",
        cellClass: "notranslate",
        filter: true,
      },
      {
        field: "ringTime",
        headerName: "Waiting Since",
        cellClass: "notranslate",
        valueFormatter: dateFormatter,
        filter: "agTextColumnFilter",
      },
    ]);

    const [anchorExport, setAnchorExport] = useState<null | HTMLElement>(null);
    const [gridReady, setGridReady] = useState(false);
    const [errorWaitingTab, setErrorWaitingTab] = useState<
      string | undefined
    >();
    const openExport = Boolean(anchorExport);

    useEffect(() => {
      if (
        queueSelectedTab === "waiting" &&
        gridReady &&
        gridRef.current &&
        hudTab === "queues"
      ) {
        setActiveFilterRef(gridRef.current?.api?.getFilterModel());
      }
    }, [hudTab, gridReady, gridRef, queueSelectedTab]);
    // DefaultColDef sets props common to all Columns
    const defaultColDef = useMemo(
      () => ({
        sortable: true,
        resizable: true,
        animateRows: false,
        cellClass: " notarnslate ",
        cellClassRules: {
          small: () => fontSize === "small",
          medium: () => fontSize === "medium",
          large: () => fontSize === "large",
        },
      }),
      [fontSize]
    );

    const getRowId = useMemo(
      () => (params: GetRowIdParams) =>
        `${params.data.queueId}-${params.data.callId}`,
      []
    );

    // useEffect(() => {
    //   if (gridReady === false) {
    //     return;
    //   }
    //   if (queueCallPickUp && showCherryPick && deviceId) {
    //     gridRef.current!.api.setColumnDefs(cherryPickButtonEnabled);
    //   } else if (queueCallPickUp && showCherryPick && !deviceId) {
    //     gridRef.current!.api.setColumnDefs(cherryPickButtonDisabled);
    //   } else {
    //     gridRef.current!.api.setColumnDefs(CherryPickHidden);
    //   }
    // }, [gridReady]);

    useEffect(() => {
      if (gridReady === false) {
        return;
      }
      const colDefs: Array<any> = [];

      colDefs.push({
        field: "duration",
        valueFormatter: durationFormatter,
        filter: "agNumberColumnFilter",
      });

      if (queueCallPickUp && showCherryPick && deviceId) {
        // setTimeout(() => {
        try {
          gridRef.current!.api.setColumnDefs(
            [
              {
                field: "vipName",
                headerName: "VIP Name",
                cellClass: "notranslate",
                hide: !showVip,
              },
              {
                field: "extensionNumber",
                filter: true,
                pinned: true,
                cellClass: "notranslate",
              },
              { field: "name", filter: true, cellClass: "notranslate" },
              { field: "callerNumber", filter: true, cellClass: "notranslate" },
              { field: "callerName", filter: true, cellClass: "notranslate" },
              {
                field: "calleeNumber",
                headerName: "Callee Number",
                cellClass: "notranslate",
                filter: true,
              },
              {
                field: "ringTime",
                headerName: "Waiting Since",
                cellClass: "notranslate",
                valueFormatter: dateFormatter,
                filter: "agTextColumnFilter",
              },
              {
                field: "partyId",
                headerName: "",
                cellClass: "notranslate",
                cellRenderer: BtnCellRenderer,
                cellRendererParams: {
                  clicked: pickUp,
                },
              },
              {
                field: "vip",
                headerName: "VIP",
                cellClass: "notranslate",
                valueFormatter: vipCheck,
                hide: !showVip,
              },
            ].concat(colDefs)
          );
        } catch (e) {
          console.log("setColumnDefs in pickup 1", e);
        }
        // }, 0);
      } else if (queueCallPickUp && showCherryPick && !deviceId) {
        try {
          gridRef.current!.api.setColumnDefs(
            [
              {
                field: "vipName",
                headerName: "VIP Name",
                cellClass: "notranslate",
                hide: !showVip,
                pinned: "left" as any,
              },
              {
                field: "extensionNumber",
                filter: true,
                pinned: true,
                cellClass: "notranslate",
              },
              { field: "name", filter: true, cellClass: "notranslate" },
              { field: "callerNumber", filter: true, cellClass: "notranslate" },
              { field: "callerName", filter: true, cellClass: "notranslate" },
              {
                field: "calleeNumber",
                headerName: "Callee Number",
                cellClass: "notranslate",
                filter: true,
              },
              {
                field: "calleeName",
                headerName: "Callee Name",
                cellClass: "notranslate",
                filter: true,
              },
              {
                field: "ringTime",
                headerName: "Waiting Since",
                cellClass: "notranslate",
                valueFormatter: dateFormatter,
                filter: "agTextColumnFilter",
              },
              {
                field: "partyId",
                headerName: "",
                cellClass: "notranslate",
                cellRenderer: DisabledBtnCellRenderer,
                cellRendererParams: {
                  clicked: pickUp,
                },
              },
              {
                field: "vip",
                headerName: "VIP",
                cellClass: "notranslate",
                valueFormatter: vipCheck,
                hide: !showVip,
              },
            ].concat(colDefs)
          );
        } catch (e) {
          console.log("setColumnDefs in pickup 2", e);
        }
      } else {
        try {
          gridRef.current!.api.setColumnDefs(
            [
              {
                field: "vipName",
                headerName: "VIP Name",
                cellClass: "notranslate",
                hide: !showVip,
              },
              {
                field: "extensionNumber",
                filter: true,
                pinned: true,
                cellClass: "notranslate",
              },
              { field: "name", filter: true, cellClass: "notranslate" },
              { field: "callerNumber", filter: true, cellClass: "notranslate" },
              { field: "callerName", filter: true, cellClass: "notranslate" },
              {
                field: "calleeNumber",
                headerName: "Callee Number",
                cellClass: "notranslate",
                filter: true,
              },
              {
                field: "calleeName",
                headerName: "Callee Name",
                filter: true,
                cellClass: "notranslate",
              },
              // {
              //   field: "ringTime",
              //   headerName: "Waiting Since",
              //   valueFormatter: (params: ValueFormatterParams) =>
              //     params.value ? new Date(params.value).toLocaleString() : "",
              // },
              {
                field: "ringTime",
                headerName: "Waiting Since",
                cellClass: "notranslate",
                valueFormatter: dateFormatter,
              },
              {
                field: "vip",
                headerName: "VIP",
                cellClass: "notranslate",
                valueFormatter: vipCheck,
                hide: !showVip,
              },
            ].concat(colDefs)
          );
        } catch (e) {
          console.log("setColumnDefs in pickup 3", e);
        }
      }
    }, [deviceId, showCherryPick, queueCallPickUp, gridReady, pickUp]);

    // useEffect(() => {
    //   setColumnDefs([
    //     { field: "extensionNumber", filter: true, pinned: true },
    //     { field: "name", filter: true },
    //     { field: "callerNumber", filter: true },
    //     { field: "callerName", filter: true },
    //     {
    //       field: "duration",
    //       headerName: "Wait Time",
    //       valueFormatter: durationFormatter,
    //     },
    //     {
    //       field: "partyId",
    //       headerName: "",
    //       cellRenderer: deviceId ? BtnCellRenderer : DisabledBtnCellRenderer,
    //       cellRendererParams: {
    //         clicked: pickUp,
    //       },
    //       hide: !queueCallPickUp || (queueCallPickUp && !showCherryPick),
    //     },
    //   ]);
    // }, [pickUp, deviceId, rcAccessToken, queueCallPickUp, showCherryPick]);

    // useEffect(() => {
    //   let timeout: any;

    //   const calculateLongest = () => {
    //     setRowData((oldRowData) =>
    //       oldRowData?.map((row) => {
    //         const myCalls = queues.get(row.queueId)?.calls || new Map();
    //         const ringTime = myCalls.get(row.callId)?.ringTime;

    //         return {
    //           ...row,
    //           duration: ringTime
    //             ? Math.round(
    //                 (new Date().getTime() +
    //                   offset -
    //                   new Date(ringTime).getTime()) /
    //                   1000
    //               )
    //             : 0,
    //         };
    //       })
    //     );

    //     timeout = setTimeout(calculateLongest, 1000);
    //   };
    //   calculateLongest();

    //   return () => {
    //     clearTimeout(timeout);
    //   };
    // }, [offset]);

    // This needs to be revived
    useEffect(() => {
      let timeout: any;

      const calculateLongest = () => {
        try {
          const update = [] as Array<RowData>;
          if (gridRef && gridRef.current && gridRef.current.api) {
            gridRef.current.api.forEachNode((node: { data: RowData }) => {
              const myCalls =
                queues.get(node.data.queueId)?.calls || new Map<string, Call>();
              const ringTime = myCalls.get(node.data.callId)?.ringTime as
                | number
                | undefined;
              if (
                node.data.duration !==
                (ringTime
                  ? Math.round(
                      (new Date().getTime() +
                        offset -
                        new Date(ringTime).getTime()) /
                        1000
                    )
                  : 0)
              ) {
                const duration = ringTime
                  ? Math.round(
                      (new Date().getTime() +
                        offset -
                        new Date(ringTime).getTime()) /
                        1000
                    )
                  : 0;

                update.push({
                  ...node.data,
                  duration,
                });

                myCalls.set(node.data.callId, {
                  ...myCalls.get(node.data.callId),
                  id: node.data.callId,
                  queueId: node.data.queueId,
                  duration,
                });

                queues.set(node.data.queueId, {
                  ...queues.get(node.data.queueId),
                  calls: myCalls,
                  id: node.data.queueId,
                });
              }
            });
            if (update.length) {
              // setTimeout(() => {
              gridRef.current?.api?.applyTransaction({ update });
              // }, 0);
            }
          }
        } catch (e) {
          console.log("Transaction error on longest feature:", e);
          console.log(gridRef, gridRef.current, gridRef.current?.api);
        } finally {
          timeout = setTimeout(() => {
            calculateLongest();
          }, 1000);
        }
      };

      calculateLongest();

      return () => {
        clearTimeout(timeout);
      };
    }, [offset, user]);

    // useEffect(() => {
    //   if (
    //     rowData
    //       ?.filter((data) => !data.vip)
    //       .find(
    //         (data) =>
    //           checkVip(vipList, data.callerNumber || "", showVip).val === 1
    //       )
    //   ) {
    //     // setRowData((oldRowData) =>
    //     //   oldRowData?.map((data) => {
    //     //     const temp = checkVip(vipList, data.callerNumber || "", showVip);

    //     //     return {
    //     //       ...data,
    //     //       vip: temp.val,
    //     //       vipName: temp.vipName,
    //     //     };
    //     //   })
    //     // );

    //     gridRef.current!.api?.applyTransaction({
    //       update: rowData
    //         ?.filter((data) => !data.vip)
    //         .filter(
    //           (data) =>
    //             checkVip(vipList, data.callerNumber || "", showVip).val === 1
    //         )
    //         .map((data) => {
    //           const temp = checkVip(vipList, data.callerNumber || "", showVip);

    //           return {
    //             ...data,
    //             vip: temp.val,
    //             vipName: temp.vipName,
    //           };
    //         }),
    //     });
    //   }
    // }, [rowData, checkVip, vipList, showVip]);

    const queueCallStateHandler = useCallback(
      (queueCallState: QueueCallState) => {
        const queueCalls = (queues.get(queueCallState.queueId)?.calls ||
          new Map()) as Map<string, Call>;

        const call = queueCalls.get(queueCallState.callId);

        if (
          queueCallState.userId !== undefined &&
          queueCallState.state !== "TALKING"
        ) {
          // do nothing
          return null;
        }

        if (!queues.has(queueCallState.queueId)) {
          return null;
        }

        let ringTime = call?.ringTime;

        if (queueCallState.state === "RINGING") {
          const { from, to: { phoneNumber: calleeNumber } = {} } =
            queueCallState;

          if (
            ringTime === undefined ||
            ringTime.getTime() < new Date(queueCallState.time).getTime()
          ) {
            ringTime = new Date(queueCallState.time);
          }

          queueCalls.set(queueCallState.callId, {
            // duration: 0,
            ...queueCalls.get(queueCallState.callId),
            id: queueCallState.callId,
            queueId: queueCallState.queueId,
            ringTime,
            callerNumber: Array.isArray(from)
              ? from[0].phoneNumber
              : from.phoneNumber,
            calleeNumber,
            callerName: Array.isArray(from) ? from[0].name : from.name,
            partyId: queueCallState.partyId,
          });

          queues.set(queueCallState.queueId, {
            ...queues.get(queueCallState.queueId),
            calls: queueCalls,
            id: queueCallState.callId,
          });

          return {
            ...queues.get(queueCallState.queueId),
            ...queueCalls.get(queueCallState.callId),
            callId: queueCallState.callId,
          } as RowData;
        }

        // sometimes the "equal to" is important for simultanesous MISSED/RINGING
        if (
          ringTime !== undefined &&
          (new Date(queueCallState.time).getTime() < ringTime.getTime() ||
            (new Date(queueCallState.time).getTime() === ringTime.getTime() &&
              queueCallState.state === "MISSED"))
        ) {
          return {
            ...queues.get(queueCallState.queueId),
            ...queueCalls.get(queueCallState.callId),
            callId: queueCallState.callId,
          } as RowData;
        }

        queueCalls.delete(queueCallState.callId);

        queues.set(queueCallState.queueId, {
          ...queues.get(queueCallState.queueId),
          calls: queueCalls,
          id: queueCallState.callId,
        });

        return undefined;
      },
      []
    );

    useEffect(() => {
      // process one new real time call event
      // const record = queueCallStates[0];
      // if (record === undefined) {
      //   return;
      // }
      if (queueCallStates.length === 0) {
        return;
      }
      queueCallStates.forEach((record) => {
        if (record.queueId === undefined) {
          return;
        }

        if (unprocessStates === undefined) {
          const newRow = queueCallStateHandler(record);

          if (newRow) {
            if (
              gridRef.current!.api.getRowNode(
                `${record.queueId}-${record.callId}`
              )
            ) {
              // setTimeout(() => {
              try {
                gridRef?.current?.api?.applyTransaction({
                  update: [newRow],
                });
              } catch (e) {
                console.log("update queue transaction");
              }
              // }, 0);
            } else {
              // setTimeout(() => {
              try {
                gridRef?.current?.api?.applyTransaction({
                  add: [newRow],
                });
              } catch (e) {
                console.log("Add queue transaction", e);
              }
              // }, 0);
            }
          } else if (
            newRow === undefined &&
            gridRef.current!.api.getRowNode(
              `${record.queueId}-${record.callId}`
            )
          ) {
            // setTimeout(() => {
            try {
              gridRef?.current?.api?.applyTransaction({
                remove: [{ queueId: record.queueId, callId: record.callId }],
              });
            } catch (e) {
              console.log("Remove queue transaction", e);
            }
            // }, 0);
          }
        } else {
          unprocessStates.push(record);
        }

        // setRowData((oldRowData) => {
        //   if (oldRowData === undefined) {
        //     unprocessStates.push(record);
        //     return undefined;
        //   }
        //   const newRow = queueCallStateHandler(record);

        //   if (oldRowData.find((row) => row.callId === record.callId)) {
        //     return oldRowData.reduce((sum, row) => {
        //       if (record.callId === row.callId) {
        //         if (newRow) {
        //           return sum.concat([newRow]);
        //         }
        //         return sum;
        //       }

        //       return sum.concat([row]);
        //     }, [] as Array<RowData>);
        //   }

        //   if (newRow) {
        //     return oldRowData.concat([newRow]);
        //   }
        //   return oldRowData;
        // });
      });
    }, [queueCallStates, queueCallStateHandler]);

    const columnChanges = useCallback(() => {
      if (gridRef.current?.columnApi === undefined) {
        return;
      }
      localStorage.setItem(
        `queue-summary-waiting`,
        JSON.stringify(gridRef.current!.columnApi.getColumnState())
      );
      // updateLocal(
      //   `queue-summary-waiting`,
      //   JSON.stringify(gridRef.current!.columnApi.getColumnState())
      // );
    }, [gridRef]);

    useEffect(() => {
      if (
        gridReady &&
        local[`queue-summary-waiting`] !== undefined &&
        gridRef.current !== undefined &&
        gridRef.current !== null &&
        gridRef?.current.columnApi !== null
      ) {
        //  applying column state changes from last session
        const raw = local[`queue-summary-waiting`];
        const columnData = raw ? JSON.parse(raw) : [];
        gridRef.current.columnApi.applyColumnState({
          state: columnData,
          applyOrder: true,
        });
      }
    }, [gridReady, local, gridRef]);

    // useEffect(() => {
    //   const data = summaries[0];
    //   if (data === undefined) {
    //     return;
    //   }

    //   data.fakeEvents.forEach(callEventHandler);
    // }, [summaries]);

    // handles spoiled cherry pick calls (failed for some reason, don't show the button again)
    // call waiting tab
    // (with vip)

    // const callEventHandler = useCallback(
    //   (record: CallEvent) => {
    //     // const four = 4;
    //     // if (four === 4) {
    //     //   return;
    //     // }
    //     const queueId = record.body.parties[0].extensionId;
    //     const callId = record.body.telephonySessionId;

    //     // there is a disconnected event with later timestamp
    //     const disconnectedTime = calls.get(`${queueId}-${callId}`);
    //     if (
    //       disconnectedTime &&
    //       new Date(record.body.eventTime).getTime() <
    //         new Date(disconnectedTime).getTime()
    //     ) {
    //       return;
    //     }

    //     let queue: Queue | undefined = queues.get(queueId);

    //     if (queue === undefined) {
    //       queue = unprocessed.get(queueId) || {
    //         id: queueId,
    //         calls: new Map<string, Call>(),
    //       };
    //     }

    //     const queueCalls: Map<string, Call> = new Map(queue?.calls);
    //     const call = queueCalls.get(callId);
    //     let ringTime = call?.ringTime;
    //     let callerNumber = call?.callerNumber;
    //     let callerName = call?.callerName;
    //     let calleeNumber = call?.calleeNumber;
    //     let partyId = call?.partyId;

    //     if (record.body.parties[0].status.code === "Proceeding") {
    //       partyId = record.body.parties[0].id;
    //     }

    //     if (record.body.parties[0].status.code === "Setup") {
    //       if (
    //         callerName === undefined &&
    //         record.body.parties[0].queue &&
    //         record.body.parties[0].from?.name
    //       ) {
    //         callerName = record.body.parties[0].from?.name;
    //       }
    //     }

    //     // call is still ongoing
    //     if (
    //       (disconnectedTime &&
    //         new Date(record.body.eventTime).getTime() >
    //           new Date(disconnectedTime).getTime()) ||
    //       !disconnectedTime
    //     ) {
    //       // use earliest ring time
    //       if (
    //         ringTime === undefined ||
    //         new Date(ringTime).getTime() >
    //           new Date(record.body.eventTime).getTime()
    //       ) {
    //         ringTime = record.body.eventTime;
    //       }
    //     }

    //     if (
    //       callerNumber === undefined &&
    //       record.body.parties[0].queue &&
    //       record.body.parties[0].from?.phoneNumber
    //     ) {
    //       callerNumber = record.body.parties[0].from?.phoneNumber;
    //     }

    //     if (
    //       calleeNumber === undefined &&
    //       record.body.parties[0].queue &&
    //       record.body.parties[0].to?.phoneNumber
    //     ) {
    //       calleeNumber = record.body.parties[0].to?.phoneNumber;
    //     }

    //     queueCalls.set(callId, {
    //       id: callId,
    //       queueId,
    //       ringTime,
    //       callerNumber,
    //       callerName,
    //       calleeNumber,
    //       partyId,
    //     });

    //     if (
    //       record.body.parties[0].status.code === "Voicemail" ||
    //       record.body.parties[0].status.code === "Disconnected"
    //     ) {
    //       if (ringTime !== undefined && record.body.eventTime < ringTime) {
    //         // old event - do not update anything
    //       } else {
    //         const disconnected = calls.get(`${queueId}-${callId}`);
    //         if (
    //           disconnected === undefined ||
    //           disconnected < record.body.eventTime
    //         ) {
    //           calls.set(`${queueId}-${callId}`, record.body.eventTime);
    //           queueCalls.delete(callId);
    //           setSpoiledCherryPickCalls(
    //             (oldSpoiledCherryPickCalls: Set<string>) => {
    //               const mySet = new Set(oldSpoiledCherryPickCalls);
    //               mySet.delete(callId);
    //               return mySet;
    //             }
    //           );
    //         }
    //       }
    //     }

    //     if (queues.get(queueId) === undefined) {
    //       unprocessed.set(queueId, {
    //         ...queue,
    //         calls: queueCalls,
    //       });
    //     } else {
    //       queues.set(queueId, { ...queue, calls: queueCalls });
    //     }

    //     setRowData((oldRowData) => {
    //       if (oldRowData === undefined) {
    //         return undefined;
    //       }
    //       unprocessed.clear();

    //       const waitingCalls = [] as Array<{
    //         callId: string;
    //         partyId?: string;
    //         queueId: string;
    //         name?: string;
    //         extensionNumber?: string;
    //         callerNumber?: string;
    //         callerName?: string;
    //         calleeNumber?: string;
    //         vip: number;
    //         vipName?: string;
    //         duration: number;
    //       }>;

    //       Array.from(queues.values())
    //         .filter((myQueue: Queue) => {
    //           if (excludedQueues && excludedQueues.has(myQueue.id)) {
    //             return false;
    //           }
    //           return true;
    //         })
    //         .forEach((myQueue: Queue) => {
    //           Array.from((myQueue.calls || new Map()).values()).forEach(
    //             (myCall: Call) => {
    //               if (myCall.ringTime) {
    //                 const name = myQueue.name || "";
    //                 const extensionNumber = myQueue.extensionNumber || "";
    //                 const temp: { val: number; vipName: string } = checkVip(
    //                   vipList,
    //                   myCall.callerNumber || "",
    //                   showVip
    //                 );
    //                 const vip =
    //                   myCall.vip !== undefined ? myCall.vip : temp.val;
    //                 const vipName =
    //                   myCall.vipName !== undefined
    //                     ? myCall.vipName
    //                     : temp.vipName;
    //                 waitingCalls.push({
    //                   callId: myCall.id,
    //                   partyId: spoiledCherryPickCalls.has(myCall.id)
    //                     ? undefined
    //                     : myCall.partyId,
    //                   // partyId: myCall.partyId,
    //                   queueId: myQueue.id,
    //                   name,
    //                   extensionNumber,
    //                   vip,
    //                   vipName,
    //                   callerNumber: myCall.callerNumber,
    //                   callerName: myCall.callerName,
    //                   calleeNumber: myCall.calleeNumber,
    //                   duration: Math.round(
    //                     (new Date().getTime() +
    //                       offset -
    //                       new Date(myCall.ringTime).getTime()) /
    //                       1000
    //                   ),
    //                 });
    //               }
    //             }
    //           );
    //         });

    //       return waitingCalls;
    //     });
    //   },
    //   [offset, spoiledCherryPickCalls, vipList]
    // );

    const initialize = useCallback(() => {
      if (unprocessStates === undefined) {
        return;
      }

      if (!gridRef.current!.api) {
        return;
      }

      const newRows = new Map<string, RowData>(new Map());

      // if (unprocessStates.length === 0) {
      //   gridRef.current!.api?.applyTransaction({
      //     add: [],
      //   });
      // }

      unprocessStates.forEach((record) => {
        // setRowData((oldRowData = []) => {
        //   const newRow = queueCallStateHandler(record);

        //   if (oldRowData.find((row) => row.callId === record.callId)) {
        //     return oldRowData.reduce((sum, row) => {
        //       if (record.callId === row.callId) {
        //         if (newRow) {
        //           return sum.concat([newRow]);
        //         }
        //         return sum;
        //       }

        //       return sum.concat([row]);
        //     }, [] as Array<RowData>);
        //   }

        //   if (newRow) {
        //     return oldRowData.concat([newRow]);
        //   }
        //   return oldRowData;
        // });

        const newRow = queueCallStateHandler(record);

        if (newRow) {
          newRows.set(`${record.queueId}-${record.callId}`, newRow);
        } else if (newRow === undefined) {
          newRows.delete(`${record.queueId}-${record.callId}`);
        }
      });

      const add = Array.from(newRows.keys())
        .filter((key) => !gridRef.current!.api?.getRowNode(key))
        .map((key) => newRows.get(key));
      const update = Array.from(newRows.keys())
        .filter((key) => gridRef.current!.api?.getRowNode(key))
        .map((key) => newRows.get(key));

      if (add.length || update.length) {
        // setTimeout(() => {
        try {
          gridRef?.current?.api?.applyTransaction({
            add: add.length ? add : undefined,
            update: update.length ? update : undefined,
          });
        } catch (e) {
          console.log("Add/update transaction", e);
        }
        // }, 0);
      }

      unprocessStates = undefined;
    }, [queueCallStateHandler]);

    useEffect(() => {
      // load historical data
      const data = historicals[0];
      if (data !== undefined) {
        // data.event.forEach(callEventHandler);

        data.queue.forEach((queue) => {
          // const subQueueInfo = unprocessed.get(queue.id);

          // const myCalls = [];

          queues.set(queue.id, {
            id: queue.id,
            name: queue.name,
            extensionNumber: queue.extensionNumber,
            calls: new Map(),
          });
        });

        initialize();

        // unprocessed.clear();

        // const disconnected = [
        //   ...answered,
        //   ...abandoned,
        //   ...missed,
        //   ...voicemail,
        // ];

        // disconnected.forEach(([queueId, queueCalls]) => {
        //   const myQueue = queues.get(queueId);
        //   const myQueueCalls = myQueue?.calls || new Map();
        //   queueCalls.forEach((call) => {
        //     calls.add(call[0]);
        //     myQueueCalls.delete(call[0]);
        //   });
        // });

        // setRowData(
        //   () =>
        // const waitingCalls = [] as Array<{
        //   callId: string;
        //   partyId?: string;
        //   queueId: string;
        //   name?: string;
        //   extensionNumber?: string;
        //   vip: number;
        //   vipName: string;
        //   callerNumber?: string;
        //   callerName?: string;
        //   calleeNumber?: string;
        //   duration: number;
        // }>;

        // Array.from(queues.values()).reduce((sum, queue) => {
        //   let row: RowData | undefined;

        //   unprocessStates
        //     .filter((unprocess) => unprocess.queueId === queue.id)
        //     .forEach((queueCallState) => {
        //       row = queueCallStateHandler(queueCallState);
        //       console.log(row);
        //     });

        //   if (row) {
        //     return sum.concat([row]);
        //   }

        //   return sum;
        // }, [] as Array<RowData>)

        // setRowData((oldRowData = []) => oldRowData);

        // .filter((queue) => {
        //   if (excludedQueues && excludedQueues.has(queue.id)) {
        //     return false;
        //   }
        //   return true;
        // })
        // .forEach((queue: Queue) => {
        //   Array.from((queue.calls || new Map()).values()).forEach(
        //     (call: Call) => {
        //       if (call.ringTime) {
        //         const name = queue.name || "";
        //         const extensionNumber = queue.extensionNumber || "";
        //         const temp: { val: number; vipName: string } = checkVip(
        //           vipList,
        //           call.callerNumber || "",
        //           showVip
        //         );
        //         const vip = call.vip !== undefined ? call.vip : temp.val;
        //         const vipName =
        //           call.vipName !== undefined ? call.vipName : temp.vipName;
        //         waitingCalls.push({
        //           callId: call.id,
        //           partyId: spoiledCherryPickCalls.has(call.id)
        //             ? undefined
        //             : call.partyId,
        //           // partyId: call.partyId,
        //           queueId: queue.id,
        //           name,
        //           extensionNumber,
        //           vip,
        //           vipName,
        //           callerNumber: call.callerNumber,
        //           callerName: call.callerName,
        //           calleeNumber: call.calleeNumber,
        //           duration: Math.round(
        //             (new Date().getTime() +
        //               offset -
        //               new Date(call.ringTime).getTime()) /
        //               1000
        //           ),
        //         });
        //       }
        //     }
        //   );
        // })

        // return waitingCalls;
        // );
      }
    }, [
      historicals,
      initialize,
      // rowData,
      // callEventHandler,
      // offset,
      // spoiledCherryPickCalls,
      // vipList,
    ]);

    // useEffect(() => {
    //   setRowData((oldRowData) => {
    //     if (oldRowData === undefined) {
    //       return undefined;
    //     }

    //     const waitingCalls = [] as Array<{
    //       callId: string;
    //       partyId?: string;
    //       queueId: string;
    //       name?: string;
    //       extensionNumber?: string;
    //       vip: number;
    //       vipName: string;
    //       callerNumber?: string;
    //       callerName?: string;
    //       calleeNumber?: string;
    //       duration: number;
    //     }>;

    //     Array.from(queues.values())
    //       .filter((queue) => {
    //         if (excludedQueues && excludedQueues.has(queue.id)) {
    //           return false;
    //         }
    //         return true;
    //       })
    //       .forEach((myQueue: Queue) => {
    //         Array.from((myQueue.calls || new Map()).values()).forEach(
    //           (myCall: Call) => {
    //             if (myCall.ringTime) {
    //               const name = myQueue.name || "";
    //               const extensionNumber = myQueue.extensionNumber || "";
    //               const temp: { val: number; vipName: string } = checkVip(
    //                 vipList,
    //                 myCall.callerNumber || "",
    //                 showVip
    //               );
    //               const vip = myCall.vip !== undefined ? myCall.vip : temp.val;
    //               const vipName =
    //                 myCall.vipName !== undefined
    //                   ? myCall.vipName
    //                   : temp.vipName;
    //               waitingCalls.push({
    //                 callId: myCall.id,
    //                 partyId: spoiledCherryPickCalls.has(myCall.id)
    //                   ? undefined
    //                   : myCall.partyId,
    //                 // partyId: myCall.partyId,
    //                 queueId: myQueue.id,
    //                 name,
    //                 extensionNumber,
    //                 vip,
    //                 vipName,
    //                 callerNumber: myCall.callerNumber,
    //                 callerName: myCall.callerName,
    //                 calleeNumber: myCall.calleeNumber,
    //                 duration: Math.round(
    //                   (new Date().getTime() +
    //                     offset -
    //                     new Date(myCall.ringTime).getTime()) /
    //                     1000
    //                 ),
    //               });
    //             }
    //           }
    //         );
    //       });

    //     return waitingCalls;
    //   });
    // }, [excludedQueues, offset, spoiledCherryPickCalls, vipList]);

    // useEffect(() => {
    //   // process one new real time call event
    //   const record = callEvents[0];
    //   if (record === undefined) {
    //     return;
    //   }

    //   callEventHandler(record);
    // }, [callEvents, callEventHandler]);

    const clickOnCsvExport = useCallback(() => {
      gridRef.current!.api.exportDataAsCsv();
      setAnchorExport(null);
    }, []);

    const clickOnExcelExport = useCallback(() => {
      gridRef.current!.api.exportDataAsExcel();
      setAnchorExport(null);
    }, []);

    const handleCloseError = useCallback(
      () => setErrorWaitingTab(undefined),
      []
    );
    const rowClassRules = {
      "row-highlight": (params: any) => params.data?.vip === '1',
    };
    return (
      <div>
        <Toolbar
          disableGutters
          variant="dense"
          style={{
            minHeight: "50px",
            backgroundColor: mode === "dark" ? "#181818" : "#0684bd",
          }}
        >
          <Grid container>
            <Grid item xs={5} style={{ display: "flex", alignItems: "center" }}>
              <Typography
                // component="div"
                style={{
                  textAlign: "left",
                  // flexGrow: 1,
                  color: "white",
                  fontSize: "0.85rem",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() => setExpandLeaderboard(!expandLeaderboard)}
                >
                  {expandLeaderboard ? (
                    <ExpandLess style={{ color: "white" }} />
                  ) : (
                    <ExpandMore style={{ color: "white" }} />
                  )}
                </IconButton>
                Leaderboard
                {gridRef &&
                  gridRef.current &&
                  gridRef.current.api &&
                  Object?.keys(gridRef.current?.api?.getFilterModel() || {})
                    ?.length > 0 && (
                    <button
                      type="button"
                      style={{
                        cursor: "pointer",
                        background: "none",
                        border: "none",
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "agGridAlpine",
                          color: "white",
                          fontSize: "1.4em",
                        }}
                        className="ag-theme-alpine ag-icon-filter"
                      />
                    </button>
                  )}
              </Typography>
            </Grid>
            {expandLeaderboard && (
              <Grid
                container
                item
                xs={7}
                justifyContent="flex-end"
                alignItems="center"
                style={{ paddingRight: "10px", paddingLeft: "10px" }}
              >
                <Button
                  id="queue-leaderboard-download"
                  onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
                    setAnchorExport(e.currentTarget)
                  }
                  aria-controls={openExport ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openExport ? "true" : undefined}
                  size="small"
                  style={{
                    height: "32px",
                    width: "32px",
                    minWidth: "24px",
                  }}
                >
                  <GetApp style={{ color: "white" }} />
                </Button>

                <Button
                  size="small"
                  style={{
                    height: "32px",
                    width: "32px",
                    minWidth: "24px",
                    marginLeft: "10px",
                  }}
                  onClick={larger}
                >
                  <UnfoldMore style={{ color: "white" }} />
                </Button>
                <Button
                  size="small"
                  style={{ height: "32px", width: "32px", minWidth: "24px" }}
                  onClick={smaller}
                >
                  <UnfoldLess style={{ color: "white" }} />
                </Button>
                <Button
                  onClick={increaseFont}
                  size="small"
                  style={{
                    height: "32px",
                    width: "32px",
                    minWidth: "24px",
                    marginLeft: "10px",
                  }}
                >
                  <TextFormat style={{ fontSize: "1.8rem", color: "white" }} />
                </Button>
                <Button
                  onClick={decreaseFont}
                  size="small"
                  style={{ height: "32px", width: "32px", minWidth: "24px" }}
                >
                  <TextFormat fontSize="small" style={{ color: "white" }} />
                </Button>
              </Grid>
            )}
          </Grid>
        </Toolbar>
        <Menu
          classes={{ paper: classes.menuPaper }}
          anchorEl={anchorExport}
          id="basic-menu"
          open={openExport}
          getContentAnchorEl={null}
          // transformOrigin={{ horizontal: 'left', vertical: 'top' }}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
          onClose={() => setAnchorExport(null)}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem
            id="queue-leaderboard-download-csv"
            className={classes.menuItem}
            onClick={clickOnCsvExport}
          >
            CSV Export
          </MenuItem>
          <MenuItem
            id="queue-leaderboard-download-excel"
            className={classes.menuItem}
            onClick={clickOnExcelExport}
          >
            Excel Export
          </MenuItem>
          {/* <MenuItem className={classes.menuItem} onClick={clickOnPdfExport}>
            PDF Export
          </MenuItem> */}
        </Menu>
        <Dialog
          classes={{ paper: classes.dialog }}
          open={errorWaitingTab !== undefined}
          fullWidth
          onClose={handleCloseError}
          aria-labelledby="error-waiting-tab"
        >
          {" "}
          <DialogTitle id="error-waiting-tab">Error</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Typography
                component="span"
                style={{ fontSize: "0.8rem" }}
                className={classes.typography}
              >
                {errorWaitingTab}
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={handleCloseError}
              color={mode === "dark" ? "default" : "primary"}
              variant="contained"
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Collapse in={expandLeaderboard} timeout="auto">
          <div style={{ width: "100%", height: `${verticalPercent}vh` }}>
            <AgGridReact
              isExternalFilterPresent={() => true}
              doesExternalFilterPass={(row) =>
                excludedQueues === undefined
                  ? true
                  : !excludedQueues.has((row.data as RowData).queueId)
              }
              suppressCopyRowsToClipboard
              suppressLoadingOverlay
              detailRowHeight={200}
              onGridReady={() => {
                setGridReady(true);
                initialize();
              }}
              // @ts-expect-error
              onRowDataUpdated={(event: RowDataUpdatedEvent<RowData>) => {
                const vip = [] as Array<RowData>;

                event.api.forEachNode((node: { data: RowData }) => {
                  if (!node.data.vip) {
                    const temp = checkVip(
                      vipList,
                      node.data.callerNumber || "",
                      showVip
                    );

                    if (temp.val === 1) {
                      vip.push({
                        ...node.data,
                        vip: temp.val,
                        vipName: temp.vipName,
                      });

                      const myCalls =
                        queues.get(node.data.queueId)?.calls || new Map();

                      myCalls.set(node.data.callId, {
                        ...myCalls.get(node.data.callId),
                        id: node.data.callId,
                        vip: temp.val,
                        vipName: temp.vipName,
                      });

                      queues.set(node.data.queueId, {
                        ...queues.get(node.data.queueId),
                        calls: myCalls,
                        id: node.data.queueId,
                      });
                    }
                  }
                });

                if (vip.length) {
                  // setTimeout(() => {
                  try {
                    event?.api?.applyTransaction({
                      update: vip,
                    });
                  } catch (e) {
                    console.log("Transaction in render cycle", e);
                  }
                  // }, 0);
                }
              }}
              ref={gridRef} // Ref for accessing Grid's API
              // rowData={[]} // Row Data for Rows
              columnDefs={columnDefs} // Column Defs for Columns
              defaultColDef={defaultColDef} // Default Column Properties
              animateRows // Optional - set to 'true' to have rows animate when sorted
              rowSelection="multiple" // Options - allows click selection of rows
              getRowId={getRowId}
              rowClassRules={rowClassRules}
              onSortChanged={columnChanges}
              onColumnMoved={columnChanges}
              onColumnVisible={columnChanges}
              onColumnPinned={columnChanges}
              onColumnResized={columnChanges}
              onFilterChanged={() => {
                if (
                  queueSelectedTab === "waiting" &&
                  gridReady &&
                  gridRef.current &&
                  hudTab === "queues"
                ) {
                  setActiveFilterRef(gridRef.current?.api?.getFilterModel());
                }
              }}
              pagination
              paginationAutoPageSize
              rowHeight={28}
              sideBar={{
                toolPanels: [
                  "filters",
                  {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel",
                    toolPanelParams: {
                      suppressRowGroups: true,
                      suppressValues: true,
                      suppressPivots: true,
                      suppressPivotMode: true,
                      suppressColumnFilter: true,
                      suppressColumnSelectAll: true,
                      suppressColumnExpandAll: true,
                    },
                  },
                ],
              }}
              // frameworkComponents={{
              //   BtnCellRenderer,
              // }}
            />
          </div>
        </Collapse>
      </div>
    );
  };
})();

const QueueInProgress = (() => {
  interface User {
    id: string;
    lastName: string;
    firstName: string;
    extensionNumber: string;
  }

  interface Queue {
    extensionNumber?: string;
    name?: string;
    id: string;
    // calls?: Map<string, Call>;
  }

  interface Call {
    callId: string;
    queueId?: string;
    callerNumber?: string;
    callerName?: string;
    userId: string;
    status?: "Talking" | "On Hold" | "Not In Progress" | "Complete";
    stateStartTime?: string;
    sequence: Array<number>;
    vip?: number;
    vipName?: string;
    calleeNumber?: string;
  }

  function durationFormatter(params: ValueFormatterParams) {
    if (params.value === undefined) return "--:--";
    return `${Math.floor(params.value / 60)
      .toString()
      .padStart(2, "0")}:${(params.value % 60).toString().padStart(2, "0")}`;
  }

  function vipCheck(params: ValueFormatterParams) {
    if (params.value) {
      return "Yes";
    }
    return "No";
  }

  function regexCheck(str: string, number: string): boolean {
    const escapeRegex = (s: string): string =>
      s.replace(/([.+^=!:${}()|\\])/g, "\\$1");

    const temp = "^".concat(number.split("*").map(escapeRegex).join(".*"), "$");
    const r = new RegExp(temp.split("?").join("."));

    return r.test(str);
  }

  function checkVip(
    vipList: Array<any>,
    number: string,
    showVip: boolean
  ): { val: number; vipName: string } {
    let val = 0;
    let vipName: string = "";
    if (vipList.length) {
      vipList.forEach((vip: any) => {
        const temp = regexCheck(number, vip.number);
        if (temp && showVip) {
          val = 1;
          vipName = vip.name;
        }
      });
    }
    return { val, vipName };
  }

  const users = new Map<string, User>();
  const queues = new Map<string, Queue>();

  // queues data stored before historical load
  // const unprocessed = new Map<string, Queue>();

  const calls = new Map<string, Call>();

  // calls finished
  // const finishedCalls = new Set<string>();
  // const userCalls = new Map<string, Call>();

  return ({
    historicals,
    queueCallStates,
    expandLeaderboard,
    setExpandLeaderboard,
    smaller,
    larger,
    mode,
    verticalPercent,
    fontSize,
    increaseFont,
    decreaseFont,
    excludedQueues,
    local,
    updateLocal,
    offset,
    summaries,
    vipList,
    showVip,
    setInProgressCount,
    setActiveFilterRef,
    queueSelectedTab,
    navTab,
    navPage,
    hudTab,
    page,
  }: {
    historicals: Array<Historical>;
    queueCallStates: Array<QueueCallState>;
    expandLeaderboard: boolean;
    setExpandLeaderboard: any;
    smaller: any;
    larger: any;
    mode: string;
    verticalPercent: number;
    fontSize: string;
    increaseFont: any;
    decreaseFont: any;
    excludedQueues: Set<string> | undefined;
    local: any;
    updateLocal: any;
    summaries: Array<Summary>;
    vipList: any;
    showVip: boolean;
    setInProgressCount: any;
    setActiveFilterRef: React.Dispatch<
      SetStateAction<{ [colId: string]: any }>
    >;
    queueSelectedTab: string;
    page: string;
    hudTab: string;
    offset: number;
    navTab: string;
    navPage: string;
  }) => {
    // eslint-disable-next-line
    const classes = mode === "light" ? useStyles() : useDarkStyles();
    const gridRef = useRef<AgGridReact>(null); // Optional - for accessing Grid's API
    const [rowData, setRowData] = useState<
      | Array<{
          callId: string;
          queueId: string;
          name?: string;
          extensionNumber?: string;
          callerNumber?: string;
          callerName?: string;
          duration: number;
          vip: number;
          vipName: string;
          userId?: string;
          userName?: string;
          agentExtension?: string;
          status?: "Talking" | "On Hold";
          calleeNumber?: string;
        }>
      | undefined
    >(); // Set rowData to Array of Objects, one Object per Row

    useEffect(() => {
      setInProgressCount(rowData?.length || 0);
    }, [rowData]);

    // Each Column Definition results in one Column.
    const [columnDefs, setColumnDefs] = useState([
      {
        field: "vipName",
        headerName: "VIP Name",
        cellClass: "notranslate",
        filter: true,
        hide: !showVip,
      },
      {
        field: "extensionNumber",
        filter: true,
        pinned: true,
        cellClass: "notranslate",
      },
      { field: "name", filter: true, cellClass: "notranslate" },
      { field: "callerNumber", filter: true, cellClass: "notranslate" },
      { field: "callerName", filter: true, cellClass: "notranslate" },
      {
        field: "calleeNumber",
        headerName: "Callee Number",
        cellClass: "notranslate",
        filter: true,
      },
      {
        field: "duration",
        valueFormatter: durationFormatter,
        filter: true,
        cellClass: "notranslate",
      },
      {
        field: "vip",
        headerName: "VIP",
        cellClass: "notranslate",
        valueFormatter: vipCheck,
        hide: !showVip,
        filter: true,
      },
      { field: "status", filter: true, cellClass: "notranslate" },
      {
        field: "userName",
        headerName: "Agent",
        cellClass: "notranslate",
        filter: true,
      },
      {
        field: "userExtension",
        headerName: "Agent Extension",
        cellClass: "notranslate",
        filter: true,
      },
    ]);
    const [anchorExport, setAnchorExport] = useState<null | HTMLElement>(null);
    const openExport = Boolean(anchorExport);
    const [gridReady, setGridReady] = useState(false);
    // const [gridReady, setGridReady] = useState<boolean>(false);
    // DefaultColDef sets props common to all Columns
    const defaultColDef = useMemo(
      () => ({
        sortable: true,
        resizable: true,
        animateRows: false,
        cellClass: " notarnslate ",
        cellClassRules: {
          small: () => fontSize === "small",
          medium: () => fontSize === "medium",
          large: () => fontSize === "large",
        },
      }),
      [fontSize]
    );

    const getRowId = useMemo(
      () => (params: GetRowIdParams) =>
        `${params.data.userId}-${params.data.callId}`,
      []
    );

    useEffect(() => {
      if (
        queueSelectedTab === "inProgress" &&
        page === "hud" &&
        navTab === "queues" &&
        gridReady &&
        gridRef.current
      ) {
        setActiveFilterRef(gridRef.current.api.getFilterModel());
      }
    }, [gridReady, gridRef, queueSelectedTab, navPage, navTab, page, hudTab]);

    useEffect(() => {
      let timeout: any;

      const calculateDuration = () => {
        setRowData((oldRowData) =>
          oldRowData?.map((row) => {
            const call = calls.get(`${row.userId}-${row.callId}`);
            const stateStartTime = call?.stateStartTime;
            return {
              ...row,
              duration: stateStartTime
                ? Math.round(
                    (new Date().getTime() +
                      offset -
                      new Date(stateStartTime).getTime()) /
                      1000
                  )
                : 0,
            };
          })
        );

        timeout = setTimeout(calculateDuration, 1000);
      };

      calculateDuration();

      return () => {
        clearTimeout(timeout);
      };
    }, [offset]);

    const queueCallStateHandler = useCallback(
      (record: QueueCallState) => {
        const { callId, userId, sequence, queueId, state, time, from, to } =
          record;

        if (userId === undefined) {
          return;
        }
        const myCall: Call = calls.get(`${userId}-${callId}`) || {
          callId,
          userId,
          sequence: [],
        };
        const latestSeqNo = myCall.sequence.sort((a, b) => b - a)[0];
        myCall.sequence.push(sequence);
        const eventsNumber = myCall.sequence.length;
        // new number is later
        if (latestSeqNo === undefined || sequence > latestSeqNo) {
          myCall.queueId = queueId;
          myCall.stateStartTime = time;
          myCall.callerNumber = Array.isArray(from)
            ? from[0].phoneNumber
            : from.phoneNumber;
          myCall.calleeNumber = to?.phoneNumber;
          myCall.callerName = Array.isArray(from) ? from[0].name : from.name;
          const temp: { val: number; vipName: string } = checkVip(
            vipList,
            Array.isArray(from) ? from[0].phoneNumber : from.phoneNumber,
            showVip
          );
          myCall.vip = myCall.vip !== undefined ? myCall.vip : temp.val;
          myCall.vipName =
            myCall.vipName !== undefined ? myCall.vipName : temp.vipName;
          if (state === "TALKING") {
            myCall.status = "Talking";
          } else if (state === "HOLDING") {
            myCall.status = "On Hold";
          } else if (state === "COMPLETE") {
            myCall.status = "Complete";
          } else {
            myCall.status = "Not In Progress";
          }

          if (state !== "COMPLETE") {
            // store the call
            calls.set(`${userId}-${callId}`, myCall);
          } else {
            // check if the new sequence has a gap
            myCall.sequence.sort((a, b) => a - b);
            if (
              eventsNumber - 1 ===
              myCall.sequence[eventsNumber - 1] - myCall.sequence[0]
            ) {
              // no gap
              calls.delete(`${userId}-${callId}`);
            } else {
              // there is a gap
              calls.set(`${userId}-${callId}`, myCall);
            }
          }
        } else if (myCall.status !== "Complete") {
          // new number is older and not complete
          calls.set(`${userId}-${callId}`, myCall);
        } else if (
          // new number is older and complete and no gap
          eventsNumber - 1 ===
          myCall.sequence[eventsNumber - 1] - myCall.sequence[0]
        ) {
          calls.delete(`${userId}-${callId}`);
        } else {
          // there is a gap
          calls.set(`${userId}-${callId}`, myCall);
        }

        setRowData((oldRowData) => {
          if (oldRowData === undefined) {
            return undefined;
          }
          const progressCalls = [] as Array<{
            callId: string;
            queueId: string;
            name?: string;
            extensionNumber?: string;
            callerNumber?: string;
            callerName?: string;
            calleeNumber?: string;
            userId?: string;
            userName?: string;
            userExtension?: string;
            vip: number;
            vipName: string;
            duration: number;
            status?: "Talking" | "On Hold";
          }>;

          Array.from(calls.values())
            .filter((call) => {
              if (
                call.queueId === undefined ||
                (excludedQueues && excludedQueues.has(call.queueId))
              ) {
                return false;
              }
              return true;
            })
            .forEach((call: Call) => {
              if (
                call.queueId === undefined ||
                queues.get(call.queueId) === undefined
              ) {
                return;
              }
              const queue = queues.get(call.queueId);
              const firstName = users.get(call.userId)?.firstName;
              const lastName = users.get(call.userId)?.lastName;
              const userExtension = users.get(call.userId)?.extensionNumber;
              if (
                call.stateStartTime &&
                (call.status === "Talking" || call.status === "On Hold")
              ) {
                const temp: { val: number; vipName: string } = checkVip(
                  vipList,
                  call.callerNumber || "",
                  showVip
                );
                progressCalls.push({
                  callId: call.callId,
                  queueId: call.queueId,
                  name: queue?.name,
                  extensionNumber: queue?.extensionNumber,
                  userId: call.userId,
                  userName: `${firstName} ${lastName}`,
                  userExtension,
                  vip: call.vip !== undefined ? call.vip : temp.val,
                  vipName:
                    call.vipName !== undefined ? call.vipName : temp.vipName,
                  callerNumber: call.callerNumber,
                  callerName: call.callerName,
                  calleeNumber: call.calleeNumber,
                  duration: Math.round(
                    (new Date().getTime() +
                      offset -
                      new Date(call.stateStartTime).getTime()) /
                      1000
                  ),
                  status: call.status,
                });
              }
            });

          return progressCalls;
        });
      },
      [vipList]
    );

    useEffect(() => {
      const data = summaries[0];
      if (data === undefined) {
        return;
      }

      data.queueCallState.forEach(queueCallStateHandler);
    }, [summaries]);

    useEffect(() => {
      // load historical data
      const data = historicals[0];
      if (data === undefined) {
        return;
      }
      data.queue.forEach((queue) => {
        queues.set(queue.id, {
          id: queue.id,
          name: queue.name,
          extensionNumber: queue.extensionNumber,
        });
      });

      data.user.forEach((user) => {
        users.set(user.id, {
          id: user.id,
          lastName: user.lastName,
          firstName: user.firstName,
          extensionNumber: user.extensionNumber,
        });
      });
      setRowData(() => {
        const progressCalls = [] as Array<{
          callId: string;
          queueId: string;
          name?: string;
          extensionNumber?: string;
          callerNumber?: string;
          callerName?: string;
          calleeNumber?: string;
          userId?: string;
          userName?: string;
          userExtension?: string;
          duration: number;
          vip: number;
          vipName: string;
          status?: "Talking" | "On Hold";
        }>;

        Array.from(calls.values())
          .filter((call) => {
            if (
              call.queueId === undefined ||
              (excludedQueues && excludedQueues.has(call.queueId))
            ) {
              return false;
            }
            return true;
          })
          .forEach((call: Call) => {
            if (
              call.queueId === undefined ||
              queues.get(call.queueId) === undefined
            ) {
              return;
            }
            const queue = queues.get(call.queueId);
            const firstName = users.get(call.userId)?.firstName;
            const lastName = users.get(call.userId)?.lastName;
            const userExtension = users.get(call.userId)?.extensionNumber;

            if (
              call.stateStartTime &&
              (call.status === "Talking" || call.status === "On Hold")
            ) {
              const temp: { val: number; vipName: string } = checkVip(
                vipList,
                call.callerNumber || "",
                showVip
              );
              progressCalls.push({
                callId: call.callId,
                queueId: call.queueId,
                name: queue?.name,
                extensionNumber: queue?.extensionNumber,
                userId: call.userId,
                userName: `${firstName} ${lastName}`,
                vip: call.vip !== undefined ? call.vip : temp.val,
                vipName:
                  call.vipName !== undefined ? call.vipName : temp.vipName,
                userExtension,
                callerNumber: call.callerNumber,
                callerName: call.callerName,
                calleeNumber: call.calleeNumber,
                duration: Math.round(
                  (new Date().getTime() +
                    offset -
                    new Date(call.stateStartTime).getTime()) /
                    1000
                ),
                status: call.status,
              });
            }
          });

        return progressCalls;
      });
    }, [historicals, offset, vipList]);

    useEffect(() => {
      setRowData((oldRowData) => {
        if (oldRowData === undefined) {
          return undefined;
        }

        const progressCalls = [] as Array<{
          callId: string;
          queueId: string;
          name?: string;
          extensionNumber?: string;
          callerNumber?: string;
          callerName?: string;
          calleeNumber?: string;
          userId?: string;
          userName?: string;
          vip: number;
          vipName: string;
          userExtension?: string;
          duration: number;
          status?: "Talking" | "On Hold";
        }>;

        Array.from(calls.values())
          .filter((call) => {
            if (
              call.queueId === undefined ||
              (excludedQueues && excludedQueues.has(call.queueId))
            ) {
              return false;
            }
            return true;
          })
          .forEach((call: Call) => {
            if (
              call.queueId === undefined ||
              queues.get(call.queueId) === undefined
            ) {
              return;
            }
            const queue = queues.get(call.queueId);
            const firstName = users.get(call.userId)?.firstName;
            const lastName = users.get(call.userId)?.lastName;
            const userExtension = users.get(call.userId)?.extensionNumber;
            if (
              call.stateStartTime &&
              (call.status === "Talking" || call.status === "On Hold")
            ) {
              const temp: { val: number; vipName: string } = checkVip(
                vipList,
                call.callerNumber || "",
                showVip
              );
              progressCalls.push({
                callId: call.callId,
                queueId: call.queueId,
                name: queue?.name,
                extensionNumber: queue?.extensionNumber,
                userId: call.userId,
                userName: `${firstName} ${lastName}`,
                vip: call.vip !== undefined ? call.vip : temp.val,
                vipName:
                  call.vipName !== undefined ? call.vipName : temp.vipName,
                userExtension,
                callerNumber: call.callerNumber,
                callerName: call.callerName,
                calleeNumber: call.calleeNumber,
                duration: Math.round(
                  (new Date().getTime() +
                    offset -
                    new Date(call.stateStartTime).getTime()) /
                    1000
                ),
                status: call.status,
              });
            }
          });
        return progressCalls;
      });
    }, [excludedQueues, offset, vipList]);

    useEffect(() => {
      // process one new real time call event
      // const record = queueCallStates[0];
      // if (record === undefined) {
      //   return;
      // }
      queueCallStates.forEach((record) => {
        queueCallStateHandler(record);
      });
    }, [queueCallStates, queueCallStateHandler]);

    const columnChanges = useCallback(() => {
      if (gridRef.current?.columnApi === undefined) {
        return;
      }
      localStorage.setItem(
        `queue-summary-in-progress`,
        JSON.stringify(gridRef.current!.columnApi.getColumnState())
      );
      // updateLocal(
      //   `queue-summary-in-progress`,
      //   JSON.stringify(gridRef.current!.columnApi.getColumnState())
      // );
    }, [gridRef]);

    useEffect(() => {
      if (
        gridReady &&
        local[`queue-summary-in-progress`] !== undefined &&
        gridRef.current !== undefined &&
        gridRef.current !== null &&
        gridRef?.current.columnApi !== null
      ) {
        //  applying column state changes from last session
        const raw = local[`queue-summary-in-progress`];
        const columnData = raw ? JSON.parse(raw) : [];
        gridRef.current.columnApi.applyColumnState({
          state: columnData,
          applyOrder: true,
        });
      }
    }, [gridReady, local, gridRef]);

    const clickOnCsvExport = useCallback(() => {
      gridRef.current!.api.exportDataAsCsv();
      setAnchorExport(null);
    }, []);

    const clickOnExcelExport = useCallback(() => {
      gridRef.current!.api.exportDataAsExcel();
      setAnchorExport(null);
    }, []);
    const rowClassRules = {
      "row-highlight": (params: any) => params.data?.vip === '1',
    };
    return (
      <div>
        <Toolbar
          disableGutters
          variant="dense"
          style={{
            minHeight: "50px",
            backgroundColor: mode === "dark" ? "#181818" : "#0684bd",
          }}
        >
          <Grid container>
            <Grid item xs={5} style={{ display: "flex", alignItems: "center" }}>
              <Typography
                style={{
                  textAlign: "left",
                  color: "white",
                  fontSize: "0.85rem",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() => setExpandLeaderboard(!expandLeaderboard)}
                >
                  {expandLeaderboard ? (
                    <ExpandLess style={{ color: "white" }} />
                  ) : (
                    <ExpandMore style={{ color: "white" }} />
                  )}
                </IconButton>
                Leaderboard
                {gridRef &&
                  gridRef.current &&
                  gridRef.current.api &&
                  Object?.keys(gridRef.current?.api?.getFilterModel() || {})
                    ?.length > 0 && (
                    <button
                      type="button"
                      style={{
                        cursor: "pointer",
                        background: "none",
                        border: "none",
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "agGridAlpine",
                          color: "white",
                          fontSize: "1.4em",
                        }}
                        className="ag-theme-alpine ag-icon-filter"
                      />
                    </button>
                  )}
              </Typography>
            </Grid>
            {expandLeaderboard && (
              <Grid
                container
                item
                xs={7}
                justifyContent="flex-end"
                alignItems="center"
                style={{ paddingRight: "10px", paddingLeft: "10px" }}
              >
                <Button
                  id="queue-leaderboard-download"
                  onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
                    setAnchorExport(e.currentTarget)
                  }
                  aria-controls={openExport ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openExport ? "true" : undefined}
                  size="small"
                  style={{
                    height: "32px",
                    width: "32px",
                    minWidth: "24px",
                  }}
                >
                  <GetApp style={{ color: "white" }} />
                </Button>

                <Button
                  size="small"
                  style={{
                    height: "32px",
                    width: "32px",
                    minWidth: "24px",
                    marginLeft: "10px",
                  }}
                  onClick={larger}
                >
                  <UnfoldMore style={{ color: "white" }} />
                </Button>
                <Button
                  size="small"
                  style={{ height: "32px", width: "32px", minWidth: "24px" }}
                  onClick={smaller}
                >
                  <UnfoldLess style={{ color: "white" }} />
                </Button>
                <Button
                  onClick={increaseFont}
                  size="small"
                  style={{
                    height: "32px",
                    width: "32px",
                    minWidth: "24px",
                    marginLeft: "10px",
                  }}
                >
                  <TextFormat style={{ fontSize: "1.8rem", color: "white" }} />
                </Button>
                <Button
                  onClick={decreaseFont}
                  size="small"
                  style={{ height: "32px", width: "32px", minWidth: "24px" }}
                >
                  <TextFormat fontSize="small" style={{ color: "white" }} />
                </Button>
              </Grid>
            )}
          </Grid>
        </Toolbar>
        <Menu
          classes={{ paper: classes.menuPaper }}
          anchorEl={anchorExport}
          id="basic-menu"
          open={openExport}
          getContentAnchorEl={null}
          // transformOrigin={{ horizontal: 'left', vertical: 'top' }}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
          onClose={() => setAnchorExport(null)}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem
            id="queue-leaderboard-download-csv"
            className={classes.menuItem}
            onClick={clickOnCsvExport}
          >
            CSV Export
          </MenuItem>
          <MenuItem
            id="queue-leaderboard-download-excel"
            className={classes.menuItem}
            onClick={clickOnExcelExport}
          >
            Excel Export
          </MenuItem>
          {/* <MenuItem className={classes.menuItem} onClick={clickOnPdfExport}>
            PDF Export
          </MenuItem> */}
        </Menu>
        <Collapse in={expandLeaderboard} timeout="auto">
          <div style={{ width: "100%", height: `${verticalPercent}vh` }}>
            <AgGridReact
              suppressCopyRowsToClipboard
              detailRowHeight={200}
              onGridReady={() => setGridReady(true)}
              ref={gridRef} // Ref for accessing Grid's API
              rowData={rowData} // Row Data for Rows
              columnDefs={columnDefs} // Column Defs for Columns
              defaultColDef={defaultColDef} // Default Column Properties
              animateRows // Optional - set to 'true' to have rows animate when sorted
              rowSelection="multiple" // Options - allows click selection of rows
              getRowId={getRowId}
              pagination
              paginationAutoPageSize
              onSortChanged={columnChanges}
              onColumnMoved={columnChanges}
              onColumnVisible={columnChanges}
              onColumnPinned={columnChanges}
              onColumnResized={columnChanges}
              onFilterChanged={() => {
                if (
                  queueSelectedTab === "inProgress" &&
                  gridReady &&
                  gridRef.current &&
                  hudTab === "queues"
                ) {
                  setActiveFilterRef(gridRef.current?.api?.getFilterModel());
                }
              }}
              rowClassRules={rowClassRules}
              rowHeight={28}
              // onGridReady={() => setGridReady(true)}
              sideBar={{
                toolPanels: [
                  "filters",
                  {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel",
                    toolPanelParams: {
                      suppressRowGroups: true,
                      suppressValues: true,
                      suppressPivots: true,
                      suppressPivotMode: true,
                      suppressColumnFilter: true,
                      suppressColumnSelectAll: true,
                      suppressColumnExpandAll: true,
                    },
                  },
                ],
              }}
            />
          </div>
        </Collapse>
      </div>
    );
  };
})();

const QueueCallback = (() => {
  interface ICall {
    index: string;
    ringDuration: number;
    callId: string;
    userId: string;
    direction: string;
    toPhoneNumber: string;
    fromPhoneNumber: string;
    duration: number;
    talkDuration: number;
    state: string;
  }

  function durationFormatter(params: ValueFormatterParams) {
    if (params.value === undefined) return "--:--";
    return `${Math.floor(params.value / 1000 / 60)
      .toString()
      .padStart(2, "0")}:${(Math.floor(params.value / 1000) % 60)
      .toString()
      .padStart(2, "0")}`;
  }

  function typeFormatter(params: ValueGetterParams) {
    if (params.data?.state.startsWith("QUEUE")) {
      if (params.data?.vmDurationTime === undefined) {
        return "Abandoned";
      }
      return "Voicemail";
    }

    return "Callback";
  }

  // function dateFormatter(params: ValueFormatterParams) {
  //   return params.value?.toLocaleString();
  // }

  function regexCheck(str: string, number: string): boolean {
    const escapeRegex = (s: string): string =>
      s.replace(/([.+^=!:${}()|\\])/g, "\\$1");

    const temp = "^".concat(number.split("*").map(escapeRegex).join(".*"), "$");
    const r = new RegExp(temp.split("?").join("."));

    return r.test(str);
  }

  interface RecordingParams extends ICellRendererParams<any> {
    accessToken: string;
    forwardAddress: string;
    mode: string;
    leaderboardUrl: string;
  }

  function recordingRenderer(params: RecordingParams) {
    const [inProgress, setInProgress] = useState(false);
    const [url, setUrl] = useState<string | undefined>(params.data?.url);

    // useEffect(() => {
    //   if (url !== undefined) {
    //     if (!params.gridRef || !params.gridRef.current || !params.gridRef.current.api) {
    //       return;
    //     }

    //     try {
    //       const updatedData: any[] = [];

    //       params.gridRef.current.api.forEachNode((node) => {
    //         if (
    //           node.data.callId === params.data?.callId &&
    //           node.data.queueId === params.data?.queueId
    //         ) {
    //           updatedData.push({
    //             ...node.data,
    //             url,
    //           });
    //         }
    //       });

    //       const transaction = {
    //         update: updatedData
    //       };

    //       params.gridRef.current.api.applyTransaction(transaction);
    //     } catch (error) {
    //       console.error("Error applying transaction:", error);
    //     }
    //   }

    // }, [url]);

    useEffect(() => {
      if (!inProgress) {
        return;
      }
      (async () => {
        if (params.data === undefined) {
          return;
        }
        // looking up user on callback grid
        // queue otherwise

        let tempUrl = "";
        if (
          params.leaderboardUrl ===
          "https://otq90fr3xg.execute-api.eu-west-2.amazonaws.com/summary"
        ) {
          tempUrl = params.leaderboardUrl.replace(
            "/summary",
            `/call/${params.data.callId}/recording?extensionId=${
              params.data?.state?.startsWith("QUEUE")
                ? params.data.queueId
                : params.data.userId
            }`
          );
        } else {
          tempUrl = params.forwardAddress.replace(
            "/shadow-agent",
            `/call/${params.data.callId}/recording?extensionId=${
              params.data?.state?.startsWith("QUEUE")
                ? params.data.queueId
                : params.data.userId
            }`
          );
        }
        const temp = await fetch(tempUrl, {
          method: "get",
          headers: {
            authorization: params.accessToken,
          },
        }).then((response) => {
          if (response.ok) {
            return response.text();
          }
          return undefined;
        });
        setUrl(temp);
      })();
    }, [inProgress]);

    if (params.data === undefined) {
      return "";
    }
    if (params.data.transcript === undefined) {
      return "";
    }

    if (url === undefined && params.data?.statusCode !== 400) {
      return (
        <div style={{ width: "100%", display: "flex" }}>
          <Tooltip title="Download Recording">
            <button
              type="button"
              aria-label="Download recording"
              style={{
                width: 26,
                height: 20,
                marginTop: 2,
                cursor: "pointer",
                borderRadius: 3,
                backgroundColor:
                  params.mode === "light" ? "#00000042" : "rgb(34, 34, 34)",
                border:
                  params.mode === "light" ? "0px" : "1px solid rgb(85, 85, 85)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: params.mode === "light" ? "black" : "white",
              }}
              onClick={() => setInProgress(true)}
            >
              <GetAppSharp
                fontSize="small"
                style={{
                  color: params.mode === "light" ? "black" : "white",
                }}
              />
            </button>
          </Tooltip>
        </div>
      );
    }
    return (
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        {params?.data?.statusCode === 200 && (
          <audio
            controls
            src={url}
            style={{
              filter:
                "sepia(20%) saturate(70%) grayscale(1) contrast(99%) invert(12%)",
              width: 260,
              height: 20,
              marginTop: 3,
            }}
          >
            <a className="audiobar" href={url}>
              Download audio
            </a>
          </audio>
        )}
      </div>
    );
  }

  interface CallbackParams extends ICellRendererParams<any> {
    accessToken: string;
    apiUrl: string;
    forwardAddress: string;
    gridRef: React.RefObject<AgGridReact<any>>;
    mode: string;
    offset: number;
    organizationId: string;
    rcId: string;
    setModalOpen: Function;
    setModalContent: Function;
    setCallerNumber: Function;
    showCallback: boolean;
    origin: string;
    newCallback: boolean;
    vipList: { number: string; name: string }[];
  }

  function callbackRenderer(params: CallbackParams) {
    const [uniqueMatches, setUniqueMatches] = useState<Array<string>>([]);
    const [transcript, setTranscript] = useState<string | undefined>(
      params.data?.transcript
    );
    const [inputValue, setInputValue] = useState<string | undefined>(
      params.data?.inputValue
    );
    const [statusCode, setStatusCode] = useState<number | undefined>(
      params.data?.statusCode
    );
    const [vipList] = useState<{ number: string; name: string }[]>(
      params.vipList
    );
    function extractNumbers(input: string): string {
      return input.replace(/\D+/g, "");
    }
    const getTranscript: () => Promise<any> = useCallback(async () => {
      if (params.showCallback !== true) {
        return undefined;
      }

      if (params.data === undefined) {
        return undefined;
      }

      // try {
      const url = params.forwardAddress.replace("/shadow-agent", "/transcript");
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({
          extensionId: params.data.userId,
          date: params.data.time.toISOString(),
          phoneNumber: params.data.callerNumber,
          telephonySessionId: params.data.callId,
        }),
        headers: {
          authorization: params.accessToken,
        },
      });

      // if (!response.ok) {
      //   const err = response
      //   setCallbackResponse(err)
      //   throw new Error(`wrong response: ${response?.body}`);
      // }
      setStatusCode(response.status);

      try {
        const res: {
          message: string | undefined;
          sentimentScore: number | undefined;
        } = await response.json();

        if (res.message?.trim() === "") {
          res.message = undefined;
        }

        if (
          res.message !== undefined &&
          params.gridRef &&
          params.gridRef.current &&
          params.gridRef.current.api
        ) {
          try {
            const updatedData: any[] = [];

            params.gridRef.current.api.forEachNode((node) => {
              if (
                node.data.callId === params.data?.callId &&
                node.data.queueId === params.data?.queueId
              ) {
                let { vip, vipName } = node.data;
                console.log(node.data, vipList.length);
                if (res.message && vipList.length) {
                  vipList.forEach(({ name, number }) => {
                    console.log(extractNumbers(res.message || ""), number);
                    const temp = regexCheck(
                      extractNumbers(res.message || ""),
                      number
                    );
                    if (temp) {
                      vip = "Yes";
                      vipName = name;
                    }
                  });
                }
                updatedData.push({
                  ...node.data,
                  vip,
                  vipName,
                  transcript: res.message,
                  sentimentScore:
                    response.status === 200 ? res.sentimentScore : undefined,
                  statusCode: response.status,
                });
              }
            });

            const transaction = {
              update: updatedData,
            };
            console.log(transaction);

            params.gridRef.current.api.applyTransaction(transaction);

            setTranscript(res.message);
          } catch (error) {
            console.error("Error applying transaction:", error);
          }
        }
      } catch (err) {
        console.log(err);
      }
      return undefined;
    }, [vipList]);

    useEffect(() => {
      setInputValue(
        uniqueMatches.length ? uniqueMatches[0] : params.data?.callerNumber
      );
    }, [uniqueMatches, params.data?.callerNumber]);

    useEffect(() => {
      if (params.data?.vmDurationTime === undefined) {
        return () => {};
      }

      let cb: any;

      function transcriptLoop() {
        cb = setTimeout(() => {
          if (transcript !== undefined) {
            return;
          }

          getTranscript();

          transcriptLoop();
        }, 30 * 1000);
      }

      if (transcript === undefined) {
        getTranscript();

        transcriptLoop();

        return () => {
          clearTimeout(cb);
        };
      }

      // magic regex
      // https://stackoverflow.com/questions/39587157/how-to-fetch-phone-numbers-from-string-using-regular-expressionregex
      const regex = /(?:[-+() ]*\d){10,13}/g;
      const matches = transcript.match(regex);
      setUniqueMatches(Array.from(new Set(matches)));

      // not consistently working
      // const node = params.api.getRowNode(
      //   `${params.data?.userId}-${params.data?.callId}`
      // );

      // if (node) {
      //   // setTimeout(() => {
      //   try {
      //     params.api.refreshCells({
      //       columns: ["recording", "transcript", "sentimentScore"],
      //       rowNodes: [node],
      //       force: true,
      //     });
      //   } catch (e) {
      //     console.log("RefreshCells on transcript");
      //   }
      //   // }, 0);
      // }
      return () => {};
    }, [transcript, getTranscript]);

    if (params.data === undefined) {
      return "";
    }
    return (
      <div style={{ display: "flex", justifyContent: "start" }}>
        <form
          className="form-container"
          onSubmit={(event) => {
            event.preventDefault();
            if (inputValue !== undefined) {
              // window.parent.postMessage(
              //   JSON.stringify({
              //     extensionNumber: inputValue,
              //     event: "phone",
              //   }),
              //   params.origin
              // );

              const dialerRef = document.querySelector(
                "#ex-dialer"
              ) as HTMLIFrameElement;
              dialerRef.contentWindow!.postMessage(
                {
                  type: "rc-adapter-new-call",
                  phoneNumber: inputValue,
                  toCall: true,
                },
                "*"
              );

              (async () => {
                await fetch(params.apiUrl, {
                  method: "post",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    event: `/restapi/v1.0/account/${params.organizationId}/extension/${params.rcId}/callback`,
                    body: {
                      toPhoneNumber: inputValue,
                      callerNumber: params.data?.callerNumber,
                      time: new Date(new Date().getTime() + params.offset),
                    },
                  }),
                });
              })();
            }
          }}
        >
          <div className="combox-main">
            <div className="combox-inner" style={{ position: "relative" }}>
              <input
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                className="combox-input"
                style={{
                  color: params.mode === "light" ? "black" : "white",
                  backgroundColor: params.mode === "light" ? "white" : "#222",
                  border:
                    params.mode === "light"
                      ? "1px solid gray"
                      : "1px solid #555",
                  borderRadius: 3,
                }}
              />
              <select
                onChange={(e: React.ChangeEvent) => {
                  const temp = (e.target as HTMLInputElement).value;

                  setInputValue(temp);

                  if (
                    !params.gridRef ||
                    !params.gridRef.current ||
                    !params.gridRef.current.api
                  ) {
                    return;
                  }

                  try {
                    const updatedData: any[] = [];

                    params.gridRef.current.api.forEachNode((node) => {
                      if (
                        node.data.callId === params.data?.callId &&
                        node.data.queueId === params.data?.queueId
                      ) {
                        updatedData.push({
                          ...node.data,
                          inputValue: temp,
                        });
                      }
                    });

                    const transaction = {
                      update: updatedData,
                    };

                    params.gridRef.current.api.applyTransaction(transaction);
                  } catch (error) {
                    console.error(
                      "Error applying callbackRenderer transaction:",
                      error
                    );
                  }
                }}
                style={{
                  outline: "none",
                  zIndex: 0,
                  position: "absolute",
                  bottom: 8,
                  right: 2,
                  height: 14,
                  borderRadius: "0px 3px 3px 0px",
                  color: params.mode === "light" ? "black" : "white",
                  cursor: "pointer",
                  fontSize: "1em",
                  width: 20,
                  border: 0,
                  backgroundColor: params.mode === "light" ? "white" : "#222",
                }}
              >
                <option
                  key={params.data?.callerNumber}
                  value={params.data?.callerNumber}
                >
                  {params.data?.callerNumber}
                </option>
                {uniqueMatches.map((number: string) => (
                  // eslint-disable-next-line
                  <option
                    key={number}
                    style={{
                      color: params.mode === "light" ? "black" : "white",
                    }}
                    value={number}
                  >
                    {number}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="form-buttons">
            <Tooltip title="Call Back">
              <IconButton
                className="callback-submit"
                type="submit"
                disableRipple
                style={{ color: params.mode === "dark" ? "white" : "black" }}
              >
                <Phone
                  fontSize="small"
                  style={{ color: params.mode === "dark" ? "white" : "#333" }}
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="Mark as Completed">
              <IconButton
                disableRipple
                className="marked-callback-button"
                type="button"
                onClick={() => {
                  (async () => {
                    await fetch(params.apiUrl, {
                      method: "post",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify({
                        event: `/restapi/v1.0/account/${params.organizationId}/extension/${params.rcId}/mark-as-called`,
                        body: {
                          callId: params.data?.callId,
                          time: new Date(
                            new Date().getTime() + params.offset
                          ).toISOString(),
                        },
                      }),
                    });
                  })();
                }}
              >
                <CheckCircleRounded
                  fontSize="small"
                  style={{ color: "green" }}
                />
              </IconButton>
            </Tooltip>
            {transcript !== undefined && statusCode === 200 && (
              <Tooltip title="View Transcript">
                <div
                  style={{
                    cursor: "pointer",
                    width: 24,
                  }}
                  className=" transcript-svg"
                  role="button"
                  aria-label="Open Transcript"
                  tabIndex={0}
                  onClick={() => {
                    params.setModalOpen(true);
                    params.setModalContent(transcript);
                    params.setCallerNumber(params?.data?.callerNumber || "");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      params.setModalOpen(true);
                      params.setModalContent(transcript);
                      params.setCallerNumber(params?.data?.callerNumber || "");
                    }
                  }}
                >
                  <img
                    alt="View Transcript"
                    style={{ height: "100%", width: "auto" }}
                    src={
                      params.mode === "light" ? transcriptLight : transcriptDark
                    }
                  />
                </div>
              </Tooltip>
            )}
            {transcript === undefined && statusCode === 200 && (
              <div
                style={{
                  cursor: "pointer",
                  width: 24,
                }}
                className=" transcript-svg"
              >
                <img
                  alt="View Transcript"
                  style={{
                    height: "100%",
                    width: "auto",
                    visibility: "hidden",
                  }}
                  src={
                    params.mode === "light" ? transcriptLight : transcriptDark
                  }
                />
              </div>
            )}
            {statusCode === 400 && transcript !== undefined && (
              <Tooltip title="No Transcript">
                <div
                  style={{
                    width: 24,
                  }}
                  className=" transcript-svg"
                >
                  <img
                    alt="No Transcript"
                    style={{ height: "100%", width: "auto" }}
                    src={
                      params.mode === "light"
                        ? noTranscriptLight
                        : noTranscriptDark
                    }
                  />
                </div>
              </Tooltip>
            )}
          </div>
        </form>
      </div>
    );
  }

  return ({
    historicals,
    callbackStates,
    expandLeaderboard,
    setExpandLeaderboard,
    smaller,
    larger,
    mode,
    verticalPercent,
    fontSize,
    increaseFont,
    decreaseFont,
    updateLocal,
    vipList,
    showVip,
    callbacks,
    accessToken,
    forwardAddress,
    origin,
    excludedQueues,
    rcId,
    organizationId,
    offset,
    markedAsCalledBack,
    showCallback,
    filter,
    rowData,
    setRowData,
    historicalState,
    local,
    transcriptTimeout,
    setTranscriptTimeout,
    apiUrl,
    newCallback,
    leaderboardUrl,
    deletedVMs,
    setActiveFilterRef,
    queueSelectedTab,
    navPage,
    navTab,
    page,
    hudTab,
    setGridRef,
  }: {
    historicals: Array<Historical>;
    callbackStates: Array<CallbackState>;
    expandLeaderboard: boolean;
    setExpandLeaderboard: any;
    smaller: any;
    larger: any;
    mode: string;
    verticalPercent: number;
    fontSize: string;
    increaseFont: any;
    decreaseFont: any;
    updateLocal: any;
    vipList: { number: string; name: string }[];
    showVip: boolean;
    callbacks: Array<CallbackState> | undefined;
    accessToken: string;
    forwardAddress: string;
    origin: string;
    excludedQueues: Set<string> | undefined;
    rcId: string;
    organizationId: string;
    offset: number;
    markedAsCalledBack: Array<any>;
    showCallback: boolean;
    filter: string; // used to conditionally render filters within the grid ref
    rowData: Array<any> | undefined;
    setRowData: Function;
    historicalState:
      | {
          users: Map<string, User>;
          queues: Map<string, Queue>;
          queuesById: Map<string, Queue>;
        }
      | undefined;
    local: any;
    transcriptTimeout: number;
    setTranscriptTimeout: Function;
    apiUrl: string;
    newCallback: boolean;
    leaderboardUrl: string;
    deletedVMs: Set<string>;
    setActiveFilterRef: React.Dispatch<
      SetStateAction<{ [colId: string]: any }>
    >;
    queueSelectedTab: string;
    page: string;
    hudTab: string;
    navTab: string;
    navPage: string;
    setGridRef: React.Dispatch<SetStateAction<any>>;
  }) => {
    // eslint-disable-next-line
    const classes = mode === "light" ? useStyles() : useDarkStyles();
    const gridRef = useRef<AgGridReact>(null); // Optional - for accessing Grid's API
    const detailRef = useRef<AgGridReact>(null);
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [modalContent, setModalContent] = useState<string>("");
    const [callerNumber, setCallerNumber] = useState<string>("");
    const [gridReady, setGridReady] = useState(false);

    useEffect(() => {
      const addRows: Array<any> = [];
      const updateRows: Array<any> = [];

      rowData?.forEach((data) => {
        const row = gridRef.current!.api?.getRowNode(
          `${data.userId}-${data.callId}`
        );

        if (row) {
          // let's keep in our modifications
          const existingVip = row.data.vip;
          const existingVipName = row.data.vipName;

          // Preserve vip and vipName if existing vip is "Yes"
          const updatedData = {
            ...row.data,
            ...data,
            vip: existingVip === "Yes" ? existingVip : data.vip,
            vipName: existingVip === "Yes" ? existingVipName : data.vipName,
          };

          updateRows.push(updatedData);
        } else {
          addRows.push(data);
        }
      });

      console.log("add", addRows.length, "update", updateRows.length);
      gridRef?.current?.api?.applyTransaction({
        update: updateRows,
        add: addRows,
      });
    }, [rowData]);

    const resolutionRenderer = useCallback(
      (params: ICellRendererParams<any>) => {
        if (params.data !== undefined) {
          if (
            markedAsCalledBack.find(
              (item) =>
                item.callId === params.data?.callId &&
                params.data?.time !== undefined &&
                new Date(item.time).getTime() >
                  new Date(params.data.time).getTime()
            ) ||
            deletedVMs.has(`${params.data.messageId}`)
          ) {
            return <div>Complete</div>;
          }
        }

        return <div>Unresolved</div>;
      },
      [markedAsCalledBack, deletedVMs]
    );
    interface TranscriptParams extends ICellRendererParams<any> {
      mode: string;
    }
    const displayTranscript = useCallback((params: TranscriptParams) => {
      if (
        params.data?.vmDurationTime !== undefined &&
        params.data?.statusCode === 200
      ) {
        return (
          <div>
            <div className="transcript-row transcript-main-box">
              <Tooltip title="View Transcript">
                <div
                  style={{
                    cursor: "pointer",
                    border:
                      params.mode === "light"
                        ? "0px"
                        : "1px solid rgb(85, 85, 85)",
                    backgroundColor:
                      params.mode === "light" ? "#00000042" : "rgb(34,34,34)",
                  }}
                  className="transcript-inner-box"
                  role="button"
                  aria-label="Open Transcript"
                  tabIndex={0}
                  onClick={() => {
                    setModalOpen(true);
                    setModalContent(params.data?.transcript || "");
                    setCallerNumber(params?.data?.callerNumber || "");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setModalOpen(true);
                      setModalContent(params.data?.transcript || "");
                      setCallerNumber(params?.data?.callerNumber || "");
                    }
                  }}
                >
                  <KeyboardArrowDown />
                </div>
              </Tooltip>
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: " hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {params.data?.transcript}
              </div>
            </div>
          </div>
        );
      }
      return "";
    }, []);

    const columnDefs = useMemo(
      () => [
        {
          field: "type",
          valueGetter: typeFormatter,
          filter: "agSetColumnFilter",
           
          filterParams: {
            values: ["Callback", "Abandoned", "Voicemail"],
          },
          hide: true,
        },
        // {
        //   width: 50,
        //   rowGroup: true,
        //   field: "vipName",
        //   valueFormatter: () => "",
        //   headerName: `+`,
        //   resizable: false,
        // },
        // {
        //   width: 60,
        //   field: "vipName",
        //   hide: !showVip,
        //   headerName: `+`,
        //   cellClass: "notranslate",
        //   cellRenderer: "agGroupCellRenderer",
        //   cellRendererParams: {
        //     innerRenderer: (p: any) => <span />,
        //   },
        //   resizable: false,
        //   valueGetter: (params: ValueGetterParams) => params?.data?.vipName,
        // },
        {
          field: "vipName",
          hide: !showVip,
          headerName: `VIP Name`,
          cellClass: "notranslate",
        },
        {
          field: "callback",
          cellRenderer: callbackRenderer,
          cellRendererParams: {
            gridRef,
            mode,
            forwardAddress,
            organizationId,
            rcId,
            offset,
            setModalOpen,
            setModalContent,
            setCallerNumber,
            accessToken,
            showCallback,
            origin,
            apiUrl,
            newCallback,
            vipList,
          },
          valueGetter: (params: ValueGetterParams) =>
            !!params?.data?.transcript,
          width: 300,
          suppressKeyboardEvent: (params: any) => true,
        },
        {
          hide: filter === "Abandoned",
          field: "transcript",
          cellRenderer: displayTranscript,
          cellClass: "notranslate",
          cellRendererParams: {
            mode,
          },
        },
        {
          hide: filter === "Abandoned",
          field: "sentimentScore",
          cellClass: "notranslate",
          // valueFormatter: (params: ValueFormatterParams) =>
          //   params.value === undefined ? "--" : params.value,
          cellRenderer: (params: ValueFormatterParams) => {
            if (params && params.value !== undefined) {
              if (params.value >= 2) {
                return (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Tooltip title="Very Positive">
                      <SentimentVerySatisfied style={{ color: "#5DCF49" }} />
                    </Tooltip>
                  </div>
                );
              }
              if (params.value >= 1) {
                return (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Tooltip title="Positive">
                      <SentimentSatisfiedAlt style={{ color: "#009AFF" }} />
                    </Tooltip>
                  </div>
                );
              }
              if (params.value > 0) {
                return (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Tooltip title="Neutral">
                      <SentimentSatisfied style={{ color: "#64BDFD" }} />
                    </Tooltip>
                  </div>
                );
              }
              if (params.value > -1) {
                return (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Tooltip title="Negative">
                      <SentimentDissatisfied style={{ color: "#FF9E1C" }} />
                    </Tooltip>
                  </div>
                );
              }
              return (
                <div style={{ display: "flex", alignItems: "center" }}>
                  {" "}
                  <Tooltip title="Very Negative">
                    <SentimentVeryDissatisfied style={{ color: "#EE6B6B" }} />
                  </Tooltip>
                </div>
              );
            }
            return "--";
          },
        },
        {
          hide: filter === "Abandoned",
          field: "recording",
          cellClass: "notranslate",
          width: 270,
          cellRenderer: recordingRenderer,
          cellRendererParams: {
            accessToken,
            forwardAddress,
            setRowData,
            mode,
            leaderboardUrl,
          },
          valueGetter: (params: ValueGetterParams) =>
            !!params?.data?.transcript,
        },
        {
          field: "resolutionStatus",
          cellClass: "notranslate",
          cellRenderer: resolutionRenderer,
          valueGetter: (params: ValueGetterParams) => {
            if (params?.data !== undefined) {
              if (
                markedAsCalledBack.find(
                  (item) =>
                    item.callId === params?.data?.callId &&
                    params?.data?.time !== undefined &&
                    new Date(item.time).getTime() >
                      new Date(params.data.time).getTime()
                ) ||
                deletedVMs.has(`${params.data.messageId}`)
              ) {
                return "Complete";
              }
            }

            return "Unresolved";
          },
          filter: "agSetColumnFilter",
          filterParams: {
            values: ["Complete", "Unresolved"],
          },
        },
        { field: "extensionNumber", hide: true, cellClass: "notranslate" },
        { field: "name", hide: true, cellClass: "notranslate" },
        {
          field: "vip",
          headerName: "VIP",
          cellClass: "notranslate",
          hide: !showVip,
        },
        { field: "calleeNumber", cellClass: "notranslate" },
        {
          field: "time",
          valueFormatter: dateFormatter,
          cellClass: "notranslate",
        },
        {
          field: "duration",
          valueFormatter: durationFormatter,
          cellClass: "notranslate",
        },
        {
          field: "queueName",
          headerName: "Queue Name",
          cellClass: "notranslate",
        },
        {
          field: "vmDurationTime",
          headerName: "Voicemail Duration",
          cellClass: "notranslate",
          valueFormatter: durationFormatter,
          filter: "agNumberColumnFilter",
          // filter:
          //   filterString === "abandoned"
          //     ? {
          //         filterType: "custom",
          //         filter: (params: any) =>
          //           params?.data?.vmDurationTime === undefined,
          //       }
          //     : {},
        },
        {
          field: "callerNumber",
          headerName: "Caller Number",
          cellClass: "notranslate",
        },
      ],
      [markedAsCalledBack, vipList, deletedVMs]
    );

    const [anchorExport, setAnchorExport] = useState<null | HTMLElement>(null);
    const openExport = Boolean(anchorExport);
    const defaultColDef = useMemo(
      () => ({
        sortable: true,
        resizable: true,
        animateRows: false,
        filter: true,
        detailRowHeight: 140,
        cellClass: " notarnslate ",
        cellClassRules: {
          small: () => fontSize === "small",
          medium: () => fontSize === "medium",
          large: () => fontSize === "large",
        },
      }),
      [fontSize]
    );

    const detailChanges = useCallback(() => {
      if (detailRef.current?.columnApi === undefined) {
        return;
      }
      localStorage.setItem(
        `queue-summary-detail-callback-${filter}`,
        JSON.stringify(detailRef.current!.columnApi.getColumnState())
      );
      // updateLocal(
      //   `queue-summary-detail-callback-${filter}`,
      //   JSON.stringify(detailRef.current!.columnApi.getColumnState())
      // );
    }, [filter]);

    // eslint-disable-next-line arrow-body-style
    // const detailCellRendererParams = useMemo(() => {
    //   // eslint-disable-next-line arrow-body-style
    //   return {
    //     detailGridOptions: {
    //       animateRows: true,
    //       rowHeight: 28,
    //       ref: detailRef,
    //       onGridReady: () => {
    //         if (
    //           local[`queue-summary-detail-callback-${filter}`] !== undefined &&
    //           detailRef.current?.columnApi
    //         ) {
    //           const raw = local[`queue-summary-detail-callback-${filter}`];
    //           const columnData = raw ? JSON.parse(raw) : [];
    //           detailRef.current.columnApi.applyColumnState({
    //             state: columnData,
    //             applyOrder: true,
    //           });
    //         }
    //       },

    //       detailRowHeight: 200,
    //       rowSelection: "multiple",
    //       suppressRowClickSelection: true,
    //       enableRangeSelection: true,
    //       pagination: true,
    //       paginationAutoPageSize: true,
    //       onSortChanged: detailChanges,
    //       onColumnMoved: detailChanges,
    //       onColumnPinned: detailChanges,
    //       onColumnResized: detailChanges,
    //       onColumnVisible: detailChanges,
    //       columnDefs: [
    //         { field: "time", valueFormatter: dateFormatter },
    //         { field: "calleeNumber" },
    //         { field: "callerNumber" },
    //         { field: "extensionNumber" },
    //         { field: "duration", valueFormatter: durationFormatter },
    //         { field: "ringDuration", valueFormatter: durationFormatter },
    //         { field: "talkDuration", valueFormatter: durationFormatter },
    //         { field: "state" },
    //       ],
    //       defaultColDef,
    //     },
    //     getDetailRowData: (params: {
    //       data: any;
    //       successCallback: Function;
    //     }) => {
    //       if (historicalState === undefined) {
    //         return;
    //       }
    //       (async () => {
    //         const startTime = new Date(params.data.time);

    //         const regex = /(?:[-+() ]*\d){10,13}/g;

    //         const data = await Promise.all(
    //           [params.data.callerNumber]
    //             .concat(params.data?.transcript?.match(regex) || [])
    //             .map(async (number) => {
    //               const myNumber = number
    //                 .trim()
    //                 .replace("+1", "")
    //                 .split("-")
    //                 .join("");

    //               const res = await fetch(
    //                 forwardAddress.replace(
    //                   "/shadow-agent",
    //                   `/toPhoneNumber/+1${myNumber}?startTime=${startTime.toISOString()}`
    //                 ),
    //                 {
    //                   method: "get",
    //                   headers: {
    //                     authorization: accessToken,
    //                     "Content-Type": "application/json",
    //                   },
    //                 }
    //               );
    //               const myData = (await res.json()) as { calls: Array<ICall> };
    //               return myData;
    //             })
    //         );

    //         params.successCallback(
    //           data.reduce(
    //             (sum, { calls: myCalls }) =>
    //               sum.concat(
    //                 myCalls.map((call) => ({
    //                   time: new Date(call.index).toLocaleString(),
    //                   calleeNumber: call.toPhoneNumber,
    //                   callerNumber: call.fromPhoneNumber,
    //                   duration: call.duration,
    //                   ringDuration: call.ringDuration,
    //                   talkDuration: call.talkDuration,
    //                   state: call.state.replace(`-${call.index}`, ""),
    //                   name: `${
    //                     historicalState.users.get(call.userId)?.firstName || ""
    //                   } ${
    //                     historicalState.users.get(call.userId)?.lastName || ""
    //                   }`,
    //                   extensionNumber:
    //                     historicalState.users.get(call.userId)
    //                       ?.extensionNumber || "",
    //                 }))
    //               ),
    //             [] as Array<{
    //               time: string;
    //               calleeNumber: string;
    //               callerNumber: string;
    //               duration: number;
    //               ringDuration: number;
    //               talkDuration: number;
    //               state: string;
    //               name: string;
    //               extensionNumber: string;
    //             }>
    //           )
    //         );
    //       })();
    //     },
    //   };
    // }, [accessToken, forwardAddress, defaultColDef, historicalState]);

    const getRowId = useMemo(
      () => (params: GetRowIdParams) =>
        `${params.data.userId}-${params.data.callId}`,
      []
    );

    useEffect(() => {
      if (gridReady && gridRef.current && hudTab === "queues") {
        if (
          page === "abandoned" ||
          page === "voicemail" ||
          page === "callback"
        ) {
          setGridRef(gridRef?.current?.api?.getFilterModel());
        }
      }
    }, [gridReady, gridRef, page, hudTab]);

    useEffect(() => {
      if (!gridRef || !gridRef.current || !gridRef.current.api) {
        return;
      }

      try {
        const updatedData: any[] = [];

        gridRef.current.api.forEachNode((node) => {
          let vip = "No";
          let vipName = "";

          if (vipList.length && showVip) {
            vipList.forEach(
              ({ name, number }: { name: string; number: string }) => {
                const temp = regexCheck(node.data.callerNumber, number);
                if (temp) {
                  vip = "Yes";
                  vipName = name;
                }
              }
            );
          }

          updatedData.push({
            ...node.data,
            vipName,
            vip,
          });
        });

        const transaction = {
          update: updatedData,
        };

        gridRef.current.api.applyTransaction(transaction);
      } catch (error) {
        console.error("Error applying transaction for vipRegex:", error);
      }
    }, [vipList, showVip]);

    // useEffect(() => {
    //   setRowData((oldRowData) =>
    //     oldRowData?.map((record) => {
    //       if (record.queueId !== undefined && excludedQueues?.has(record.queueId)) {

    //       }

    //       return {
    //         ...record,
    //         vipName,
    //         vip,
    //       };
    //     })
    //   );
    // }, [excludedQueues, rowData?.length]);

    // useEffect(() => {
    //   if (rowData === undefined) {
    //     return () => {};
    //   }

    //   if (showCallback !== true) {
    //     return () => {};
    //   }

    //   const cb = setTimeout(async () => {
    //     setTranscriptTimeout(30 * 1000);

    //     const temp = await getTranscript([...rowData]);

    //     setRowData((oldRowData: Array<any>) =>
    //       oldRowData?.map((item) => ({
    //         ...item,
    //         ...temp.find(
    //           ({ callId, userId }) =>
    //             item.userId === userId && item.callId === callId
    //         ),
    //       }))
    //     );
    //   }, transcriptTimeout);

    //   return () => clearTimeout(cb);
    // }, [rowData, getTranscript, showCallback, transcriptTimeout]);

    const columnChanges = useCallback(() => {
      if (gridRef.current?.columnApi === undefined) {
        return;
      }
      localStorage.setItem(
        `queue-summary-callback-${filter}`,
        JSON.stringify(gridRef.current!.columnApi.getColumnState())
      );
      // updateLocal(
      //   `queue-summary-callback-${filter}`,
      //   JSON.stringify(gridRef.current!.columnApi.getColumnState())
      // );
    }, [filter]);

    useEffect(() => {
      gridRef.current!.api?.onFilterChanged();
    }, [excludedQueues, markedAsCalledBack, deletedVMs]);

    const clickOnCsvExport = useCallback(() => {
      gridRef.current!.api.exportDataAsCsv();
      setAnchorExport(null);
    }, []);

    const clickOnExcelExport = useCallback(() => {
      gridRef.current!.api.exportDataAsExcel();
      setAnchorExport(null);
    }, []);
    const rowClassRules = {
      "row-highlight": (params: any) => params.data?.vip === 'yes',
    };

    // const gridOptions = {
    //   autoGroupColumnDef: {
    //     headerName: "+",
    //     cellClass: "notranslate",
    //     width: 60,
    //     suppressRowResize: true,
    //   },
    // };

    return (
      <div>
        <Toolbar
          disableGutters
          variant="dense"
          style={{
            minHeight: "50px",
            backgroundColor: mode === "dark" ? "#181818" : "#0684bd",
          }}
        >
          <Grid container>
            <Grid item xs={5} style={{ display: "flex", alignItems: "center" }}>
              <Typography
                style={{
                  textAlign: "left",
                  color: "white",
                  fontSize: "0.85rem",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() => setExpandLeaderboard(!expandLeaderboard)}
                >
                  {expandLeaderboard ? (
                    <ExpandLess style={{ color: "white" }} />
                  ) : (
                    <ExpandMore style={{ color: "white" }} />
                  )}
                </IconButton>
                Leaderboard
                {gridRef &&
                  gridRef.current &&
                  gridRef.current.api &&
                  Object?.keys(gridRef.current?.api?.getFilterModel() || {})
                    ?.length > 0 && (
                    <button
                      type="button"
                      style={{
                        cursor: "pointer",
                        background: "none",
                        border: "none",
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "agGridAlpine",
                          color: "white",
                          fontSize: "1.4em",
                        }}
                        className="ag-theme-alpine ag-icon-filter"
                      />
                    </button>
                  )}
              </Typography>
            </Grid>
            {expandLeaderboard && (
              <Grid
                container
                item
                xs={7}
                justifyContent="flex-end"
                alignItems="center"
                style={{ paddingRight: "10px", paddingLeft: "10px" }}
              >
                <Button
                  id="queue-leaderboard-download"
                  onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
                    setAnchorExport(e.currentTarget)
                  }
                  aria-controls={openExport ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openExport ? "true" : undefined}
                  size="small"
                  style={{
                    height: "32px",
                    width: "32px",
                    minWidth: "24px",
                  }}
                >
                  <GetApp style={{ color: "white" }} />
                </Button>

                <Button
                  size="small"
                  style={{
                    height: "32px",
                    width: "32px",
                    minWidth: "24px",
                    marginLeft: "10px",
                  }}
                  onClick={larger}
                >
                  <UnfoldMore style={{ color: "white" }} />
                </Button>
                <Button
                  size="small"
                  style={{ height: "32px", width: "32px", minWidth: "24px" }}
                  onClick={smaller}
                >
                  <UnfoldLess style={{ color: "white" }} />
                </Button>
                <Button
                  onClick={increaseFont}
                  size="small"
                  style={{
                    height: "32px",
                    width: "32px",
                    minWidth: "24px",
                    marginLeft: "10px",
                  }}
                >
                  <TextFormat style={{ fontSize: "1.8rem", color: "white" }} />
                </Button>
                <Button
                  onClick={decreaseFont}
                  size="small"
                  style={{ height: "32px", width: "32px", minWidth: "24px" }}
                >
                  <TextFormat fontSize="small" style={{ color: "white" }} />
                </Button>
              </Grid>
            )}
          </Grid>
        </Toolbar>
        <Menu
          classes={{ paper: classes.menuPaper }}
          anchorEl={anchorExport}
          id="basic-menu"
          open={openExport}
          getContentAnchorEl={null}
          // transformOrigin={{ horizontal: 'left', vertical: 'top' }}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
          onClose={() => setAnchorExport(null)}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem
            id="queue-leaderboard-download-csv"
            className={classes.menuItem}
            onClick={clickOnCsvExport}
          >
            CSV Export
          </MenuItem>
          <MenuItem
            id="queue-leaderboard-download-excel"
            className={classes.menuItem}
            onClick={clickOnExcelExport}
          >
            Excel Export
          </MenuItem>
          {/* <MenuItem className={classes.menuItem} onClick={clickOnPdfExport}>
            PDF Export
          </MenuItem> */}
        </Menu>
        <Collapse in={expandLeaderboard} timeout="auto">
          <div style={{ width: "100%", height: `${verticalPercent}vh` }}>
            <AgGridReact
              suppressCopyRowsToClipboard
              detailRowHeight={200}
              onGridReady={() => {
                // Get a reference to the filter instance
                const filterInstance =
                  gridRef.current!.api.getFilterInstance("type");
                // Set the filter model
                filterInstance?.setModel({
                  type: "set",
                  values: [filter],
                });

                const resolutionInstance =
                  gridRef.current!.api.getFilterInstance("resolutionStatus");

                resolutionInstance?.setModel({
                  type: "set",
                  values: ["Unresolved"],
                });
                // Tell grid to run filter operation again
                gridRef.current!.api.onFilterChanged();

                if (
                  local[`queue-summary-callback-${filter}`] !== undefined &&
                  gridRef.current?.columnApi
                ) {
                  const raw = local[`queue-summary-callback-${filter}`];
                  const columnData = raw ? JSON.parse(raw) : [];
                  gridRef.current.columnApi.applyColumnState({
                    state: columnData,
                    applyOrder: true,
                  });
                }
                setGridReady(true);
              }}
              ref={gridRef} // Ref for accessing Grid's API
              // rowData={rowData} // Row Data for Rows
              columnDefs={columnDefs} // Column Defs for Columns
              defaultColDef={defaultColDef} // Default Column Properties
              animateRows // Optional - set to 'true' to have rows animate when sorted
              rowSelection="multiple" // Options - allows click selection of rows
              getRowId={getRowId}
              pagination
              onFilterChanged={() =>
                setGridRef(gridRef.current?.api?.getFilterModel())
              }
              paginationAutoPageSize
              onSortChanged={columnChanges}
              onColumnMoved={columnChanges}
              onColumnPinned={columnChanges}
              onColumnVisible={columnChanges}
              onColumnResized={columnChanges}
              rowClassRules={rowClassRules}
              // masterDetail
              // gridOptions={gridOptions}
              // detailCellRendererParams={detailCellRendererParams}
              rowHeight={28}
              // onGridReady={() => setGridReady(true)}
              isExternalFilterPresent={() => true}
              doesExternalFilterPass={(node) => {
                if (
                  !historicalState?.queuesById.has(
                    node.data.callback?.[0] || node.data.userId
                  ) ||
                  excludedQueues?.has(
                    node.data.callback?.[0] || node.data.userId
                  )
                ) {
                  return false;
                }

                // if (
                //   node.data.queueId !== undefined &&
                //   excludedQueues?.has(node.data.queueId)
                // ) {
                //   return false;
                // }

                // if (
                //   markedAsCalledBack.find(
                //     (item) =>
                //       item.callId === node.data.callId &&
                //       new Date(item.time).getTime() >
                //         new Date(node.data.time).getTime()
                //   )
                // ) {
                //   return false;
                // }

                return true;
              }}
              sideBar={{
                toolPanels: [
                  "filters",
                  {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel",
                    toolPanelParams: {
                      suppressRowGroups: true,
                      suppressValues: true,
                      suppressPivots: true,
                      suppressPivotMode: true,
                      suppressColumnFilter: true,
                      suppressColumnSelectAll: true,
                      suppressColumnExpandAll: true,
                    },
                  },
                ],
              }}
            />
          </div>
        </Collapse>
        <div key="troubled-component">
          <Modal
            keepMounted
            open={modalOpen}
            onClose={() => {
              setModalOpen(false);
              setModalContent("");
              setCallerNumber("");
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              style={{
                transform: "translate(-50%, -50%)",
                position: "absolute" as "absolute",
                top: "35%",
                left: "50%",
                width: 400,
                background:
                  mode === "dark"
                    ? "linear-gradient(1deg,#111111,#222);"
                    : "white",
                padding: 0,
                color: mode === "dark" ? "white" : "black",
                borderRadius: "7px",
              }}
            >
              <div
                className="header-row"
                style={{
                  padding: 1,
                  paddingTop: 10,
                  paddingBottom: 10,
                  display: "flex",
                  justifyContent: "space-between",
                  alignContent: "center",
                  alignItems: "center",
                  border:
                    mode === "dark" ? "1px solid #222" : "1px solid white",
                  borderRadius: "7px 7px 0px 0px",
                  background:
                    mode === "dark"
                      ? "#111"
                      : "linear-gradient(90deg,#0684bd,#1d82b1)",
                  color: "white",
                }}
              >
                <div
                  className="header-left"
                  style={{
                    paddingLeft: "1rem",
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div
                    className="header-icon"
                    style={{ marginRight: "4px", width: "30px" }}
                  >
                    <TranscriptIcon mode="dark" />
                  </div>
                  <Typography id="modal-modal-header" component="h2">
                    Transcript
                  </Typography>
                </div>
                <div
                  className="header-right"
                  style={{
                    paddingRight: "1rem",
                  }}
                >
                  <button
                    type="button"
                    aria-label="Close"
                    style={{
                      backgroundColor: "#00000000",
                      border: "0px #00000000",
                      color: "white",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setModalOpen(false);
                      setModalContent("");
                      setCallerNumber("");
                    }}
                  >
                    <Close fontSize="medium" />
                  </button>
                </div>
              </div>
              <div
                style={{
                  minHeight: 400,
                  padding: "1em",
                  background: mode === "dark" ? "#1e1e1e" : "#fff",
                }}
              >
                <Typography style={{ fontSize: "1.3em" }} component="h3">
                  {callerNumber || "Transcript"}
                </Typography>
                <Typography
                  id="modal-modal-description"
                  component="p"
                  style={{
                    paddingTop: "1em",
                    color: mode === "light" ? "#000" : "#b0b8c4",
                  }}
                >
                  {modalContent}
                </Typography>
              </div>
            </Box>
          </Modal>
        </div>
      </div>
    );
  };
})();

const DateRangeSummary = React.memo(
  ({
    orgId,
    historicals,
    // callEvents,
    queueCallStates,
    leaderboardDeltas,
    presenceEvents,
    queuePresenceEvents,
    summaries,
    getSummary,
    mode,
    verticalPercent,
    expandLeaderboard,
    setExpandLeaderboard,
    smaller,
    larger,
    fontSize,
    increaseFont,
    decreaseFont,
    excludedQueues,
    leaderboardUrl,
    local,
    updateLocal,
    page,
    hudTab,
    offset,
    navTab,
    navPage,
    setActiveFilterRef,
    queueSelectedTab,
  }: {
    orgId: string | undefined;
    historicals: Array<Historical>;
    // callEvents: Array<CallEvent>;
    queueCallStates: Array<QueueCallState>;
    leaderboardDeltas: Array<Delta>;
    presenceEvents: Array<UserPresenceEvent>;
    queuePresenceEvents: Array<QueuePresenceEvent>;
    summaries: Array<Summary>;
    getSummary: any;
    mode: string;
    verticalPercent: number;
    expandLeaderboard: boolean;
    setExpandLeaderboard: any;
    smaller: any;
    larger: any;
    fontSize: string;
    increaseFont: any;
    decreaseFont: any;
    excludedQueues: Set<string> | undefined;
    leaderboardUrl: string | undefined;
    local: any;
    updateLocal: any;
    page: string;
    hudTab: string;
    offset: number;
    navTab: string;
    navPage: string;
    queueSelectedTab:
      | "summary"
      | "waiting"
      | "inProgress"
      | "callback"
      | "abandoned"
      | "voicemail"
      | "agent";
    setActiveFilterRef: React.Dispatch<
      SetStateAction<{ [colId: string]: any }>
    >;
  }) => {
    const [dateRange, setDateRange] = useState<string>("Today");
    const [anchorDate, setAnchorDate] = useState<null | HTMLElement>(null);
    const [checkedFrom, setCheckedFrom] = useState<boolean>(true);
    const [checkedTo, setCheckedTo] = useState<boolean>(false);
    const [startTime, setStartTime] = useState<Date | null>(null);
    const [endTime, setEndTime] = useState<Date | null>(null);
    const [daily, setDaily] = useState(false);
    const [error, setError] = useState<string>("");

    // eslint-disable-next-line
    const classes = mode === "light" ? useStyles() : useDarkStyles();

    const openDateRange = Boolean(anchorDate);

    useEffect(() => {
      if (page !== "hud" && openDateRange) {
        setAnchorDate(null);
      }
    }, [page, openDateRange]);

    useEffect(() => {
      const todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);
      setStartTime(todayStart);
    }, []);

    const handleCheckedFrom = useCallback(() => {
      if (!checkedFrom && startTime === null) {
        setStartTime(new Date());
      } else {
        setStartTime(null);
      }
      setCheckedFrom(!checkedFrom);
    }, [checkedFrom, startTime]);

    const handleCheckedTo = useCallback(() => {
      if (!checkedTo && endTime === null) {
        setEndTime(new Date());
      } else {
        setEndTime(null);
      }
      setCheckedTo(!checkedTo);
    }, [checkedTo, endTime]);

    // const handleDaily = useCallback(() => {
    //   setDaily((oldDaily) => !oldDaily);
    // }, []);

    // useEffect(() => {
    //   if (url === undefined) return;

    //   getSummary(url);
    // }, [url, getSummary]);

    const handleDone = useCallback(
      async (button: string) => {
        // let filterDateValue = null;
        let range = "";
        let url = leaderboardUrl;
        if (button === "done") {
          // filterDateValue = new Date();
          let startParameter;
          let endParameter;
          if (checkedFrom && startTime !== null) {
            startParameter = startTime;
          }
          if (checkedTo && endTime !== null) {
            endParameter = endTime;
          }
          const date1 = startParameter
            ? startParameter
                .toLocaleString("en-CA", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  hourCycle: "h23",
                  minute: "2-digit",
                })
                .replace(",", "")
            : "";
          const date2 = endParameter
            ? endParameter
                .toLocaleString("en-CA", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  hourCycle: "h23",
                  minute: "2-digit",
                })
                .replace(",", "")
            : "";
          if (startParameter && endParameter) {
            if (startParameter > new Date() || startParameter > endParameter) {
              setError("Error: Invalid date range.");
              return;
            }
            range = `${date1} - ${date2}`;
            url = `${leaderboardUrl}?startTime=${startParameter.toISOString()}&endTime=${endParameter.toISOString()}`;
          } else if (startParameter) {
            if (startParameter > new Date()) {
              setError("Error: Invalid start time.");
              return;
            }
            range = `After ${date1}`;
            url = `${leaderboardUrl}?startTime=${startParameter.toISOString()}`;
          } else if (endParameter) {
            range = `Before ${date2}`;
            url = `${leaderboardUrl}?endTime=${endParameter.toISOString()}`;
          } else {
            range = "All Time";
            url = `${leaderboardUrl}`;
          }
          if (daily) {
            if (url.includes("?")) {
              url += "&period=daily";
            } else {
              url += "?period=daily";
            }
          }
        }
        if (button === "today") {
          const todayStart = new Date();
          todayStart.setHours(0, 0, 0, 0);
          url = `${leaderboardUrl}?startTime=${todayStart.toISOString()}`;
          range = "Today";
          // filterDateValue = null;
          setStartTime(todayStart);
          setEndTime(null);
          setCheckedFrom(true);
          setCheckedTo(false);
          setDaily(false);
        }
        setAnchorDate(null);
        setDateRange(range);

        // // get request to /hours?startTime={startParameter.toISOString()}&endTime={endParameter.toISOString()}

        start = startTime;
        end = endTime;
        try {
          getSummary(url);
        } catch (err) {
          setError("Too much data requested");
        }
      },
      [
        startTime,
        endTime,
        checkedFrom,
        checkedTo,
        daily,
        getSummary,
        leaderboardUrl,
      ]
    );

    return (
      <ThemeProvider theme={mode === "dark" ? darkTheme : myTheme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Popover
            classes={{ paper: classes.popover }}
            open={openDateRange && hudTab === "queues"}
            anchorEl={anchorDate}
            onClose={() => setAnchorDate(null)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <Grid container style={{ minHeight: 200, padding: 20, width: 400 }}>
              <Grid item xs={12}>
                <Checkbox
                  style={{
                    paddingTop: 20,
                    width: "8%",
                    paddingLeft: 5,
                    paddingRight: 15,
                  }}
                  icon={
                    <RadioButtonUnchecked
                      style={mode === "dark" ? { color: "white" } : {}}
                    />
                  }
                  checkedIcon={<CheckCircle style={{ color: "#088F8F" }} />}
                  checked={checkedFrom}
                  onChange={handleCheckedFrom}
                  classes={{
                    root: classes.checkboxDate,
                  }}
                />
                <KeyboardDatePicker
                  disableFuture
                  autoOk
                  disabled={!checkedFrom}
                  style={{
                    color: "white",
                    width: "40%",
                    marginRight: 20,
                  }}
                  variant="inline"
                  label="Day From"
                  format="yyyy-MM-dd"
                  value={startTime}
                  onChange={(e) => {
                    setStartTime(e);
                  }}
                  PopoverProps={{
                    classes: { root: classes.calendarPopover },
                  }}
                  className={classes.dateInput}
                  InputLabelProps={{
                    style: mode === "dark" ? { color: "#D3D3D3" } : {},
                  }}
                  InputProps={{
                    style: mode === "dark" ? { color: "white" } : {},
                  }}
                  keyboardIcon={
                    <Event
                      style={mode === "dark" ? { color: "#D3D3D3" } : {}}
                    />
                  }
                />
                <KeyboardTimePicker
                  disabled={!checkedFrom}
                  autoOk
                  style={{ width: "35%" }}
                  ampm={false}
                  variant="inline"
                  label="Time From"
                  format="HH:mm"
                  value={startTime}
                  onChange={(e) => {
                    setStartTime(e);
                  }}
                  PopoverProps={{
                    classes: { root: classes.timePopover },
                  }}
                  keyboardIcon={
                    <AccessTime
                      style={mode === "dark" ? { color: "#D3D3D3" } : {}}
                    />
                  }
                  className={classes.dateInput}
                  InputLabelProps={{
                    style: mode === "dark" ? { color: "#D3D3D3" } : {},
                  }}
                  InputProps={{
                    style: mode === "dark" ? { color: "white" } : {},
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Checkbox
                  classes={{
                    root: classes.checkboxDate,
                  }}
                  checked={checkedTo}
                  style={{
                    paddingTop: 20,
                    width: "8%",
                    paddingLeft: 5,
                    paddingRight: 15,
                  }}
                  icon={
                    <RadioButtonUnchecked
                      style={mode === "dark" ? { color: "white" } : {}}
                    />
                  }
                  checkedIcon={<CheckCircle style={{ color: "#088F8F" }} />}
                  onChange={handleCheckedTo}
                />
                <KeyboardDatePicker
                  disableFuture
                  autoOk
                  disabled={!checkedTo}
                  style={{ width: "40%", marginRight: 20 }}
                  variant="inline"
                  label="Day To"
                  format="yyyy-MM-dd"
                  value={endTime}
                  onChange={(e) => {
                    setEndTime(e);
                  }}
                  PopoverProps={{
                    classes: { root: classes.calendarPopover },
                  }}
                  className={classes.dateInput}
                  InputLabelProps={{
                    style: mode === "dark" ? { color: "#D3D3D3" } : {},
                  }}
                  InputProps={{
                    style: mode === "dark" ? { color: "white" } : {},
                  }}
                  keyboardIcon={
                    <Event
                      style={mode === "dark" ? { color: "#D3D3D3" } : {}}
                    />
                  }
                />
                <KeyboardTimePicker
                  disabled={!checkedTo}
                  autoOk
                  style={{ width: "35%" }}
                  ampm={false}
                  variant="inline"
                  label="Time To"
                  // views={['hours']}
                  format="HH:mm"
                  value={endTime}
                  onChange={(e) => {
                    setEndTime(e);
                  }}
                  PopoverProps={{
                    classes: { root: classes.timePopover },
                  }}
                  keyboardIcon={
                    <AccessTime
                      style={mode === "dark" ? { color: "#D3D3D3" } : {}}
                    />
                  }
                  className={classes.dateInput}
                  InputLabelProps={{
                    style: mode === "dark" ? { color: "#D3D3D3" } : {},
                  }}
                  InputProps={{
                    style: mode === "dark" ? { color: "white" } : {},
                  }}
                />
              </Grid>
              {error !== "" && (
                <Grid item xs={12} style={{ paddingLeft: 15, marginTop: 10 }}>
                  <Typography style={{ color: "red" }}>{error}</Typography>
                </Grid>
              )}
              <Grid
                container
                item
                xs={12}
                style={{ paddingRight: 15, marginTop: 10 }}
              >
                <Grid item xs={4}>
                  <Button
                    onClick={(e) => handleDone("today")}
                    style={{ marginLeft: 10 }}
                    size="small"
                    color="primary"
                    variant="contained"
                  >
                    Today
                  </Button>
                  {/* <FormControlLabel
                  style={{ marginLeft: 2 }}
                  control={
                    <Checkbox
                      checked={daily}
                      onChange={handleDaily}
                      color="primary"
                    />
                  }
                  label="Daily"
                /> */}
                </Grid>
                <Grid container item xs={8} justifyContent="flex-end">
                  <Button
                    style={{ marginLeft: 10 }}
                    size="small"
                    variant="contained"
                    autoFocus
                    color="primary"
                    onClick={() => setAnchorDate(null)}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={(e) => handleDone("done")}
                    style={{ marginLeft: 10 }}
                    size="small"
                    color="primary"
                    variant="contained"
                  >
                    Done
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Popover>
          <QueueLeaderboard
            orgId={orgId}
            historicals={historicals}
            summaries={summaries}
            leaderboardDeltas={leaderboardDeltas}
            queueCallStates={queueCallStates}
            // callEvents={callEvents}
            presenceEvents={presenceEvents}
            queuePresenceEvents={queuePresenceEvents}
            excludedQueues={excludedQueues}
            expandLeaderboard={expandLeaderboard}
            setExpandLeaderboard={setExpandLeaderboard}
            smaller={smaller}
            larger={larger}
            mode={mode}
            hudTab={hudTab}
            verticalPercent={verticalPercent}
            dateRange={dateRange}
            openDateRange={openDateRange}
            // openDatePicker={openDatePicker}
            fontSize={fontSize}
            increaseFont={increaseFont}
            decreaseFont={decreaseFont}
            updateLocal={updateLocal}
            local={local}
            offset={offset}
            tab={navTab}
            navPage={navPage}
            setActiveFilterRef={setActiveFilterRef}
            queueSelectedTab={queueSelectedTab}
          />
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    );
  }
);

const AgentLeaderboard = (() => {
  interface AgentData {
    id: string;
    display: string;
    lastName: string;
    firstName: string;
    extensionNumber: string;
    lastDndStatus: string;
    messageTimestamp: string;
    queuePresence: {
      all: Array<string>;
      accept: Array<string>;
      reject: Array<string>;
    };
    queues: Map<string, AgentCounts>;
  }

  interface AgentCounts {
    count?: number;
    duration?: number;
    maxDuration?: number;

    ringCountInbound?: number;
    ringTimeInbound?: number;
    maxRingTimeInbound?: number;
    ringCountOutbound?: number;
    ringTimeOutbound?: number;
    maxRingTimeOutbound?: number;

    talkCountInbound?: number;
    talkTimeInbound?: number;
    maxTalkTimeInbound?: number;
    talkCountOutbound?: number;
    talkTimeOutbound?: number;
    maxTalkTimeOutbound?: number;

    faxCount?: number;
    faxSendTime?: number;

    holdCountInbound?: number;
    holdTimeInbound?: number;
    maxHoldTimeInbound?: number;
    holdCountOutbound?: number;
    holdTimeOutbound?: number;
    maxHoldTimeOutbound?: number;

    vmAbandonedCount?: number;
    vmLeftCount?: number;
    vmDurationTime?: number;
    vmGreetingTime?: number;
    vmCount?: number;

    rcVideoCount?: number;

    hangupCount?: number;
    firstCall?: Date;
    lastCall?: Date;
  }

  // for formatting each queue a user is present in
  // function presentInFormatter(params: any) {
  //   return (
  //     <div>
  //       <Tooltip
  //         placement="bottom-start"
  //         title={params?.value?.map((v: string) => (
  //           <h4 style={{ fontSize: "1.2em", margin: 3 }}>{v}</h4>
  //         ))}
  //       >
  //         <div>{params?.value?.join(", ")}</div>
  //       </Tooltip>
  //     </div>
  //   );
  // }

  // sync issues, crappy work-around
  let temp: Array<Delta> | undefined = [];

  const timeFormatter = (time: number) => {
    // many of these exist in UK3, good to pass this down instead
    const totalSeconds = Math.floor(time / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  };

  const queuePresenceRenderer = ({ value }: ICellRendererParams) => {
    if (
      value === undefined ||
      value.accept === undefined ||
      value.all === undefined
    )
      return " ";

    const accepted = value.accept.length;
    const total = value.all.length;
    const percentage = total > 0 ? (accepted / total) * 100 : 0;

    // Percentage cutoff
    const greenThreshold = 75.0;
    const blueThreshold = 50.0;
    const yellowThreshold = 25.0;

    // Color based off percentage
    let color = "#ff0000"; // Default to Red
    if (percentage >= greenThreshold) color = "#4caf50"; // Green
    else if (percentage >= blueThreshold) color = "#2196f3"; // Blue
    else if (percentage >= yellowThreshold) color = "#ffeb3b"; // Yellow

    // Pie chart SVG
    const radius = 9;
    const strokeWidth = 4.5;
    const circumference = 2 * Math.PI * radius;

    // Adjust for stroke cap overshoot
    const correction = 3.5
    const adjustPercentage = Math.max(percentage - correction, 0);
    const offset = circumference - (circumference * adjustPercentage) / 100;

    // JSX Element to display progress bar
    return (
      <Tooltip
        title={`${accepted} of ${total} queues accepted`}
      >
      <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
        <div style={{ width: "50%", display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "0.9em", color: "#fff" }}>
          <svg width="25" height="25">
            <circle
              cx="12"
              cy="11.5"
              r={radius}
              stroke={color}
              strokeWidth={strokeWidth}
              opacity="0.3"
              fill="none"
            />
            <circle
              cx="12"
              cy="11.5"
              r={radius}
              stroke={color}
              strokeWidth={strokeWidth}
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              strokeLinecap="round"
              transform="rotate(-90 12 11.5)"
            />
          </svg>
          <div>
            {percentage.toFixed(1)}%
          </div>
        </div>
      </div>
      </Tooltip>
    )
  };

  return ({
    mode,
    fontSize,
    verticalPercent,
    expandLeaderboard,
    setExpandLeaderboard,
    smaller,
    larger,
    increaseFont,
    decreaseFont,
    historicals,
    summaries,
    leaderboardDeltas,
    excludedQueues,
    presenceEvents,
    queuePresenceEvents,
    local,
    updateLocal,
    showBusy,
    showAvailable,
    showDnd,
    showInvisible,
    queueSelectedTab,
    page,
    hudTab,
    offset,
    navTab,
    navPage,
    setActiveFilterRef,
    agentData,
  }: {
    mode: string;
    fontSize: string;
    verticalPercent: number;
    expandLeaderboard: boolean;
    setExpandLeaderboard: Function;
    smaller: Function;
    larger: Function;
    increaseFont: Function;
    decreaseFont: Function;
    historicals: Array<Historical>;
    summaries: Array<Summary>;
    leaderboardDeltas: Array<Delta>;
    excludedQueues: Set<string> | undefined;
    presenceEvents: Array<UserPresenceEvent>;
    queuePresenceEvents: Array<QueuePresenceEvent>;
    local: any;
    updateLocal: any;
    showBusy: boolean;
    showAvailable: boolean;
    showDnd: boolean;
    showInvisible: boolean;
    queueSelectedTab: string;
    page: string;
    hudTab: string;
    offset: number;
    navTab: string;
    navPage: string;
    agentData: any[];
    setActiveFilterRef: React.Dispatch<
      SetStateAction<{ [colId: string]: any }>
    >;
  }) => {
    const [anchorExport, setAnchorExport] = useState<null | HTMLElement>(null);
    const gridRef = useRef() as any;
    const [pinnedBottomRowData, setPinnedBottomRowData] = useState<
      | [{ extensionNumber: string; queues: Map<string, AgentCounts> }]
      | undefined
    >();

    const openExport = Boolean(anchorExport);
    const clickOnCsvExport = useCallback(() => {
      gridRef.current?.api?.exportDataAsCsv();
      setAnchorExport(null);
    }, []);
    const clickOnExcelExport = useCallback(() => {
      gridRef.current?.api?.exportDataAsExcel();
      setAnchorExport(null);
    }, []);
    const [agentRowData, setAgentRowData] = useState<AgentData[]>();
    const [gridReady, setGridReady] = useState<boolean>(false);
    const sideBar = useMemo(
      () => ({
        toolPanels: [
          "filters",
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
            toolPanelParams: {
              suppressRowGroups: true,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true,
              suppressColumnFilter: true,
              suppressColumnSelectAll: true,
              suppressColumnExpandAll: true,
            },
          },
        ],
        defaultToolPanel: "",
      }),
      []
    );
    useEffect(() => {
      if (
        queueSelectedTab === "agent" &&
        gridReady &&
        gridRef.current &&
        hudTab === "queues"
      ) {
        setActiveFilterRef(gridRef.current?.api?.getFilterModel());
      }
    }, [navPage, hudTab, gridReady, gridRef, queueSelectedTab]);

    const queuePresenceGetter = useCallback(
      (params: ValueGetterParams) => {
        if (params.data.extensionNumber === "Total") {
          return { all: undefined, accept: undefined };
        }
        const { all, accept } = params.data.queuePresence;
        const allFiltered =
          all?.filter((id: string) => !excludedQueues?.has(id)) || [];
        let acceptFiltered = [];
        acceptFiltered =
          accept?.filter((id: string) => !excludedQueues?.has(id)) || [];
        return { all: allFiltered, accept: acceptFiltered };
      },
      [excludedQueues]
    );

    const queuePresenceFilterValueGetter = useCallback(
      (params: ValueGetterParams) => {
        if (params.data.queuePresence?.accept !== undefined) {
          const { accept } = params.data.queuePresence;
          const acceptFiltered =
            accept?.filter((id: string) => !excludedQueues?.has(id)) || [];
          return acceptFiltered.length;
        }
        return 0;
      },
      [excludedQueues]
    );

    const sumValueGetter = useCallback(
      (
        params: { data: { queues: Map<string, AgentCounts> } },
        attributeName: keyof AgentCounts
      ) => {
        const userQueues: Map<string, AgentCounts> = params.data.queues;
        const value = Array.from(userQueues).reduce(
          (sum: number, [key, queueItem]: [string, AgentCounts]) => {
            if (excludedQueues?.has(key)) {
              return sum;
            }
            if (
              queueItem[attributeName] !== undefined &&
              typeof queueItem[attributeName] === "number"
            ) {
              return sum + (queueItem[attributeName]! as number);
            }
            return sum;
          },
          0
        );
        return value;
      },
      [excludedQueues]
    );

    const firstCallGetter = useCallback(
      (params: ValueGetterParams) => {
        const userQueues: Map<string, AgentCounts> = params.data.queues;
        const value = Array.from(userQueues).reduce(
          (sum: Date | undefined, [key, queueItem]: [string, AgentCounts]) => {
            if (excludedQueues?.has(key)) {
              return sum;
            }
            if (queueItem.firstCall === undefined) {
              return sum;
            }

            if (sum === undefined || sum > queueItem.firstCall) {
              return queueItem.firstCall;
            }

            return sum;
          },
          undefined
        );
        return value;
      },
      [excludedQueues]
    );

    const lastCallGetter = useCallback(
      (params: ValueGetterParams) => {
        const userQueues: Map<string, AgentCounts> = params.data.queues;
        const value = Array.from(userQueues).reduce(
          (sum: Date | undefined, [key, queueItem]: [string, AgentCounts]) => {
            if (excludedQueues?.has(key)) {
              return sum;
            }
            if (queueItem.lastCall === undefined) {
              return sum;
            }

            if (sum === undefined || sum < queueItem.lastCall) {
              return queueItem.lastCall;
            }

            return sum;
          },
          undefined
        );
        return value;
      },
      [excludedQueues]
    );

    const maxValueGetter = useCallback(
      (params: ValueGetterParams, attributeName: keyof AgentCounts) => {
        const userQueues: Map<string, AgentCounts> = params.data.queues;
        const value = Array.from(userQueues).reduce(
          (max: number, [key, queueItem]: [string, AgentCounts]) => {
            if (excludedQueues?.has(key)) {
              return max;
            }
            if (
              queueItem[attributeName] !== undefined &&
              typeof queueItem[attributeName] === "number" &&
              (queueItem[attributeName]! as number) > max
            ) {
              return queueItem[attributeName]! as number;
            }
            return max;
          },
          0
        );
        return value;
      },
      [excludedQueues]
    );

    const avgGetter = useCallback(
      (
        params: ValueGetterParams,
        sumAttributeName: keyof AgentCounts,
        countAttributeName: keyof AgentCounts
      ) => {
        const sum = sumValueGetter(params, sumAttributeName);
        const count = sumValueGetter(params, countAttributeName);
        if (sum !== 0 && count !== 0) {
          return sum / count;
        }
        return 0;
      },
      [sumValueGetter]
    );

    const extensionRenderer = useCallback((params: ICellRendererParams) => {
      const { extensionNumber } = params.data;
      if (extensionNumber === "Total") return " ";

      let presence = "Available";
      if (params.data.display !== undefined) {
        if (params.data.display.startsWith("DND:")) {
          presence = "Do not disturb";
        }
        if (params.data.display.startsWith("BSY:")) {
          presence = "Busy";
        }
        if (params.data.display.startsWith("INV:")) {
          presence = "Invisible";
        }
      }
      switch (presence) {
        case "Available":
          return (
            <div className="cell-wrapper bg-green">
              <div className="cell available-cell" />
              {extensionNumber}
            </div>
          );
        case "Busy":
          return (
            <div className="cell-wrapper bg-busy">
              <div className="cell busy-cell" />
              {extensionNumber}
            </div>
          );
        case "Do not disturb":
          return (
            <div className="cell-wrapper bg-dnd">
              <div className="cell dnd-cell" />
              {extensionNumber}
            </div>
          );
        case "Invisible":
          return (
            <div className="cell-wrapper bg-inv">
              <div className="cell inv-cell" />
              {extensionNumber}
            </div>
          );
        default:
          return <div className="cell-wrapper"> {extensionNumber}</div>;
      }
    }, []);

    const presenceRenderer = useCallback((params: ICellRendererParams) => {
      if (params.data.extensionNumber === "Total") return " ";
      let presence = "Available";
      if (params.data.display !== undefined) {
        if (params.data.display.startsWith("DND:")) {
          presence = "Do not disturb";
        }
        if (params.data.display.startsWith("BSY:")) {
          presence = "Busy";
        }
        if (params.data.display.startsWith("INV:")) {
          presence = "Invisible";
        }
      }

      switch (presence) {
        case "Available":
          return (
            <div className="cell-wrapper bg-green">
              <div className="cell available-cell" />
              {presence}
            </div>
          );
        case "Busy":
          return (
            <div className="cell-wrapper bg-busy">
              <div className="cell busy-cell" />
              {presence}
            </div>
          );
        case "Do not disturb":
          return (
            <div className="cell-wrapper bg-dnd">
              <div className="cell dnd-cell" />
              {presence}
            </div>
          );
        case "Invisible":
          return (
            <div className="cell-wrapper bg-inv">
              <div className="cell inv-cell" />
              {presence}
            </div>
          );

        default:
          return <div className="cell-wrapper"> {presence}</div>;
      }
    }, []);

    const auxRenderer = useCallback((params: ICellRendererParams) => {
      if (params.data.extensionNumber === "Total") return " ";
      const status = (params.data.display || "").substring(4);
      // if (params.data.extensionNumber === "Total") return "";
      let presence = "Available";
      if (params.data.display !== undefined) {
        if (params.data.display.startsWith("DND:")) {
          presence = "Do not disturb";
        }
        if (params.data.display.startsWith("BSY:")) {
          presence = "Busy";
        }
        if (params.data.display.startsWith("INV:")) {
          presence = "Invisible";
        }
      }

      switch (presence) {
        case "Available":
          return (
            <div className="cell-wrapper bg-green">
              <div className="cell available-cell" />
              {status || presence}
            </div>
          );

        case "Busy":
          return (
            <div className="cell-wrapper bg-busy">
              <div className="cell busy-cell" />
              {status || presence}
            </div>
          );
        case "Do not disturb":
          return (
            <div className="cell-wrapper bg-dnd">
              <div className="cell dnd-cell" />
              {status || presence}
            </div>
          );
        case "Invisible":
          return (
            <div className="cell-wrapper bg-inv">
              <div className="cell inv-cell" />
              {status || presence}
            </div>
          );
        default:
          return <div className="cell-wrapper"> {status || presence}</div>;
      }
    }, []);
    // const timeAvgCalculator = useCallback((_count: number, _max: number) => {
    //   if (_count !== 0 && _max !== 0) {
    //     const avg = _count / _max;
    //     const formatted = timeFormatter(avg);
    //     return formatted;
    //   }
    //   return timeFormatter(0);
    // }, []);

    const colDefs = useMemo(
      () => [
        {
          field: "firstName",
          title: "First name",
          filter: "agSetColumnFilter",
          cellClass: "notranslate",
        },
        { field: "lastName", title: "Last name", filter: "agSetColumnFilter" },
        {
          field: "extensionNumber",
          pinned: true,
          headerName: "Extension",
          cellClass: "notranslate",
          filter: "agSetColumnFilter",
          cellRenderer: extensionRenderer,
        },
        {
          field: "department",
          filter: "agSetColumnFilter",
          cellClass: "notranslate",
        },
        {
          field: "id",
          title: "User ID",
          filter: "agSetColumnFilter",
          cellClass: "notranslate",
          hide: true,
        },
        {
          field: "firstCall",
          headerName: "First Call",
          cellClass: "notranslate",
          filter: "agTextColumnFilter",
          valueGetter: firstCallGetter,
          valueFormatter: (params: any) => params.value?.toLocaleString(),
        },

        {
          field: "lastCall",
          headerName: "Last Call",
          cellClass: "notranslate",
          valueGetter: lastCallGetter,
          filter: "agTextColumnFilter",
          valueFormatter: (params: any) => params.value?.toLocaleString(),
        },
        // {
        //   field: "presentIn",
        //   filter: "agTextColumnFilter",
        //   // @ts-ignore
        //   cellRenderer: (params: any) => presentInFormatter(params),
        // },
        {
          field: "presence",
          cellClass: "notranslate",
          headerName: "EX Presence",
          width: 200,
          cellRenderer: presenceRenderer,
        },
        {
          field: "status",
          headerName: "Custom Presence",
          cellClass: "notranslate",
          width: 200,
          cellRenderer: auxRenderer,
        },
        {
          field: "queuePresence",
          cellClass: "notranslate",
          valueGetter: queuePresenceGetter,
          cellRenderer: queuePresenceRenderer,
          filter: "agNumberColumnFilter",
          filterValueGetter: queuePresenceFilterValueGetter,
          comparator: (
            valueA: { all: Array<string>; accept: Array<string> },
            valueB: { all: Array<string>; accept: Array<string> }
          ) => {
            if (valueA.accept.length === valueB.accept.length) {
              if (valueA.all.length === valueB.all.length) return 0;
              return valueA.all.length > valueB.all.length ? 1 : -1;
            }
            return valueA.accept.length > valueB.accept.length ? 1 : -1;
          },
        },
        {
          field: "count",
          headerName: "Total Calls",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: (params: any) => sumValueGetter(params, "count"),
        },
        {
          field: "duration",
          headerName: "Total Duration",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: (params: any) => sumValueGetter(params, "duration"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          field: "maxDuration",
          headerName: "Longest Duration",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: (params: any) => maxValueGetter(params, "maxDuration"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          headerName: "Average Duration",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: (params: any) => avgGetter(params, "duration", "count"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },

        {
          field: "ringCountInbound",
          headerName: "Inbound Offered",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: (params: any) =>
            sumValueGetter(params, "ringCountInbound"),
        },
        {
          field: "ringTimeInbound",
          headerName: "Inbound Ring Duration",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: (params: any) =>
            sumValueGetter(params, "ringTimeInbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },

        {
          field: "maxRingTimeInbound",
          headerName: "Longest Inbound Ring Duration",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: (params: any) =>
            maxValueGetter(params, "maxRingTimeInbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          headerName: "Average Inbound Ring Duration",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: (params: any) =>
            avgGetter(params, "ringTimeInbound", "ringCountInbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          field: "ringCountOutbound",
          headerName: "Outbound Offered",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: (params: any) =>
            sumValueGetter(params, "ringCountOutbound"),
        },
        {
          field: "ringTimeOutbound",
          headerName: "Outbound Ring Duration",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: (params: any) =>
            sumValueGetter(params, "ringTimeOutbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },

        {
          field: "maxRingTimeOutbound",
          headerName: "Longest Outbound Ring Duration",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: (params: any) =>
            maxValueGetter(params, "maxRingTimeOutbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          headerName: "Average Outbound Ring Duration",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: (params: any) =>
            avgGetter(params, "ringTimeOutbound", "ringCountOutbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          field: "talkCountInbound",
          filter: "agNumberColumnFilter",
          headerName: "Inbound Answered",
          cellClass: "notranslate",
          valueGetter: (params: any) =>
            sumValueGetter(params, "talkCountInbound"),
        },
        {
          field: "talkTimeInbound",
          filter: "agNumberColumnFilter",
          headerName: "Inbound Answered Duration",
          cellClass: "notranslate",
          valueGetter: (params: any) =>
            sumValueGetter(params, "talkTimeInbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          field: "maxTalkTimeInbound",
          filter: "agNumberColumnFilter",
          headerName: "Longest Inbound Answered Duration",
          cellClass: "notranslate",
          valueGetter: (params: any) =>
            maxValueGetter(params, "maxTalkTimeInbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          headerName: "Average Inbound Answered Duration",
          filter: "agNumberColumnFilter",
          cellClass: "notranslate",
          valueGetter: (params: any) =>
            avgGetter(params, "talkTimeInbound", "talkCountInbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          field: "talkCountOutbound",
          headerName: "Outbound Answered",
          cellClass: "notranslate",
          valueGetter: (params: any) =>
            sumValueGetter(params, "talkTimeOutbound"),
        },
        {
          field: "talkTimeOutbound",
          filter: "agNumberColumnFilter",
          headerName: "Outbound Answered Duration",
          cellClass: "notranslate",
          valueGetter: (params: any) =>
            sumValueGetter(params, "talkTimeOutbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          field: "maxTalkTimeOutbound",
          filter: "agNumberColumnFilter",
          headerName: "Longest Outbound Answered Duration",
          cellClass: "notranslate",
          valueGetter: (params: any) =>
            maxValueGetter(params, "maxTalkTimeOutbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          headerName: "Average Outbound Answered Duration",
          filter: "agNumberColumnFilter",
          cellClass: "notranslate",
          valueGetter: (params: any) =>
            avgGetter(params, "talkTimeOutbound", "talkCountOutbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },

        {
          field: "holdCountOutbound",
          filter: "agNumberColumnFilter",
          headerName: "Outbound Hold Count",
          cellClass: "notranslate",
          valueGetter: (params: any) =>
            sumValueGetter(params, "holdCountOutbound"),
        },
        {
          field: "holdTimeOutbound",
          filter: "agNumberColumnFilter",
          headerName: "Longest Outbound Hold Duration",
          cellClass: "notranslate",
          valueGetter: (params: any) =>
            sumValueGetter(params, "holdTimeOutbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          field: "maxHoldTimeOutbound",
          filter: "agNumberColumnFilter",
          headerName: "Outbound Hold Duration",
          cellClass: "notranslate",
          valueGetter: (params: any) =>
            maxValueGetter(params, "maxHoldTimeOutbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          headerName: "Average Outbound Hold Duration",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: (params: any) =>
            avgGetter(params, "holdTimeOutbound", "holdCountOutbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },

        {
          field: "holdCountInbound",
          filter: "agNumberColumnFilter",
          headerName: "Inbound Hold Count",
          cellClass: "notranslate",
          valueGetter: (params: any) =>
            sumValueGetter(params, "holdCountInbound"),
        },
        {
          field: "holdTimeInbound",
          filter: "agNumberColumnFilter",
          headerName: "Inbound Hold Duration",
          cellClass: "notranslate",
          valueGetter: (params: any) =>
            maxValueGetter(params, "maxHoldTimeInbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          field: "maxHoldTimeInbound",
          filter: "agNumberColumnFilter",
          headerName: "Longest Inbound Hold Duration",
          cellClass: "notranslate",
          valueGetter: (params: any) =>
            sumValueGetter(params, "holdTimeInbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          headerName: "Average Inbound Hold Duration",
          cellClass: "notranslate",
          filter: "agNumberColumnFilter",
          valueGetter: (params: any) =>
            avgGetter(params, "holdTimeInbound", "holdCountInbound"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          field: "vmCount",
          filter: "agNumberColumnFilter",
          headerName: "Calls to VM",
          cellClass: "notranslate",
          valueGetter: (params: any) => sumValueGetter(params, "vmCount"),
        },
        {
          field: "vmAbandonedCount",
          filter: "agNumberColumnFilter",
          headerName: "Abandoned VM",
          cellClass: "notranslate",
          valueGetter: (params: any) =>
            sumValueGetter(params, "vmAbandonedCount"),
        },
        {
          field: "vmGreetingTime",
          filter: "agNumberColumnFilter",
          headerName: "Total VM Greeting Duration",
          cellClass: "notranslate",
          valueGetter: (params: any) =>
            sumValueGetter(params, "vmGreetingTime"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          field: "vmDurationTime",
          filter: "agNumberColumnFilter",
          headerName: "Total VM Duration",
          cellClass: "notranslate",
          valueGetter: (params: any) =>
            sumValueGetter(params, "vmDurationTime"),
          valueFormatter: (params: any) => timeFormatter(params.value),
        },
        {
          field: "hangupCount",
          filter: "agNumberColumnFilter",
          headerName: "Near End Hangups",
          cellClass: "notranslate",
          width: 170,
          valueGetter: (params: any) => sumValueGetter(params, "hangupCount"),
        },
      ],
      [
        avgGetter,
        maxValueGetter,
        sumValueGetter,
        presenceRenderer,
        auxRenderer,
        extensionRenderer,
        queuePresenceGetter,
        queuePresenceRenderer,
        firstCallGetter,
        lastCallGetter,
        queuePresenceFilterValueGetter,
      ]
    );

    const setTotals = useCallback(() => {
      if (!gridRef) return;
      if (!gridRef.current) return;

      const totalQueues = new Map() as Map<string, AgentCounts>;
      try {
        gridRef.current?.api?.forEachNodeAfterFilter((rowNode: any, i: any) => {
          if (rowNode.data.queues) {
            rowNode.data.queues.forEach((value: AgentCounts, key: string) => {
              const thisQueueInTotal = totalQueues.get(key) || {
                count: 0,
                duration: 0,
                maxDuration: 0,
                ringCountInbound: 0,
                ringTimeInbound: 0,
                maxRingTimeInbound: 0,
                ringCountOutbound: 0,
                ringTimeOutbound: 0,
                maxRingTimeOutbound: 0,
                talkCountInbound: 0,
                maxTalkTimeInbound: 0,
                talkTimeInbound: 0,
                talkCountOutbound: 0,
                maxTalkTimeOutbound: 0,
                talkTimeOutbound: 0,
                holdCountOutbound: 0,
                holdTimeOutbound: 0,
                maxHoldTimeOutbound: 0,
                holdCountInbound: 0,
                holdTimeInbound: 0,
                maxHoldTimeInbound: 0,
                vmCount: 0,
                vmAbandonedCount: 0,
                vmGreetingTime: 0,
                vmDurationTime: 0,
                hangupCount: 0,
              };
              [
                "count",
                "duration",
                "ringCountInbound",
                "ringTimeInbound",
                "ringCountOutbound",
                "ringTimeOutbound",
                "talkCountInbound",
                "talkCountOutbound",
                "talkTimeInbound",
                "talkTimeOutbound",
                "holdCountInbound",
                "holdCountOutbound",
                "holdTimeInbound",
                "holdTimeOutbound",
                "vmCount",
                "vmAbandonedCount",
                "vmGreetingTime",
                "vmDurationTime",
                "hangupCount",
              ].forEach((myKey) => {
                const increment = value[myKey as keyof AgentCounts] as
                  | number
                  | undefined;
                if (increment !== undefined) {
                  // @ts-ignore
                  thisQueueInTotal[myKey] += increment;
                }
              });
              [
                "maxDuration",
                "maxRingTimeInbound",
                "maxRingTimeOutbound",
                "maxTalkTimeInbound",
                "maxTalkTimeOutbound",
                "maxHoldTimeInbound",
                "maxHoldTimeOutbound",
              ].forEach((myKey) => {
                const setter = value[myKey as keyof AgentCounts] as
                  | number
                  | undefined;

                if (
                  setter !== undefined &&
                  // @ts-ignore
                  setter > thisQueueInTotal[myKey]
                ) {
                  // @ts-ignore
                  thisQueueInTotal[myKey] = setter;
                }
              });
              totalQueues.set(key, thisQueueInTotal);
            });
          }
        });
      } catch (e) {
        console.log("SetTotals forEachAfterFilter", e);
      }

      // setTimeout(() => {
      try {
        setPinnedBottomRowData([
          {
            extensionNumber: "Total",
            queues: totalQueues,
            ...[
              "count",
              "duration",
              "ringCountInbound",
              "ringTimeInbound",
              "ringCountOutbound",
              "ringTimeOutbound",
              "talkCountInbound",
              "talkCountOutbound",
              "talkTimeInbound",
              "talkTimeOutbound",
              "holdCountInbound",
              "holdCountOutbound",
              "holdTimeInbound",
              "holdTimeOutbound",
              "vmCount",
              "vmAbandonedCount",
              "vmGreetingTime",
              "vmDurationTime",
              "hangupCount",

              "maxDuration",
              "maxRingTimeInbound",
              "maxRingTimeOutbound",
              "maxTalkTimeInbound",
              "maxTalkTimeOutbound",
              "maxHoldTimeInbound",
              "maxHoldTimeOutbound",
            ].reduce(
              (sum, key) => ({
                ...sum,
                [key]: sumValueGetter(
                  { data: { queues: totalQueues } },
                  key as keyof AgentCounts
                ),
              }),
              {}
            ),
          },
        ]);
      } catch (e) {
        console.log("SetTotals pinnedData", e);
      }
      // }, 0);
    }, []);

    const defaultColDef = useMemo(
      () => ({
        sortable: true,
        resizable: true,
        animateRows: false,
        detailRowHeight: 200,
        cellClass: " notarnslate ",
        cellClassRules: {
          small: () => fontSize === "small",
          medium: () => fontSize === "medium",
          large: () => fontSize === "large",
        },
      }),
      [fontSize]
    );

    useEffect(() => {
      const data = historicals[0];
      if (data === undefined) {
        return;
      }
      setAgentRowData(() =>
        data.user
          ?.filter((user) =>
            data.queue?.some((queue) =>
              queue.users?.some((agent) => agent.id === user.id)
            )
          )
          .map((agent) => {
            const queuePresence = data.queue.reduce(
              (
                sum: {
                  all: Array<string>;
                  accept: Array<string>;
                  reject: Array<string>;
                },
                queue: {
                  users: Array<{
                    id: string;
                    acceptCurrentQueueCalls: boolean;
                  }>;
                  extensionNumber: string;
                  name: string;
                  id: string;
                  ivrId?: string;
                }
              ) => {
                const queueUsers = queue.users;
                const { accept, all, reject } = sum;
                const found = queueUsers.find((user) => user.id === agent.id);
                if (found) {
                  all.push(queue.id);
                  if (found.acceptCurrentQueueCalls) {
                    if (agent.lastDndStatus === "TakeAllCalls") {
                      accept.push(queue.id);
                    }
                  } else {
                    reject.push(queue.id);
                  }
                }

                return { all, accept, reject };
              },
              { all: [], accept: [], reject: [] }
            );
            return {
              ...agent,
              queuePresence,
              queues: new Map(),
            };
          })
      );
    }, [historicals]);

    const processDelta = useCallback((delta: Delta) => {
      setAgentRowData((oldRowData) =>
        oldRowData?.map((agent) => {
          if (agent.id !== delta.userId) {
            return agent;
          }
          // for ts
          if (delta.queueId === undefined) {
            return agent;
          }

          const newAgent = { ...agent };

          // being careful not to mutate directly
          newAgent.queues = new Map(newAgent.queues);

          const thisQueue: AgentCounts = newAgent.queues.get(delta.queueId) || {
            count: 0,
            duration: 0,
            maxDuration: 0,
            ringCountInbound: 0,
            ringTimeInbound: 0,
            maxRingTimeInbound: 0,
            ringCountOutbound: 0,
            ringTimeOutbound: 0,
            maxRingTimeOutbound: 0,
            talkCountInbound: 0,
            maxTalkTimeInbound: 0,
            talkTimeInbound: 0,
            talkCountOutbound: 0,
            maxTalkTimeOutbound: 0,
            talkTimeOutbound: 0,
            holdCountOutbound: 0,
            holdTimeOutbound: 0,
            maxHoldTimeOutbound: 0,
            holdCountInbound: 0,
            holdTimeInbound: 0,
            maxHoldTimeInbound: 0,
            vmCount: 0,
            vmAbandonedCount: 0,
            vmGreetingTime: 0,
            vmDurationTime: 0,
            hangupCount: 0,
          };

          [
            "count",
            "duration",
            "ringCountInbound",
            "ringTimeInbound",
            "ringCountOutbound",
            "ringTimeOutbound",
            "talkCountInbound",
            "talkCountOutbound",
            "talkTimeInbound",
            "talkTimeOutbound",
            "holdCountInbound",
            "holdCountOutbound",
            "holdTimeInbound",
            "holdTimeOutbound",
            "vmCount",
            "vmAbandonedCount",
            "vmGreetingTime",
            "vmDurationTime",
            "hangupCount",
          ].forEach((key) => {
            const increment = delta[key as keyof Delta] as number | undefined;

            if (increment !== undefined) {
              // @ts-ignore

              thisQueue[key] += increment;
            }
          });

          [
            "maxDuration",
            "maxRingTimeInbound",
            "maxRingTimeOutbound",
            "maxTalkTimeInbound",
            "maxTalkTimeOutbound",
            "maxHoldTimeInbound",
            "maxHoldTimeOutbound",
          ].forEach((key) => {
            const setter = delta[key as keyof Delta] as number | undefined;
            // @ts-ignore
            if (setter !== undefined && setter > thisQueue[key]) {
              // @ts-ignore
              thisQueue[key] = setter;
            }
          });

          ["firstCall"].forEach((key) => {
            const increment = delta[key as keyof Delta] as string | undefined;

            if (increment !== undefined) {
              if (
                // @ts-ignore
                thisQueue[key] === undefined ||
                // @ts-ignore
                thisQueue[key].toISOString() > increment
              ) {
                // @ts-ignore
                thisQueue[key] = new Date(increment);
              }
            }
          });

          ["lastCall"].forEach((key) => {
            const increment = delta[key as keyof Delta] as string | undefined;

            if (increment !== undefined) {
              if (
                // @ts-ignore
                thisQueue[key] === undefined ||
                // @ts-ignore
                thisQueue[key].toISOString() < increment
              ) {
                // @ts-ignore
                thisQueue[key] = new Date(increment);
              }
            }
          });

          newAgent.queues.set(delta.queueId, thisQueue);

          return newAgent;
        })
      );
    }, []);

    useEffect(() => {
      if (agentRowData === undefined) {
        return;
      }

      if (temp === undefined) {
        return;
      }

      // just an accumulation while loading
      temp.forEach(processDelta);

      temp = undefined;
    }, [agentRowData, processDelta]);

    useEffect(() => {
      const data = summaries[0];
      if (data === undefined) {
        return;
      }

      if (temp !== undefined) {
        temp = temp.concat(data.agents);
        return;
      }

      data.agents.forEach(processDelta);
    }, [summaries, processDelta]);

    useEffect(() => {
      if (!presenceEvents || presenceEvents.length === 0) {
        return;
      }

      setAgentRowData((oldRowData) =>
        oldRowData?.map((agent) => {
          // Find all events relevant to this agent
          const relevantEvents = presenceEvents.filter(
            (event) => event.id === agent.id
          );

          if (relevantEvents.length === 0) {
            return agent; // No relevant events for this agent
          }

          // Process the most recent event for the agent
          const latestEvent = relevantEvents.reduce((latest, current) =>
            current.messageTimestamp > (latest.messageTimestamp || 0)
              ? current
              : latest
          );

          const myAgent = { ...agent };
          if (
            myAgent.messageTimestamp === undefined ||
            latestEvent.messageTimestamp > myAgent.messageTimestamp
          ) {
            let myAgentAcceptQueues = myAgent.queuePresence.accept;

            if (latestEvent.lastDndStatus === "TakeAllCalls") {
              myAgentAcceptQueues = myAgent.queuePresence.all.filter(
                (queueId) => !myAgent.queuePresence.reject.includes(queueId)
              );
            } else {
              myAgentAcceptQueues = [];
            }

            return {
              ...myAgent,
              queuePresence: {
                ...myAgent.queuePresence,
                accept: myAgentAcceptQueues,
              },
              ...latestEvent,
            };
          }
          return agent;
        })
      );

      // Slightly delay to ensure grid has data
      setTimeout(() => {
        presenceEvents.forEach((record) => {
          const rowNode = gridRef.current?.api?.getRowNode(record.id);
          if (rowNode) {
            gridRef.current?.api?.refreshCells({
              rowNodes: [rowNode],
              columns: [
                "extensionNumber",
                "presence",
                "status",
                "queuePresence",
              ],
              force: true,
            });
          }
        });
      }, 50);
    }, [presenceEvents]);

    useEffect(() => {
      const record = queuePresenceEvents[0];
      if (record === undefined) {
        return;
      }

      setAgentRowData((oldRowData) =>
        oldRowData?.map((agent) => {
          if (agent.id !== record.userId) {
            return agent;
          }
          const myAgent = { ...agent };
          const myAgentAcceptQueues = new Set(myAgent.queuePresence.accept);
          const myAgentRejectQueues = new Set(myAgent.queuePresence.reject);
          if (record.acceptCurrentQueueCalls) {
            if (myAgent.lastDndStatus === "TakeAllCalls") {
              myAgentAcceptQueues.add(record.id);
            }
            myAgentRejectQueues.delete(record.id);
          } else {
            myAgentAcceptQueues.delete(record.id);
            myAgentRejectQueues.add(record.id);
          }
          myAgent.queuePresence = {
            ...myAgent.queuePresence,
            accept: Array.from(myAgentAcceptQueues),
          };
          return myAgent;
        })
      );
    }, [queuePresenceEvents]);

    useEffect(() => {
      if (leaderboardDeltas.length === 0) {
        return;
      }

      leaderboardDeltas.forEach((delta: Delta) => {
        if (delta.queueId === undefined) {
          return;
        }

        if (temp !== undefined) {
          temp = temp.concat([delta]);
          return;
        }

        processDelta(delta);
      });
    }, [leaderboardDeltas]);

    useEffect(() => {
      console.log("agentData", agentData);
      if (agentData.length === 0 || !gridReady) {
        return;
      }
      agentData.forEach((agent) => processDelta(agent));
    }, [agentData, gridReady]);

    // // external filters will be checked every time filters changed
    // const doesExternalFilterPass = useCallback(
    //   (node: RowNode<AgentData>) => {
    //     if (node.data?.id) {
    //       return !excludedUsers?.has(node.data?.id);
    //     }
    //     return false;
    //   },
    //   [excludedUsers]
    // );

    useEffect(() => {
      setTotals();
    }, [agentRowData, setTotals]);

    const onFilterChanged = useCallback(() => {
      setTotals();
      if (
        queueSelectedTab === "agent" &&
        gridReady &&
        gridRef.current &&
        hudTab === "queues"
      ) {
        setActiveFilterRef(gridRef.current?.api?.getFilterModel());
      }
    }, [setTotals, queueSelectedTab, gridReady, gridRef, hudTab]);

    const doesExternalFilterPass = useCallback(
      (node: RowNode<AgentData>) => {
        if (node.data) {
          const userQueueIds = Array.from(node.data.queuePresence?.all);
          // every queue od the user is excluded
          if (userQueueIds.every((queueId) => excludedQueues?.has(queueId))) {
            return false;
          }
          if (
            node.data?.display === undefined ||
            node.data?.display.startsWith("AVL:")
          ) {
            return showAvailable;
          }
          if (node.data?.display.startsWith("BSY:")) {
            return showBusy;
          }
          if (node.data?.display.startsWith("DND:")) {
            return showDnd;
          }
          if (node.data?.display.startsWith("INV:")) {
            return showInvisible;
          }
          return true;
        }
        return false;
      },
      [excludedQueues, showAvailable, showBusy, showDnd, showInvisible]
    );

    // trigger external filters on queue filters change
    useEffect(() => {
      if (!gridReady) {
        return;
      }
      gridRef.current?.api.onFilterChanged();
    }, [
      excludedQueues,
      gridReady,
      showBusy,
      showAvailable,
      showInvisible,
      showDnd,
      agentRowData,
    ]);

    const columnChanges = useCallback(() => {
      if (gridRef.current?.columnApi === undefined) {
        return;
      }
      localStorage.setItem(
        `queue-summary-agent`,
        JSON.stringify(gridRef.current!.columnApi.getColumnState())
      );
      // updateLocal(
      //   `queue-summary-agent`,
      //   JSON.stringify(gridRef.current!.columnApi.getColumnState())
      // );
    }, [gridRef]);

    useEffect(() => {
      if (
        gridReady &&
        gridRef.current !== undefined &&
        gridRef.current !== null &&
        gridRef?.current.columnApi !== null
      ) {
        //  applying column state changes from last session
        const raw = localStorage.getItem(`queue-summary-agent`);
        const columnData = raw ? JSON.parse(raw) : [];
        gridRef.current.columnApi.applyColumnState({
          state: columnData,
          applyOrder: true,
        });
      }
    }, [gridReady, local, gridRef]);

    return (
      <div>
        <Toolbar
          disableGutters
          variant="dense"
          style={{
            minHeight: "50px",
            backgroundColor: mode === "dark" ? "#181818" : "#0684bd",
            borderRadius: "5px 5px 0px 0px",
          }}
        >
          <Grid container justifyContent="space-between">
            <Grid
              item
              xs={4}
              md={4}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Button
                variant="text"
                disableRipple
                style={{
                  backgroundColor: "transparent",
                  color: "#fff",
                  textTransform: "none",
                }}
                onClick={() => setExpandLeaderboard(!expandLeaderboard)}
                startIcon={
                  expandLeaderboard ? (
                    <ExpandLess style={{ color: "white" }} />
                  ) : (
                    <ExpandMore style={{ color: "white" }} />
                  )
                }
              >
                Leaderboard
                {gridRef &&
                  gridRef.current &&
                  gridRef.current.api &&
                  Object?.keys(gridRef.current?.api?.getFilterModel() || {})
                    ?.length > 0 && (
                    <button
                      type="button"
                      style={{
                        cursor: "pointer",
                        background: "none",
                        border: "none",
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "agGridAlpine",
                          color: "white",
                          fontSize: "1.4em",
                        }}
                        className="ag-theme-alpine ag-icon-filter"
                      />
                    </button>
                  )}
              </Button>
            </Grid>
            {expandLeaderboard && (
              <Grid
                container
                item
                xs={8}
                alignItems="center"
                direction="row-reverse"
                style={{ paddingTop: "0.3rem" }}
              >
                <Grid container item xs={12} justifyContent="flex-end">
                  <Button
                    id="queue-leaderboard-download"
                    onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
                      setAnchorExport(e.currentTarget)
                    }
                    aria-controls={openExport ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={openExport ? "true" : undefined}
                    size="small"
                    style={{
                      height: "32px",
                      width: "32px",
                      minWidth: "24px",
                    }}
                  >
                    <GetApp style={{ color: "white" }} />
                  </Button>

                  <Button
                    size="small"
                    style={{
                      height: "32px",
                      width: "32px",
                      minWidth: "24px",
                    }}
                    onClick={() => larger()}
                  >
                    <UnfoldMore style={{ color: "white" }} />
                  </Button>
                  <Button
                    size="small"
                    style={{ height: "32px", width: "32px", minWidth: "24px" }}
                    onClick={() => smaller()}
                  >
                    <UnfoldLess style={{ color: "white" }} />
                  </Button>
                  <Button
                    onClick={() => increaseFont()}
                    size="small"
                    style={{
                      height: "32px",
                      width: "32px",
                      minWidth: "24px",
                    }}
                  >
                    <TextFormat
                      style={{ fontSize: "1.8rem", color: "white" }}
                    />
                  </Button>
                  <Button
                    onClick={() => decreaseFont()}
                    size="small"
                    style={{ height: "32px", width: "32px", minWidth: "24px" }}
                  >
                    <TextFormat fontSize="small" style={{ color: "white" }} />
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  style={{ marginBottom: 5, marginTop: 5 }}
                />
              </Grid>
            )}
          </Grid>
        </Toolbar>
        <Menu
          disableEnforceFocus
          disableAutoFocus
          anchorEl={anchorExport}
          id="basic-menu"
          open={openExport}
          getContentAnchorEl={null}
          // transformOrigin={{ horizontal: 'left', vertical: 'top' }}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
          onClose={() => setAnchorExport(null)}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem
            id="queue-leaderboard-download-csv"
            onClick={clickOnCsvExport}
          >
            CSV Export
          </MenuItem>
          <MenuItem
            id="queue-leaderboard-download-excel"
            onClick={clickOnExcelExport}
          >
            Excel Export
          </MenuItem>
        </Menu>
        <Collapse in={expandLeaderboard} timeout="auto">
          <div
            style={{ width: "100%", height: `${verticalPercent}vh` }}
            className={`${
              mode === "light" ? "ag-theme-alpine" : "ag-theme-alpine-dark"
            }`}
          >
            <AgGridReact
              getRowId={(params) => params.data.id}
              suppressCopyRowsToClipboard
              columnDefs={colDefs}
              rowData={agentRowData}
              rowSelection="multiple"
              paginationAutoPageSize
              pagination
              rowHeight={28}
              defaultColDef={defaultColDef}
              ref={gridRef}
              suppressScrollOnNewData
              sideBar={sideBar}
              onGridReady={() => setGridReady(true)}
              onFilterChanged={onFilterChanged}
              isExternalFilterPresent={() => true}
              doesExternalFilterPass={doesExternalFilterPass}
              onSortChanged={columnChanges}
              onColumnMoved={columnChanges}
              onColumnVisible={columnChanges}
              onColumnPinned={columnChanges}
              onColumnResized={columnChanges}
              pinnedBottomRowData={pinnedBottomRowData}
              // enableCellChangeFlash={true}
            />
          </div>
        </Collapse>
      </div>
    );
  };
})();

interface User {
  id: string;
  lastName: string;
  firstName: string;
  extensionNumber: string;
}
interface Queue {
  id: string;
  name: string;
}

const Queues = React.memo(
  ({
    tabCounts,
    setTabCounts,
    rcId,
    historicals,
    callEvents,
    presenceEvents,
    queuePresenceEvents,
    excludedQueues,
    summaries,
    getSummary,
    mode,
    leaderboardUrl,
    local,
    updateLocal,
    page,
    hudTab,
    offset,
    queueCallStates,
    callbackStates,
    deviceId,
    rcAccessToken,
    queueCallPickUp,
    showCherryPick,
    spoiledCherryPickCalls,
    setSpoiledCherryPickCalls,
    showVip,
    vipList,
    showCallback,
    callbacks,
    selfUser,
    accessToken,
    forwardAddress,
    origin,
    organizationId,
    markedAsCalledBack,
    navTab,
    navPage,
    agentLeaderboard,
    leaderboardDeltas,
    showBusy,
    showAvailable,
    showDnd,
    showInvisible,
    apiUrl,
    newCallback,
    deletedVMs,
    setActiveFilterRef,
    agentData,
  }: {
    tabCounts: {voicemail: number, callback: number, abandoned: number},
    setTabCounts: React.Dispatch<SetStateAction<{voicemail: number; callback: number; abandoned: number;}>>;
    rcId: string;
    historicals: Array<Historical>;
    callEvents: Array<CallEvent>;
    presenceEvents: Array<UserPresenceEvent>;
    queuePresenceEvents: Array<QueuePresenceEvent>;
    excludedQueues: Set<string> | undefined;
    summaries: Array<Summary>;
    getSummary: any;
    mode: string;
    leaderboardUrl: string | undefined;
    local: any;
    updateLocal: any;
    page: string;
    hudTab: string;
    offset: number;
    queueCallStates: Array<QueueCallState>;
    callbackStates: Array<CallbackState>;
    deviceId: string | undefined;
    rcAccessToken: string | undefined;
    queueCallPickUp: boolean;
    showCherryPick: boolean | undefined;
    spoiledCherryPickCalls: Set<string>;
    setSpoiledCherryPickCalls: any;
    vipList: { number: string; name: string }[];
    showVip: boolean;
    showCallback: boolean;
    callbacks: Array<CallbackState> | undefined;
    selfUser: any;
    accessToken: string;
    forwardAddress: string;
    origin: string;
    organizationId: string;
    markedAsCalledBack: Array<any>;
    navTab: string;
    navPage: string;
    agentLeaderboard: boolean;
    leaderboardDeltas: Array<Delta>;
    showAvailable: boolean;
    showBusy: boolean;
    showDnd: boolean;
    showInvisible: boolean;
    apiUrl: string;
    newCallback: boolean;
    deletedVMs: Set<string>;
    agentData: any[];
    setActiveFilterRef: React.Dispatch<
      SetStateAction<{ [colId: string]: any }>
    >;
  }) => {
    const [verticalPercent, setVerticalPercent] = useState(50);
    const [fontSize, setFontSize] = useState("small");
    const [theme, setTheme] = useState("ag-theme-alpine");
    const [tab, setTab] = useState<
      | "summary"
      | "waiting"
      | "inProgress"
      | "callback"
      | "abandoned"
      | "voicemail"
      | "agent"
    >("summary");

    const [expandQLeaderboard, setExpandQLeaderboard] = useState<boolean>(true);
    const [historicalState, setHistoricalState] = useState<
      | {
          users: Map<string, User>;
          queues: Map<string, Queue>;
          queuesById: Map<string, Queue>;
        }
      | undefined
    >();
    const [rowData, setRowData] = useState<Array<any> | undefined>(); // Set rowData to Array of Objects, one Object per Row
    const [transcriptTimeout, setTranscriptTimeout] = useState<number>(30);
    const [queueWaitingCount, setQueueWaitingCount] = useState<number>(0);
    const [inProgressCount, setInProgressCount] = useState<number>(0);
    const [abandonedGridRef, setAbandonedGridRef] = useState<any>();
    const [voicemailGridRef, setVoicemailGridRef] = useState<any>();
    const [callbackGridRef, setCallbackGridRef] = useState<any>();

    useEffect(() => {
      const now = new Date();
      const callbackTS = localStorage.getItem("abandonedTimestamp") as
        | string
        | null;
      const abandonedTS = localStorage.getItem("callbackTimestamp") as
        | string
        | null;
      const voicemailTS = localStorage.getItem("voicemailTimestamp") as
        | string
        | null;
      if (!callbackTS) {
        localStorage.setItem("abandonedTimestamp", now.toString());
      }
      if (!abandonedTS) {
        localStorage.setItem("callbackTimestamp", now.toString());
      }
      if (!voicemailTS) {
        localStorage.setItem("voicemailTimestamp", now.toString());
      }

      switch (tab) {
        case "callback": {
          localStorage.setItem("callbackTimestamp", now.toString());
          break;
        }
        case "abandoned": {
          localStorage.setItem("abandonedTimestamp", now.toString());
          break;
        }
        case "voicemail": {
          localStorage.setItem("voicemailTimestamp", now.toString());
          break;
        }
        default:
          break;
      }

      console.log('STATES CALLBACK: ', rowData)
      const abandonedFilter = (rowData || []).filter((d) => {
        const startsWithAbandoned = d.state
          ?.toUpperCase()
          .includes("ABANDONED");
        const hasNoVM = d.vmDurationTime === undefined;
        return startsWithAbandoned && hasNoVM;
      });
      const callbackFilter = (rowData || []).filter((d) =>
        d.state?.includes("CALLBACK")
      );
      const voicemailFilter = (rowData || []).filter((d) => {
        const startsWithAbandoned = d.state
          ?.toUpperCase()
          .includes("ABANDONED");
        const hasVM = d.vmDurationTime !== undefined;
        return startsWithAbandoned && hasVM;
      });

      const recentAbnd = abandonedFilter?.filter(
        (a) =>
          Math.floor(new Date(a.time)?.getTime() / 1000) >
          Math.floor(
            new Date(
              localStorage.getItem("abandonedTimestamp") as string
            )?.getTime() / 1000
          )
      );
      const recentCallback = callbackFilter?.filter(
        (a) =>
          Math.floor(new Date(a.time)?.getTime() / 1000) >
          Math.floor(
            new Date(
              localStorage.getItem("callbackTimestamp") as string
            )?.getTime() / 1000
          )
      );
      const recentVoicemail = voicemailFilter?.filter(
        (a) =>
          Math.floor(new Date(a.time)?.getTime() / 1000) >
          Math.floor(
            new Date(
              localStorage.getItem("voicemailTimestamp") as string
            )?.getTime() / 1000
          )
      );
      // using counters 
      console.log('setting callback counter.');
 
      setTabCounts(() => ({
        voicemail: tab === "voicemail" ? 0 : recentVoicemail.length,
        callback: tab === "callback" ? 0 : recentCallback.length,
        abandoned: tab === "abandoned" ? 0 : recentAbnd.length,
      }));
    }, [tab, rowData]);

    // eslint-disable-next-line
    const classes = mode === "light" ? useStyles() : useDarkStyles();
    const smaller = useCallback(() => {
      setVerticalPercent((oldHeight) => Math.max(20, oldHeight - 10));
    }, []);

    const larger = useCallback(() => {
      setVerticalPercent((oldHeight) => oldHeight + 10);
    }, []);

    const increaseFont = useCallback(() => {
      if (fontSize === "small") {
        setFontSize("medium");
      } else if (fontSize === "medium") {
        setFontSize("large");
      }
    }, [fontSize]);

    const decreaseFont = useCallback(() => {
      if (fontSize === "large") {
        setFontSize("medium");
      } else if (fontSize === "medium") {
        setFontSize("small");
      }
    }, [fontSize]);

    useEffect(() => {
      let newTheme: string;
      if (mode === "light") {
        newTheme = "ag-theme-alpine";
      } else {
        newTheme = "ag-theme-alpine-dark";
      }
      setTheme(newTheme);
    }, [mode]);

    function regexCheck(str: string, number: string): boolean {
      const escapeRegex = (s: string): string =>
        s.replace(/([.+^=!:${}()|\\])/g, "\\$1");

      const temp = "^".concat(
        number.split("*").map(escapeRegex).join(".*"),
        "$"
      );
      const r = new RegExp(temp.split("?").join("."));

      return r.test(str);
    }

    const callbackStateHandler = useCallback(
      (record: CallbackState) => {
        const call = callbackCalls.get(`${record.userId}-${record.callId}`);

        // discard out of order callback states
        if (call?.sequence !== undefined && call.sequence > record.sequence) {
          return;
        }

        const row = callbackCalls.get(`${record.userId}-${record.callId}`);
        callbackCalls.set(`${record.userId}-${record.callId}`, record);

        if (historicalState === undefined) {
          return;
        }
        // Do VIP logic here. Setting vip to yes/no and vipName to "" or vipName;
        const found = vipList.find((element) =>
          regexCheck(record.fromPhoneNumber as string, element.number)
        );

        setRowData((oldRowData) => {
          if (oldRowData === undefined) {
            return undefined;
          }
          const user = historicalState.users.get(record.userId);
          let queue = historicalState.queuesById.get(record.userId);

          if (queue === undefined && record.callback) {
            // just grabbing the first callback queue for now, problem for another day to have multiple
            queue = historicalState.queuesById.get(record.callback[0]);
          }

          if (row === undefined) {
            return [
              ...oldRowData,
              {
                ...record,
                vip: found ? "Yes" : "No",
                vipName: found?.name,
                name: `${user?.firstName || ""} ${user?.lastName || ""}`,
                extensionNumber: user?.extensionNumber || "",
                callerNumber: record.fromPhoneNumber,
                queueName: queue?.name || "",
                calleeNumber: record.toPhoneNumber,
                time: new Date(record.index),
                queueId: queue?.id,
              },
            ];
          }

          return [...oldRowData].map((oldRow) => {
            if (oldRow.userId !== row.userId || oldRow.callId !== row.callId) {
              return oldRow;
            }

            // merge (and update if necessary)
            // (looks like merging was insufficient here)
            return {
              ...oldRow,
              ...row,
              ...record,
              vip: found ? "Yes" : "No",
              vipName: found?.name,
              name: `${user?.firstName || ""} ${user?.lastName || ""}`,
              extensionNumber: user?.extensionNumber || "",
              callerNumber: record.fromPhoneNumber,
              queueName: queue?.name || "",
              calleeNumber: record.toPhoneNumber,
              time: new Date(record.index),
              queueId: queue?.id,
            };
          });
        });
      },
      [historicalState]
    );

    useEffect(() => {
      const data = historicals[0];
      if (data === undefined) {
        return;
      }

      setHistoricalState(() => {
        const users = new Map();

        data.user.forEach((user) => {
          users.set(user.id, {
            id: user.id,
            lastName: user.lastName,
            firstName: user.firstName,
            extensionNumber: user.extensionNumber,
          });
        });

        const queues = new Map();
        const queuesById = new Map();

        data.queue.forEach((queue) => {
          // arbitrarily overwrite queues with the same name
          queues.set(queue.name, queue);
          queuesById.set(queue.id, queue);
        }, []);

        return {
          users,
          queues,
          queuesById,
        };
      });
    }, [historicals]);

    // useEffect(() => {
    //   if (organizationId === "3154756020") {
    //     if (excludedQueues && excludedQueues !== undefined) {
    //       console.log('excluded queues: ', excludedQueues)
    //     }
    //   }
    // }, [excludedQueues])

    useEffect(() => {
      // process one new real time call event
      const record = callbackStates[0];
      if (record === undefined) {
        return;
      }

      callbackStateHandler(record);
    }, [callbackStates, callbackStateHandler]);

    useEffect(() => {
      if (callbacks !== undefined) {
        callbacks?.forEach(callbackStateHandler);
        setTranscriptTimeout(0); // immediate grab these transcripts
      }
    }, [callbacks, callbackStateHandler]);

    useEffect(() => {
      if (historicalState === undefined) {
        return;
      }
      setRowData(
        Array.from(callbackCalls.values()).map((myRecord) => {
          const user = historicalState.users.get(myRecord.userId);
          let queue = historicalState.queuesById.get(myRecord.userId);
          const found = vipList.find((element) =>
            regexCheck(myRecord.fromPhoneNumber as string, element.number)
          );

          if (queue === undefined && myRecord.callback) {
            // just grabbing the first callback queue for now, problem for another day to have multiple
            queue = historicalState.queuesById.get(myRecord.callback[0]);
          }
          return {
            ...myRecord,
            vip: found ? "Yes" : "No",
            vipName: found?.name,
            name: `${user?.firstName || ""} ${user?.lastName || ""}`,
            extensionNumber: user?.extensionNumber || "",
            callerNumber: myRecord.fromPhoneNumber,
            queueName: queue?.name || "",
            calleeNumber: myRecord.toPhoneNumber,
            time: new Date(myRecord.index),
            queueId: queue?.id,
          };
        })
      );
    }, [callbackStateHandler, historicalState]);

    const now = new Date();

    useEffect(() => {
      if (page === "hud" && hudTab === "queues") {
        if (tab === "abandoned") {
          setActiveFilterRef(abandonedGridRef);
        }
        if (tab === "voicemail") {
          setActiveFilterRef(voicemailGridRef);
        }
        if (tab === "callback") {
          setActiveFilterRef(callbackGridRef);
        }
      }
    }, [
      abandonedGridRef,
      callbackGridRef,
      voicemailGridRef,
      tab,
      hudTab,
      page,
    ]);
    return (
      <ThemeProvider theme={mode === "dark" ? darkTheme : myTheme}>
        <div className={theme}>
          <div style={tab === "summary" ? {} : { display: "none" }}>
            <DateRangeSummary
              orgId={organizationId}
              historicals={historicals}
              // callEvents={callEvents}
              leaderboardDeltas={leaderboardDeltas}
              queueCallStates={queueCallStates}
              presenceEvents={presenceEvents}
              queuePresenceEvents={queuePresenceEvents}
              summaries={summaries}
              excludedQueues={excludedQueues}
              getSummary={getSummary}
              verticalPercent={verticalPercent}
              mode={mode}
              expandLeaderboard={expandQLeaderboard}
              setExpandLeaderboard={setExpandQLeaderboard}
              smaller={smaller}
              larger={larger}
              fontSize={fontSize}
              increaseFont={increaseFont}
              decreaseFont={decreaseFont}
              leaderboardUrl={leaderboardUrl}
              updateLocal={updateLocal}
              local={local}
              page={page}
              hudTab={hudTab}
              offset={offset}
              navTab={navTab}
              navPage={navPage}
              setActiveFilterRef={setActiveFilterRef}
              queueSelectedTab={tab}
            />
          </div>
          {agentLeaderboard && (
            <div style={tab === "agent" ? {} : { display: "none" }}>
              <AgentLeaderboard
                agentData={agentData}
                mode={mode}
                verticalPercent={verticalPercent}
                smaller={smaller}
                larger={larger}
                fontSize={fontSize}
                increaseFont={increaseFont}
                decreaseFont={decreaseFont}
                expandLeaderboard={expandQLeaderboard}
                setExpandLeaderboard={setExpandQLeaderboard}
                historicals={historicals}
                summaries={summaries}
                leaderboardDeltas={leaderboardDeltas}
                excludedQueues={excludedQueues}
                //   excludedUsers={excludedUsers}
                presenceEvents={presenceEvents}
                queuePresenceEvents={queuePresenceEvents}
                local={local}
                updateLocal={updateLocal}
                showAvailable={showAvailable}
                showBusy={showBusy}
                showDnd={showDnd}
                showInvisible={showInvisible}
                queueSelectedTab={tab}
                page={page}
                hudTab={hudTab}
                offset={offset}
                navTab={navTab}
                navPage={navPage}
                setActiveFilterRef={setActiveFilterRef}
              />
            </div>
          )}
          <div style={tab === "waiting" ? {} : { display: "none" }}>
            <QueueWaiting
              historicals={historicals}
              // callEvents={callEvents}
              queueCallStates={queueCallStates}
              expandLeaderboard={expandQLeaderboard}
              excludedQueues={excludedQueues}
              setExpandLeaderboard={setExpandQLeaderboard}
              smaller={smaller}
              larger={larger}
              mode={mode}
              verticalPercent={verticalPercent}
              fontSize={fontSize}
              increaseFont={increaseFont}
              decreaseFont={decreaseFont}
              updateLocal={updateLocal}
              local={local}
              page={page}
              hudTab={hudTab}
              offset={offset}
              navTab={navTab}
              navPage={navPage}
              deviceId={deviceId}
              rcAccessToken={rcAccessToken}
              queueCallPickUp={queueCallPickUp}
              summaries={summaries}
              showCherryPick={showCherryPick}
              spoiledCherryPickCalls={spoiledCherryPickCalls}
              setSpoiledCherryPickCalls={setSpoiledCherryPickCalls}
              vipList={vipList}
              showVip={showVip}
              user={selfUser}
              queueWaitingCount={queueWaitingCount}
              setQueueWaitingCount={setQueueWaitingCount}
              organizationId={organizationId}
              setActiveFilterRef={setActiveFilterRef}
              queueSelectedTab={tab}
            />
          </div>
          <div style={tab === "inProgress" ? {} : { display: "none" }}>
            <QueueInProgress
              historicals={historicals}
              queueCallStates={queueCallStates}
              expandLeaderboard={expandQLeaderboard}
              excludedQueues={excludedQueues}
              setExpandLeaderboard={setExpandQLeaderboard}
              smaller={smaller}
              larger={larger}
              mode={mode}
              verticalPercent={verticalPercent}
              fontSize={fontSize}
              increaseFont={increaseFont}
              decreaseFont={decreaseFont}
              updateLocal={updateLocal}
              local={local}
              page={page}
              hudTab={hudTab}
              offset={offset}
              navTab={navTab}
              navPage={navPage}
              summaries={summaries}
              vipList={vipList}
              showVip={showVip}
              setInProgressCount={setInProgressCount}
              setActiveFilterRef={setActiveFilterRef}
              queueSelectedTab={tab}
            />
          </div>
          <div
            style={
              tab === "callback" && showCallback ? {} : { display: "none" }
            }
          >
            <QueueCallback
              leaderboardUrl={leaderboardUrl as string}
              newCallback={newCallback}
              historicals={historicals}
              callbackStates={callbackStates}
              expandLeaderboard={expandQLeaderboard}
              setExpandLeaderboard={setExpandQLeaderboard}
              smaller={smaller}
              larger={larger}
              mode={mode}
              verticalPercent={verticalPercent}
              fontSize={fontSize}
              increaseFont={increaseFont}
              decreaseFont={decreaseFont}
              updateLocal={updateLocal}
              vipList={vipList}
              showVip={showVip}
              callbacks={callbacks}
              accessToken={accessToken}
              forwardAddress={forwardAddress}
              origin={origin}
              excludedQueues={excludedQueues}
              rcId={rcId}
              organizationId={organizationId}
              page={page}
              hudTab={hudTab}
              offset={offset}
              navTab={navTab}
              navPage={navPage}
              markedAsCalledBack={markedAsCalledBack}
              showCallback={showCallback}
              filter="Callback"
              rowData={rowData}
              setRowData={setRowData}
              historicalState={historicalState}
              local={local}
              transcriptTimeout={transcriptTimeout}
              setTranscriptTimeout={setTranscriptTimeout}
              apiUrl={apiUrl}
              deletedVMs={deletedVMs}
              setActiveFilterRef={setActiveFilterRef}
              queueSelectedTab={tab}
              setGridRef={setCallbackGridRef}
            />
          </div>
          <div style={tab === "abandoned" ? {} : { display: "none" }}>
            <QueueCallback
              leaderboardUrl={leaderboardUrl as string}
              newCallback={newCallback}
              historicals={historicals}
              callbackStates={callbackStates}
              expandLeaderboard={expandQLeaderboard}
              setExpandLeaderboard={setExpandQLeaderboard}
              smaller={smaller}
              larger={larger}
              mode={mode}
              verticalPercent={verticalPercent}
              fontSize={fontSize}
              increaseFont={increaseFont}
              decreaseFont={decreaseFont}
              updateLocal={updateLocal}
              vipList={vipList}
              showVip={showVip}
              callbacks={callbacks}
              accessToken={accessToken}
              forwardAddress={forwardAddress}
              origin={origin}
              excludedQueues={excludedQueues}
              rcId={rcId}
              organizationId={organizationId}
              page={page}
              hudTab={hudTab}
              offset={offset}
              navTab={navTab}
              navPage={navPage}
              markedAsCalledBack={markedAsCalledBack}
              showCallback={showCallback || true}
              filter="Abandoned"
              rowData={rowData}
              setRowData={setRowData}
              historicalState={historicalState}
              local={local}
              transcriptTimeout={transcriptTimeout}
              setTranscriptTimeout={setTranscriptTimeout}
              apiUrl={apiUrl}
              deletedVMs={deletedVMs}
              setActiveFilterRef={setActiveFilterRef}
              queueSelectedTab={tab}
              setGridRef={setAbandonedGridRef}
            />
          </div>
          <div style={tab === "voicemail" ? {} : { display: "none" }}>
            <QueueCallback
              leaderboardUrl={leaderboardUrl as string}
              newCallback={newCallback}
              historicals={historicals}
              callbackStates={callbackStates}
              expandLeaderboard={expandQLeaderboard}
              setExpandLeaderboard={setExpandQLeaderboard}
              smaller={smaller}
              larger={larger}
              mode={mode}
              verticalPercent={verticalPercent}
              fontSize={fontSize}
              increaseFont={increaseFont}
              decreaseFont={decreaseFont}
              updateLocal={updateLocal}
              vipList={vipList}
              showVip={showVip}
              callbacks={callbacks}
              accessToken={accessToken}
              forwardAddress={forwardAddress}
              origin={origin}
              excludedQueues={excludedQueues}
              rcId={rcId}
              organizationId={organizationId}
              page={page}
              hudTab={hudTab}
              offset={offset}
              navTab={navTab}
              navPage={navPage}
              markedAsCalledBack={markedAsCalledBack}
              showCallback={showCallback || true}
              filter="Voicemail"
              rowData={rowData}
              setRowData={setRowData}
              historicalState={historicalState}
              local={local}
              transcriptTimeout={transcriptTimeout}
              setTranscriptTimeout={setTranscriptTimeout}
              apiUrl={apiUrl}
              deletedVMs={deletedVMs}
              setActiveFilterRef={setActiveFilterRef}
              queueSelectedTab={tab}
              setGridRef={setVoicemailGridRef}
            />
          </div>
          {expandQLeaderboard && (
            <Toolbar
              disableGutters
              variant="dense"
              style={{
                minHeight: "43px",
                backgroundColor: mode === "dark" ? "#181818" : "#0684bd",
                borderRadius: "0px 0px 5px 5px",
                border: mode === "dark" ? "1px solid #616161d9" : " ",
                borderTop: "0px",
                overflow: "hidden",
              }}
            >
              <Button
                style={
                  tab === "summary"
                    ? {
                        color: mode === "light" ? "white" : "#D3D3D3",
                        backgroundColor:
                          mode === "light" ? "rgb(44 164 219)" : "#282b2e",
                        borderRadius: "0px 0px 0px 5px",
                        marginLeft: 3,
                      }
                    : { marginLeft: 3 }
                }
                className={classes.tab}
                onClick={() => setTab("summary")}
              >
                Summary
              </Button>
              {agentLeaderboard && (
                <div className="inv-container" style={{ position: "relative" }}>
                  <Button
                    style={
                      tab === "agent"
                        ? {
                            color: mode === "light" ? "white" : "#D3D3D3",
                            backgroundColor:
                              mode === "light" ? "rgb(44 164 219)" : "#282b2e",
                            borderRadius: "0px 0px 0px 0px",
                          }
                        : {}
                    }
                    className={classes.tab}
                    onClick={() => setTab("agent")}
                  >
                    Agent
                  </Button>
                </div>
              )}
              <div className="inv-container" style={{ position: "relative" }}>
                <Button
                  style={
                    tab === "waiting"
                      ? {
                          color: mode === "light" ? "white" : "#D3D3D3",
                          backgroundColor:
                            mode === "light" ? "rgb(44 164 219)" : "#282b2e",
                          borderRadius: "0px 0px 0px 0px",
                        }
                      : {}
                  }
                  className={classes.tab}
                  onClick={() => setTab("waiting")}
                >
                  Waiting
                </Button>
                {queueWaitingCount > 0 && (
                  <div className="notif-style">{queueWaitingCount}</div>
                )}
              </div>
              <div className="inv-container" style={{ position: "relative" }}>
                <Button
                  style={
                    tab === "inProgress"
                      ? {
                          color: mode === "light" ? "white" : "#D3D3D3",
                          backgroundColor:
                            mode === "light" ? "rgb(44 164 219)" : "#282b2e",
                          borderRadius: "0px 0px 0px 0px",
                        }
                      : {}
                  }
                  className={classes.tab}
                  onClick={() => setTab("inProgress")}
                >
                  In Progress
                </Button>
                {inProgressCount > 0 && (
                  <div className="notif-style">{inProgressCount}</div>
                )}
              </div>
              <div
                className="inv-container"
                style={{
                  position: "relative",
                }}
              >
                <Button
                  style={
                    tab === "abandoned"
                      ? {
                          color: mode === "light" ? "white" : "#D3D3D3",
                          backgroundColor:
                            mode === "light" ? "rgb(44 164 219)" : "#282b2e",
                          borderRadius: "0px 0px 0px 0px",
                        }
                      : {}
                  }
                  className={classes.tab}
                  onClick={() => {
                    localStorage.setItem("abandonedTimestamp", now.toString());
                    setTab("abandoned");
                  }}
                >
                  Abandoned
                </Button>
                {tabCounts.abandoned > 0 && (
                  <div className="notif-style">{tabCounts.abandoned}</div>
                )}
              </div>
              <div className="inv-container" style={{ position: "relative" }}>
                <Button
                  style={
                    tab === "voicemail"
                      ? {
                          color: mode === "light" ? "white" : "#D3D3D3",
                          backgroundColor:
                            mode === "light" ? "rgb(44 164 219)" : "#282b2e",
                          borderRadius: "0px 0px 0px 0px",
                        }
                      : {}
                  }
                  className={classes.tab}
                  onClick={() => {
                    localStorage.setItem("voicemailTimestamp", now.toString());
                    setTab("voicemail");
                  }}
                >
                  Voicemail
                </Button>
                {tabCounts.voicemail > 0 && (
                  <div className="notif-style">{tabCounts.voicemail}</div>
                )}
              </div>

              {showCallback && (
                <div className="inv-container" style={{ position: "relative" }}>
                  <Button
                    style={
                      tab === "callback"
                        ? {
                            color: mode === "light" ? "white" : "#D3D3D3",
                            backgroundColor:
                              mode === "light" ? "rgb(44 164 219)" : "#282b2e",
                            borderRadius: "0px 0px 5px 0px",
                          }
                        : {}
                    }
                    className={classes.tab}
                    onClick={() => {
                      localStorage.setItem("callbackTimestamp", now.toString());
                      setTab("callback");
                    }}
                  >
                    Callback
                  </Button>
                  {tabCounts.callback > 0 && (
                    <div className="notif-style">{tabCounts.callback}</div>
                  )}
                </div>
              )}
            </Toolbar>
          )}
        </div>
      </ThemeProvider>
    );
  }
);

export default Queues;
export type {
  UserPresenceEvent,
  QueuePresenceEvent,
  Historical,
  CallEvent,
  Summary,
  Delta,
  QueueCallState,
  CallbackState,
  UserState,
  CallUser,
};
